<template>
  <Loader v-if="loading"/>
  <ContractPreviewDialog ref="contractPreviewDialog" v-model:visible="contractPreviewVisible" :documents="contractPreviewDocuments" :matrice-id="previewMatriceId" :desktop="windowSize >= 1200" :can-sign="true" @signed="refreshPreviewSignature" @draft="getData(false)" @edit="goToUpdateContract" @download="downloadPreviewContract" />
  <h4>Caricamenti</h4><br/>

  <div v-if="loaded">
    <div v-if="contatori.length">
      <div class="counter grid">
        <div class="col-12 sm:col-6 xl:col-3" v-for="item in contatori" :key="item.title">
          <div class="card" style="padding: 12px 20px;">
            <h4>{{item.title}}</h4>
            <div class="flex flex-wrap justify-content-between mb-2">
              <div class="col-12 sm:col-4">
                <span class="block text-500 font-medium mb-3">Totale</span>
                <div class="text-900 font-medium text-xl">{{item.totale}}</div>
              </div>
              <div class="col-12 sm:col-4">
                <span class="block text-500 font-medium mb-3">Firmati</span>
                <div class="text-900 font-medium text-xl">{{item.firmati}}</div>
              </div>
              <div class="col-12 sm:col-4">
                <span class="block text-500 font-medium mb-3">Non firmati</span>
                <div class="text-900 font-medium text-xl">{{item.non_firmati}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="field card">
      <Skeleton class="mb-2"></Skeleton>
      <Skeleton width="10rem" class="mb-2"></Skeleton>
      <Skeleton width="5rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton width="10rem" height="4rem"></Skeleton>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <div class="card" style="padding: 12px 20px;">
        <i @click="removeFilters" class="btn-remove-selected p-error pi pi-times removeFilter" style="font-size: 1.2rem" v-tooltip="'Ripristina filtri'"></i>
        <i class="ml-2 pi pi-refresh btn-remove-selected removeFilter" v-tooltip="`Aggiorna`" @click="initData()" style="font-size: 1.2rem"></i>
        <div class="grid m-0">
          <div class="col-12 md:col-6 xl:col-4" style="max-height: 90px;">
            <div class="col-12">Filtra per id caricamento (separa gli con la virgola. Esempio: 111,112,113)</div>
            <div class="mb-0">
              <!-- <InputNumber style="height: 45px" class="w-full" v-model="selectedIdMatrice" inputId="withoutgrouping" :useGrouping="false" @update:modelValue="changeIdMatrice($event)"/> -->
              <InputText type="text" style="height: 45px" class="w-full" v-model="selectedIdMatrice" @blur="changeIdMatrice($event.target.value)" @keydown.enter="changeIdMatrice($event.target.value)"/>
            </div>
          </div>

          <div class="col-12 md:col-6 xl:col-4" style="max-height: 90px;">
            <div class="col-12">Filtra per punto di prelievo (separa gli con la virgola)</div>
            <div class="mb-0">
              <InputText type="text" style="height: 45px" class="w-full" v-model="selectedPuntiPrelievo" @blur="changePuntiPrelievo($event.target.value)" @keydown.enter="changePuntiPrelievo($event.target.value)"/>
            </div>
          </div>

          <div class="col-12 md:col-6 xl:col-4" style="max-height: 90px;">
            <div class="col-12">Filtra per cliente/rappresentante, CF o P.IVA cliente</div>
            <div class="mb-0">
              <InputText type="text" style="height: 45px" class="w-full" v-model="selectedClienteRappresentante" @blur="changeClienteRappresentante($event.target.value)" @keydown.enter="changeClienteRappresentante($event.target.value)"/>
            </div>
          </div>

          <div class="col-12 md:col-6 xl:col-4" style="max-height: 90px;">
            <div class="col-12">Filtra per stato caricamento</div>
            <div class="mb-0 flex justify-content-between">
              <MultiSelect v-model="selectedStatus" placeholder="Seleziona stati" optionLabel="name" :options="stati" class="col-12 w-full" @change="onSelectedStatus" @hide="onSelectedStatusHide" display="chip" :maxSelectedLabels="3" selectedItemsLabel="{0} stati selezionati" style="min-height: 45px">
                <template #option="slotProps">
                  <Tag :value="slotProps.option.name" :severity="getSeverityTag(slotProps.option.id)"/>
                </template>
              </MultiSelect>
            </div>
          </div>
          <div class="col-12 md:col-6 xl:col-4" style="max-height: 90px;">
            <div class="col-12">Filtra per data caricamento</div>
            <div class="mb-0 flex justify-content-center">
              <Calendar ref="calendarRef" v-model="selectedDate" @today-click="onTodayClick('data_caricamento')" :maxDate="maxDate" selectionMode="range" :manualInput="false" @update:modelValue="onChangeDate('data_caricamento')" dateFormat="dd/mm/yy" class="w-full" style="height: 45px" showButtonBar/>
            </div>
          </div>
          <div class="col-12 md:col-6 xl:col-4" style="max-height: 90px;">
            <div class="col-12">Filtra per data firma</div>
            <div class="mb-0 flex justify-content-center">
              <Calendar ref="calendarRefSign" v-model="selectedSignDate" @today-click="onTodayClick('data_firma')" :maxDate="maxDate" selectionMode="range" :manualInput="false" @update:modelValue="onChangeDate('data_firma')" dateFormat="dd/mm/yy" class="w-full" style="height: 45px" showButtonBar/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <Button v-if="loaded_caricamenti_pk_ko" class="mb-3 p-button-warning w-full" label="Vedi le pratiche da gestire" @click="filterCaricamenti()"/>
  
  <div v-if="loaded">
    <div class="card caricamenti-multisito" v-if="items && items.length > 0">
      <p class="text-sm text-600 flex align-items-center gap-2 mb-3">
        <i class="pi pi-info-circle" aria-hidden="true"></i> 
        <span>Per vedere i dettagli e i documenti associati al singolo caricamento, apri con la freccia a sinistra.</span>
      </p>
      <DataTable :value="items" v-model:selection="selectedItems" sortField="id" dataKey="id" :sortOrder="-1" v-model:filters="filters" filterDisplay="row" :globalFilterFields="['agenteIncaricato','agente', 'agenteMaster', 'id', 'rappresentante', 'cliente', 'cf_piva_clienti', 'pps']" paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" breakpoint="1400px" v-model:expandedRows="expandedRows" @rowExpand="onRowExpand">
        <template #header>
          <div class="flex justify-content-between gap-2 flex-wrap">
            <div class="flex gap-2 flex-wrap">
              <Button class="mr-2" icon="pi pi-external-link" label="Esportazione completa" @click="esportaCaricamenti($event)"/>
              <Button class="p-button-secondary" icon="pi pi-external-link" label="Esportazione semplice" @click="esportaCaricamenti($event, 'mini')"/>
            </div>
            <Button class="p-button-help" v-if="currentUser.role == roles.admin.role" icon="pi pi-external-link" label="Esporta Esiti Precheck" @click="esportaEsiti($event)" />
          </div>
        </template>
  
        <Column expander style="width: 3rem" />
        <Column field='id' header="#" :showFilterMenu="false" :filterMenuStyle="{ width: '2.5rem' }" style="width: 8%" :sortable="true">
          <template #body="{data}">
            <div class="flex align-items-center gap-2">
              <span>{{ data.id }}</span>
              <i
                v-if="isCaricamentoEreditato(data)"
                class="pi pi-info-circle text-blue-500 ml-2"
                style="font-size: 0.9rem"
                v-tooltip.top="`Ereditato dal caricamento #${data.origin_id}`"
              ></i>
            </div>
            <div class="mt-2 flex align-items-center">
              <i :class="`pi pi-circle-on ${getSeverity(data.cod_stato_caricamento)}`" style="font-size: 1rem"></i>
              <div class="m-2">{{ data.stato_caricamento }}</div>
            </div>
            <div v-if="currentUser.role == roles.admin.role">
              <Button v-if="[2,6].includes(data.cod_stato_caricamento)" v-tooltip="'Forza caricamento'" icon="pi pi-check" class="p-button-text p-button-success" @click="forzaCaricamento(data.id)"/>
              <Button v-if="[0].includes(data.cod_stato_caricamento)" v-tooltip="'Forza scissione PK'" icon="pi pi-check" class="ml-2 p-button-text p-button-success" @click="forzaScissionePk(data.id)"/>
            </div>
            <div v-if="currentUser.role == roles.admin.role" class="mt-3 flex flex-column align-items-start">
              <Button label="Vedi storico" icon="pi pi-search" class="p-button-rounded p-button-success p-button-sm w-9rem" @click="getStoricoCaricamentoById(data.id)"/>
              <Button v-if="currentUser.role == roles.admin.role && currentUser.profile.name == 'admin'" label="Vedi log" icon="pi pi-list" v-tooltip="'opzione IT'" class="mt-2 p-button-rounded p-button-outlined p-button-secondary p-button-sm w-9rem" @click="getLogCaricamentiMultisitoById(data.id)"/>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="ids" placeholder="Filtra id" class="p-column-filter" :showClear="true" filter optionLabel="key" optionValue="key"/>
          </template>
        </Column>
        <Column field="agenteIncaricato" header="Agente incaricato" :showFilterMenu="false" :filterMenuStyle="{ width: '10rem' }" style="min-width: 20%" >
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="incaricati" placeholder="Filtra agente" class="p-column-filter" :showClear="true" filter optionLabel="name" optionValue="name">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.name }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
  
        <Column v-if="currentUser.role == roles.admin.role" field="agenteMaster" header="Agente Master" :showFilterMenu="false" :filterMenuStyle="{ width: '10rem' }" style="min-width: 20%">
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="masters" placeholder="Filtra agente" class="p-column-filter" :showClear="true" filter optionLabel="name" optionValue="name">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.name }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column field="agente" header="Agente" :showFilterMenu="false" :filterMenuStyle="{ width: '10rem' }" style="min-width: 20%">
          <template #body="{data}">
            <div class="flex flex-wrap">
              <span :class="['col-12', {'flex justify-content-end':windowSize < 1400}]" v-if="data.admin_id != 0">
                {{data.admin}} <small>(admin)</small>
              </span>
              <span :class="['col-12', {'flex justify-content-end':windowSize < 1400}]" v-if="data.agente_id != 0">
                <Button v-if="currentUser.role == roles.admin.role" icon="pi pi-pencil" class="p-button-text p-0" v-tooltip="`Modifica agente firmatario`" @click="openDialogModificaAgenteFirmatario(data)" :label="data.agente"/>
                <p v-else>{{data.agente}}</p>
              </span>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="authors" placeholder="Filtra agente" class="p-column-filter" :showClear="true" filter optionLabel="name" optionValue="name">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.name }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante" style="min-width: 30%" :showFilterMenu="false" :filterMenuStyle="{ width: '6rem' }">
          <template #body="{data}">
            <div class="flex flex-wrap">
              <span :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">{{data.rappresentante ?? ''}}</span>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="rapps" placeholder="Filtra rappresentante" class="p-column-filter" :showClear="true" filter optionLabel="name" optionValue="name">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.name }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column field="cliente" header="Cliente" style="min-width: 40%" :showFilterMenu="false" :filterMenuStyle="{ width: '10rem' }">
          <template #body="{data}">
            <div class="flex flex-wrap">
              <div v-if="data.cliente.split(', ').length > 5" :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">{{data.cliente.split(', ').length}} clienti</div>
              <div v-else>
                <div v-for="(name,index) of data.cliente.split(', ')" :key="index" :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">{{ name }}</div>
              </div>
            </div> 
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="clients" placeholder="Filtra cliente" class="p-column-filter" :showClear="true" filter optionLabel="name" optionValue="name">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.name }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column field='cf_piva_clienti' header="CF/PIVA clienti" :sortable="true" style="width: 8%" :showFilterMenu="false" :filterMenuStyle="{ width: '14rem' }">
          <template #body="{data}">
            <div class="flex flex-wrap">
              <div v-if="data.cf_piva_clienti.split(', ').length > 5" :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">{{data.cf_piva_clienti.split(', ').length}} cf/piva</div>
              <div v-else>
                <div v-for="(cf_piva,index) of data.cf_piva_clienti.split(', ')" :key="index" :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">{{ cf_piva }}</div>
              </div>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="cf_piva" placeholder="Filtra cf o piva" class="p-column-filter" :showClear="true" filter optionLabel="key" optionValue="key">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.key }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column field='data_caricamento' header="Data Caricamento" :sortable="true" style="width: 8%">
          <template #body="{data}">
            {{moment(data.data_caricamento).format('DD-MM-YYYY HH:mm')}}
          </template>
        </Column>
        <Column field="is_complete" header="Firmato" dataType="boolean" style="width: 10%">
          <template #body="{ data }">
            <div class="flex flex-wrap align-items-center">
              <i class="pi" :class="{ 'pi-check-circle text-green-500': data.is_complete, 'pi-times-circle p-error': !data.is_complete }"></i>
              <div class="m-1">
                {{data.data_firma ? (!data.is_contratto_manuale ? moment(data.data_firma).format('DD-MM-YYYY HH:mm') : moment(data.data_firma).format('DD-MM-YYYY')) : ''}}
              </div>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()"/>
          </template>
        </Column>
        <Column field="need_pratiche" header="Filtra pratiche" dataType="boolean" style="width: 10%">
          <template #body="{data}">
            <Button v-if="data.need_pratiche && !data.data_ricezione_pratiche && ![8,13].includes(data.cod_stato_caricamento)" @click="insertDataForPratiche(data)" label="Completa Pratiche" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-warning btn-multisito"/>
            <!-- <div class="flex flex-wrap align-items-center">
              {{ data.need_pratiche ? 'Ci sono pratiche da gestire' : ''}}
            </div> -->
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" :binary="true"/>
          </template>
        </Column>
        <Column field='pps' header="Forniture" :sortable="true" style="width: 8%" :showFilterMenu="false" :filterMenuStyle="{ width: '14rem' }">
          <template #body="{data}">
            <div class="flex flex-wrap">
              <div v-if="data.pps.split(', ').length > 5" v-tooltip.top="data.pps" :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">
                <div v-for="(tipo_fornitura, index) of data.tipi_forniture.split(', ')" :key="index">{{ tipo_fornitura }}</div>
              </div>
              <div v-else>
                <div v-for="(pp,index) of data.pps.split(', ')" :key="index" :class="['col-12', {'flex justify-content-end':windowSize < 1400}]">{{ pp }}</div>
              </div>
            </div>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="forniture" placeholder="Filtra fornitura" class="p-column-filter" :showClear="true" filter optionLabel="key" optionValue="key">
              <template #option="slotProps">
                <div class="flex align-items-center">
                  {{ slotProps.option.key }}
                </div>
              </template>
            </Dropdown>
          </template>
        </Column>
        <Column header="" style="width: 180px;justify-content: start;">
          <template #body="{data}" style="font-size: 10px">
            <div class="grid div-buttons">
              <Button v-if="(currentUser.role == roles.admin.role || currentUser.can_update_matrice) && (data.cod_richiesta_firma == null || data.cod_status_pratica == 1) && ![8,13].includes(data.cod_stato_caricamento)" @click="detachAndUpdateContract(data)" :disabled="loading" label="Modifica contratto" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-sucess btn-multisito"/>

              <Button v-if="data.cod_stato_caricamento == 3" @click="insertMissingDocuments(data)" label="Carica documenti mancanti" type="button" icon="pi pi-file-pdf" iconPos="left" class="p-button-rounded p-button-info btn-multisito"/>
  
              <!-- <Button v-if="!data.is_complete && data.cod_status_pratica < 2 && data.cod_stato_caricamento != 8 && currentUser.role == roles.agent.role" @click="deleteUpdate(data)" label="Elimina caricamento" type="button" icon="pi pi-trash" iconPos="left" class="p-button-rounded p-button-danger btn-multisito" /> -->
  
              <Button v-if="canViewAnnullaContratto(data)" @click="setDataAnnullamento(data)" label="Annulla contratto" type="button" icon="pi pi-trash" iconPos="left" class="p-button-rounded p-button-danger btn-multisito" />
              
              <Button v-if="!data.is_complete && data.cod_stato_caricamento == 0 && !Number(data.has_contract_document)" @click="showPdf(data)" :label="windowSize >= 1200 ? 'Genera e visualizza contratto' : 'Genera e scarica contratto'" type="button" icon="pi pi-file-pdf" iconPos="left" class="p-button-rounded p-button-success btn-multisito" />
              
              <!-- <Button v-if="!data.is_complete_rapp && data.rappresentante_id != 0" @click="insertDataRapp(data)" label="Aggiorna Rappresentante" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-warning btn-multisito" /> -->

              <Button v-if="currentUser.role == roles.admin.role && (data.cod_status_pratica == null || [1, 2].includes(Number(data.cod_status_pratica))) && data.cod_stato_caricamento == 0" @click="insertSignedContract(data)" label="Carica documenti firmati" type="button" icon="pi pi-file-pdf" iconPos="left" class="p-button-rounded p-button-info btn-multisito"/>

              <Button v-if="data.data_ricezione_pratiche && !data.is_complete_pratiche && (data.cod_richiesta_firma != data.cod_richiesta_firma_pratiche) && [0,2,3,9].includes(data.cod_stato_caricamento)" @click="showPratiche(data.id)" :label="'Scarica Pratiche' + (data.cod_status_pratica_moduli == 3 ? ' firmate' : '')" type="button" icon="pi pi-file-pdf" iconPos="left" class="p-button-rounded p-button-danger btn-multisito"/>

              <Button v-if="data.is_complete && (data.cod_richiesta_firma != data.cod_richiesta_firma_pratiche) && data.cod_status_pratica_moduli == 1 && data.data_ricezione_pratiche && !data.is_contratto_manuale && ![1,8,13].includes(data.cod_stato_caricamento)" @click="signPratiche(data)" label="Richiedi Firma pratiche" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-primary btn-multisito"/>
              
              <span v-if="!data.is_complete && (data.cod_status_pratica == null || data.cod_status_pratica == 1) && data.cod_stato_caricamento == 0" v-tooltip.top="{ value: 'Genera il contratto per richiedere la firma', disabled: data.cod_status_pratica != null }">
                <Button :disabled="data.cod_status_pratica != 1" @click="signPdf(data, $event)" label="Richiedi Firma contratto" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-primary btn-multisito" />
              </span>

              <Button v-if="currentUser.profile.name == 'admin' && data.need_pratiche > 0 && data.cod_stato_caricamento == 0" @click="aggiornamentoOnCondition(data.id)" label="Richiedi aggiornamento on condition" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-warning btn-multisito" />

              <div class="col-12" style="margin-left: -0.5rem;">
                <div v-if="data.cod_status_pratica == 2" class="nota">
                  <strong>Richiesta firma contratto già inviata</strong>
                </div>
                <div v-if="data.cod_status_pratica == 3" class="nota">
                  <strong>Contratto Firmato</strong>
                </div>
                <div v-if="data.cod_status_pratica_moduli == 2" class="nota">
                  <strong>Richiesta firma moduli già inviata</strong>
                </div>
                <div v-if="data.cod_status_pratica_moduli == 3" class="nota">
                  <strong>Moduli Firmati</strong>
                </div>
              </div>
            </div>
          </template>
        </Column> 
        <template #expansion="slotProps">
          <div v-if="!loadingFilename" class="grid">
            <div class="col-12 flex" v-if="(currentUser.role == roles.admin.role || currentUser.can_view_otp_sign_link) && !slotProps.data.is_contratto_manuale && ((!slotProps.data.is_complete && slotProps.data.cod_richiesta_firma) || (!slotProps.data.is_complete_pratiche && slotProps.data.cod_richiesta_firma_pratiche))">
              <Button @click="toggle($event, 'link')" label="Condividi il link di firma" type="button" icon="pi pi-external-link" iconPos="left" class="p-button-raised m-2 p-button-secondary p-button-outlined"/>
              <OverlayPanel ref="op" class="overlayDocs">
                <div class="inline-flex align-items-center justify-content-center mt-3">
                  <h3>
                    Condividi il link della firma
                  </h3>
                </div>
                
                <p class="p-text-secondary block mb-5">
                  <strong>Questo link è personale. Assicuratevi che siano consapevoli del fatto che non devono condividere il loro link con nessuno.</strong>
                  In ogni caso, devono inserire il loro indirizzo e-mail per sbloccare l'accesso, che sarà protetto dopo 48h (potranno generare un nuovo link).
                </p>
                
                <div v-for="link in links[slotProps.data.id]" :key="link.name" :header="link.name" class="mb-3">
                  <label><strong>{{ link.name.toUpperCase() }}</strong></label>
                  <br>
                  <div class="flex justify-content-between">
                    <InputText class="w-full" v-model="link.link" disabled/>
                    <Button @click="copyLink(link.link)" v-tooltip="`Copia il link negli appunti`" type="button" icon="pi pi-clone" class="m-2 p-button-raised m-2 p-button-secondary p-button-outlined" :disabled="link.link.startsWith('CONTRATTO')"/>
                  </div>
                </div>
              </OverlayPanel>
  
              <!-- Bottone modifica dati richiesta firma-->
              <Button v-if="currentUser.role == roles.admin.role" @click="toggle($event, 'modifiche')" label="Modifica dati firmatario" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-raised m-2 p-button-warning"/>
              <OverlayPanel ref="op_modifiche" @hide="hideOverlay" class="overlayDocs">
                <i v-if="!sign_data[slotProps.data.id]" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                <div v-else>
                  <div class="inline-flex align-items-center justify-content-center mt-3">
                    <h4>
                      Modifica i dati del firmatario
                    </h4>
                  </div>
    
                  <div class="flex justify-content-between">
                    <div class="col-6">
                      <label><strong>Email</strong></label>
                      <InputText class="w-full" v-model="sign_data_copy[slotProps.data.id].email" @input="setChangedSignData(slotProps.data.id)" @change="setChangedSignData(slotProps.data.id)"/>
                    </div>
                    <div class="col-6">
                      <label><strong>Contatto</strong></label>
                      <InputMask mask="999-999999?9" class="w-full" v-model="sign_data_copy[slotProps.data.id].contatto" @input="setChangedSignData(slotProps.data.id)" @change="setChangedSignData(slotProps.data.id)"/>
                    </div>
                  </div>
                  <div class="flex justify-content-center mt-3">
                    <Button :disabled="changed_sign_data[slotProps.data.id]" @click="sendSignData(slotProps.data.id)" label="Salva" type="button" class="m-2 p-button-success" style="width: fit-content;"/>
                  </div>
                </div>
              </OverlayPanel>
            </div>
  
            <div class="col-12 flex" v-if="currentUser.role == roles.agent.role && !slotProps.data.is_contratto_manuale && ((!slotProps.data.is_complete && slotProps.data.cod_richiesta_firma) || (!slotProps.data.is_complete_pratiche && slotProps.data.cod_richiesta_firma_pratiche))">
              <!-- Bottone richiesta modifica dati richiesta firma-->
              <Button @click="toggle($event, 'richiesta_modifiche')" label="Richiedi modifica dati firmatario" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-raised m-2 p-button-warning"/>
              <OverlayPanel ref="op_richiesta_modifiche" @hide="hideOverlay" class="overlayDocs">
                <i v-if="!sign_data[slotProps.data.id]" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                <div v-else>
                  <div class="inline-flex align-items-center justify-content-center mt-3">
                    <h4>
                      Modifica i dati del firmatario
                    </h4>
                  </div>
    
                  <div class="flex justify-content-between">
                    <div class="col-6">
                      <label><strong>Email</strong></label>
                      <InputText class="w-full" v-model="sign_data_copy[slotProps.data.id].email" @input="setChangedSignData(slotProps.data.id)" @change="setChangedSignData(slotProps.data.id)"/>
                    </div>
                    <div class="col-6">
                      <label><strong>Contatto</strong></label>
                      <InputMask mask="999-999999?9" class="w-full" v-model="sign_data_copy[slotProps.data.id].contatto" @input="setChangedSignData(slotProps.data.id)" @change="setChangedSignData(slotProps.data.id)"/>
                    </div>
                  </div>
                  <div class="flex justify-content-center mt-3">
                    <Button :disabled="changed_sign_data[slotProps.data.id]" @click="sendRequestSignData(slotProps.data.id)" label="Salva" type="button" class="m-2 p-button-success" style="width: fit-content;"/>
                  </div>
                </div>
              </OverlayPanel>
            </div>
  
            <!-- Dettaglio Contratto-->
            <div class="col-12">
              <Fieldset legend="Dettagli contratto">
                <div class="grid">
                  <div class="col-12 md:col-4 flex flex-column gap-2">
                    <div>
                      Contratto <strong>{{ typesClient.find(type => type.id == slotProps.data.cod_type_client).name }} {{ slotProps.data.is_iva_agevolata ? 'con iva agevolata' : '' }}</strong>
                    </div>
                    <div>
                      Tipologia firma: <strong>{{ slotProps.data.is_contratto_manuale ? 'Cartaceo' : 'Digitale' }} {{ slotProps.data.pratica ? ' con ' + slotProps.data.pratica : '' }}</strong>
                    </div>
                    <div v-if="!slotProps.data.is_contratto_manuale">
                      Stato firma: <strong>{{ getStatoFirmaContratto(slotProps.data) }}</strong>
                    </div>
                  </div>

                  <div class="col-12 md:col-4 flex flex-column gap-2">
                    <div class="flex align-items-center">
                      <span>Periodo di fatturazione: </span>
                      <div class="ml-2 w-8" v-if="(currentUser.role == roles.admin.role || currentUser.can_select_bimestrale) && [2,3].includes(slotProps.data.cod_type_client) && slotProps.data.cod_stato_caricamento != 8" >
                        <Dropdown v-model="slotProps.data.periodo_ft_contratto" :options="periodi" optionLabel="name" optionValue="name" placeholder="Seleziona periododi fatturazione" :disabled="!('periodo_ft_contratto' in inEdit)"/>
                        <Button class="ml-2 p-button-text p-button-success" :icon="('periodo_ft_contratto' in inEdit) ? 'pi pi-check' : 'pi pi-pencil'" v-tooltip="'Modifica Periodo di fatturazione'" @click="('periodo_ft_contratto' in inEdit) ? saveChanges('periodo_ft_contratto') : setChanges('periodo_ft_contratto', slotProps.data)"/>
                      </div>
                      <strong v-else class="ml-1">{{ slotProps.data.periodo_ft_contratto }}</strong>
                    </div>
                    <div v-if="slotProps.data.spedizione" class="flex align-items-center">
                      <span>Metodo di spedizione: </span>
                      <strong class="ml-1">{{ slotProps.data.spedizione }}</strong>
                    </div>
                    <div v-if="slotProps.data.codice_promo">
                      Codice promozionale utilizzato: <strong>"{{ slotProps.data.codice_promo }}"</strong> di <strong>{{ slotProps.data.cliente_promotore }}</strong>
                    </div>
                  </div>

                  <div class="col-12 md:col-4 flex flex-column gap-2">
                    <div v-if="slotProps.data.data_validazione">
                      Caricamento validato il: <strong>{{ moment(slotProps.data.data_validazione).format("DD/MM/YYYY") }} alle ore {{ moment(slotProps.data.data_validazione).format("HH:mm") }}</strong>
                    </div>
                    <div v-if="hasSwitchDates(slotProps.data)" class="switch-date-details">
                      <div v-if="getSwitchDateSource(slotProps.data).is_selected">
                        {{ getSwitchDateTitle(slotProps.data) }} selezionata da <strong>{{ getSwitchDateSource(slotProps.data).author }}</strong>
                        <small v-if="getSwitchDateSource(slotProps.data).is_admin"> (admin)</small>
                      </div>
                      <div v-else>
                        {{ getSwitchDateTitle(slotProps.data) }} calcolata dal sistema
                      </div>
                      <div v-for="row in getSwitchDateRows(slotProps.data)" :key="row.label">
                        {{ row.label }}: <strong>{{ row.value }}</strong>
                      </div>
                      <div v-if="slotProps.data.switch_dates_log" class="switch-date-log mt-1">
                        <div>
                          Ultimo aggiornamento {{ getSwitchDateTitle(slotProps.data).toLowerCase() }}: <strong>{{ formatDate(slotProps.data.switch_dates_log.data_inserimento) }}</strong>
                        </div>
                        <div v-for="change in slotProps.data.switch_dates_log.switch_changes" :key="`${slotProps.data.switch_dates_log.id}-${change.field}`">
                          {{ change.label }}:
                          <strong>{{ formatSwitchLogValue(change, change.from) }}</strong>
                          <span> -> </span>
                          <strong>{{ formatSwitchLogValue(change, change.to) }}</strong>
                          <span v-if="canShowSwitchLogOrigin(change)" class="ml-1">({{ change.origin_label }})</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fieldset>
            </div>
  
            <!-- Note -->
            <div class="col-12" v-if="slotProps.data.note">
              <Fieldset legend="Note">
                {{ slotProps.data.note }}
              </Fieldset>
            </div>
  
            <!-- Dettaglio Rappresentante/Cliente-->
            <div class="col-12 md:col-6">
              <Fieldset legend="Rappresentante" v-if="slotProps.data.rappresentante_id">
                {{ slotProps.data.rappresentante }}               
                <br>
                {{ slotProps.data.codfis }}
                <br>
                {{slotProps.data.pec_rappresentante}}
              </Fieldset>
              <Fieldset legend="Cliente" v-else>
                {{ slotProps.data.cliente }}               
                <br>
                {{ slotProps.data.forniture.ee ? slotProps.data.forniture.ee[0].cf_cliente : slotProps.data.forniture.gas[0].cf_cliente }}
              </Fieldset>
            </div>
            <!-- Dettaglio Contatto-->
            <div class="col-12 md:col-6">
              <Fieldset legend="Contatto">
                <div class="w-full flex m-0">
                  <div>
                    {{ slotProps.data.contatto.toponimo }} {{ slotProps.data.contatto.indirizzo }} {{ slotProps.data.contatto.civico }}, {{ slotProps.data.contatto.cap }} - {{ slotProps.data.contatto.name }}
                    <br>
                    {{ slotProps.data.contatto.email }} - {{ slotProps.data.contatto.cell }}
                    <template v-if="slotProps.data.contatto.pec">
                      <br> {{ slotProps.data.contatto.pec }}
                    </template>
                  </div>
                  <Button v-if="slotProps.data.cod_stato_caricamento != 8" class="ml-2 p-button-text p-button-success" icon="pi pi-pencil" v-tooltip="'Modifica Contatto'" @click="setChanges('contatto', slotProps.data)"/>
                </div>
              </Fieldset>
            </div>
  
            <!-- Bottoni Documenti -->
            <div class="col-12">
              <Fieldset legend="Documenti">
                <span class="font-medium text-900 block mb-2">{{loadingFilename ? 'Download in corso...' : ''}}</span>
                <div v-if="loadingFilename == false">
                  <div class="flex flex-wrap" v-if="newFilesView[slotProps.data.id] != null && newFilesView[slotProps.data.id].length != 0 ">
                    <Button @click="downloadZip(slotProps.data.id)" label="Scarica tutti i file" type="button" icon="pi pi-file-pdf" iconPos="left" class="p-button-success m-2" v-tooltip.bottom="`Scarica`"/>
                    <Button v-for="file in newFilesView[slotProps.data.id]" :key="file.filename" @click="downloadPdf(slotProps.data.id, file.filename)" :label="file.filename" type="button" icon="pi pi-file-pdf" iconPos="left" class="p-button-info m-2" v-tooltip.bottom="`Scarica`"/>
                  </div>
                  <div v-else>
                    <span class="font-medium text-900 block mb-2">Non ci sono file da visualizzare</span>
                  </div>
                </div>
              </Fieldset>
            </div>
            
            <!-- Dettaglio Forniture-->
            <div class="col-12">
              <Fieldset legend="Forniture">
                <div v-if="slotProps.data.selectedPP.length > 0" class="card w-full flex align-tems-center">
                  <Button v-if="slotProps.data.selectedPP.length > 0 && slotProps.data.selectedPP.length < slotProps.data.count_pps" label="Elimina forniture selezionate" icon="pi pi-trash" class="p-button-danger m-1" @click="openDialogDeletePP(slotProps.data)"/>
                </div>
                <div class="col-12" v-if="slotProps.data.forniture.ee">
                  <h4>Elettrico</h4>
                  <DataTable :value="slotProps.data.forniture.ee" showGridlines :alwaysShowPaginator="false" paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]" sortField="cod_esito_precheck" :sortOrder="-1" :rowClass="rowClass">
                    <Column  field='status' header="Stato" style="width: 6rem;">
                      <template #body="{data}">
                        <div class="flex justify-content-around align-items-center w-full">
                          <Checkbox v-if="slotProps.data.count_pps > 1 && !slotProps.data.in_review_delete && (slotProps.data.cod_richiesta_firma == null || (currentUser.profile.name == 'admin' && data.caricato == 0))" v-model="data.selected" :binary="true" @update:modelValue="inSelectedRows(slotProps.data, data)"/>
                          <div>
                            <p class="p-0">{{ getCaricatoLabel(data.caricato) }}</p> <p class="p-0" v-if="data.data_stato">il {{ moment(data.data_stato).format("DD/MM/YYYY") }} alle ore {{ moment(data.data_stato).format("HH:mm") }}</p>
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Anagrafica" style="width: 13rem;">
                      <template #body="{data}">
                        <div><strong>{{data.denominazione_cliente}}</strong></div>
                        <div>
                          cf: {{data.cf_cliente}}
                        </div>
                        <div v-if="data.piva_cliente">
                          p. iva: {{data.piva_cliente }}
                        </div>
                      </template>
                    </Column>
                    <Column field="iban_contratto" header="IBAN" style="width: 15rem;">
                      <template #body="{data}">
                        <div>{{ data.iban_contratto }}</div>
                        <div class="flex">
                          <div v-if="!data.checked_data_iban_equal_to_client">
                            <strong>{{ data.intestazione_contratto }}</strong>
                            {{ data.cf_intestazione_contratto }}
                          </div>
                          <Button v-if="slotProps.data.cod_stato_caricamento != 8" class="ml-2 p-button-text p-button-success" icon="pi pi-pencil" v-tooltip="(data.iban_contratto ? 'Modifica' : 'Aggiungi') + ' iban'" @click="setChanges('iban_contratto', slotProps.data, true, data)"/>
                        </div>
                      </template>
                    </Column>
                    <Column header="POD e Indirizzo di fornitura" style="width: 15rem;">
                      <template #body="{data}">
                        <div>
                          <strong>{{ data.pod }}</strong> <span>({{data.tipologia_fornitura}})</span>
                        </div>
                        <InlineMessage v-if="data.active" severity="info">in fornitura</InlineMessage>
                        <div class="flex align-items-center">
                          <span v-if="data.toponimo_fornitura">{{data.toponimo_fornitura}} {{data.indirizzo_fornitura}} {{data.numero_civico_fornitura}}, {{data.cap_fornitura}} - {{data.citta_fornitura}}</span>
                          
                          <Button v-if="data.precheck != 1 && slotProps.data.cod_stato_caricamento != 8" class="ml-2 p-button-text p-button-success" icon="pi pi-pencil" v-tooltip="'Modifica indirizzo di fornitura'" @click="setChanges('indirizzo_fornitura', slotProps.data, true, data)"/>
                        </div>
                        <Button icon="pi pi-eye" v-tooltip="'Vedi prechecks'" class="p-button-white m-2" v-if="currentUser.role == roles.admin.role && data.prechecks.length > 0" @click="viewPrechecks(data.prechecks, data.pod, 'pod')"/>
                        <Button icon="pi pi-info-circle" v-tooltip="'Vedi informative voltura'" class="p-button-white m-2" v-if="currentUser.role == roles.admin.role && getInformativeVolturaList(data).length > 0" @click="viewInformativeVoltura(data, data.pod, 'pod')"/>
                        <Button icon="pi pi-book" v-tooltip="'Vedi modifiche (opzione IT)'" class="p-button-white m-2" v-if="currentUser.role == roles.admin.role && currentUser.profile.name == 'admin'" @click="viewModifiche('ee', data)"/>
                      </template>
                    </Column>
                    <Column header="Offerta" style="width: 13rem;">
                      <template #body="{data}">
                        <div class="flex flex-wrap align-items-center">
                          <Dropdown v-if="'cod_listino_contratto' in inEdit" v-model="data.cod_listino_contratto" :options="agente_offerta[slotProps.data.agente_id].ee" optionLabel="name" optionValue="id" placeholder="Seleziona offerta" :disabled="!('cod_listino_contratto' in inEdit)" filter/>
                          <div v-else><strong>{{ data.nome_offerta }}</strong></div>
                          <Button v-if="(currentUser.role == roles.admin.role || (currentUser.role == roles.agent.role && slotProps.data.is_contratto_manuale)) && data.caricato == 0 && slotProps.data.cod_stato_caricamento != 8" class="ml-3 p-button-text p-button-success" :icon="('cod_listino_contratto' in inEdit) ? 'pi pi-check' : 'pi pi-pencil'" v-tooltip="'Modifica offerta'" @click="('cod_listino_contratto' in inEdit) ? saveChanges('cod_listino_contratto', false, true, [data.id, 'ee']) : setChanges('cod_listino_contratto', slotProps.data, true, data)"/>
                        </div>
                      </template>
                    </Column>
                    <Column style="width: 20%;">
                      <template #body="{data}">
                        <div class="flex">
                          <label>Tipo pratica:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{ getTipoPraticaLabel(data) }}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="data.cf_attivazione || data.piva_attivazione">
                          <label>CF/PIVA precedente:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>
                              <span v-if="data.cf_attivazione">CF: {{ data.cf_attivazione }}</span>
                              <span v-if="data.cf_attivazione && data.piva_attivazione"> - </span>
                              <span v-if="data.piva_attivazione">PIVA: {{ data.piva_attivazione }}</span>
                            </strong>
                          </div>
                        </div>
                        <div class="flex" v-if="data.has_vt4">
                          <label>VT4:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>Si</strong>
                          </div>
                        </div>
                        <div class="flex">
                          <label>Esito precheck:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{getEsitoPrecheck(data)}}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="currentUser.role == roles.admin.role && [2,6].includes(data.cod_stato_caricamento)">
                          <label>Stato:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{getStatoSwitch(data)}}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="currentUser.role == roles.admin.role && [null, 3, 5].includes(data.cod_state_switch)">
                          <label>Esito TIMOE:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{getEsitoTimoeTimg(data, 'ee')}}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="[3,7].includes(data.cod_state_switch) || data.timoe_ok == 0">
                          <label>Note annullamento:</label>
                          <div class="ml-2 flex flex-column">
                            <div v-if="data.id_annullamento > 0">
                              <strong>{{ data.note_annullamento }}</strong>
                              <p v-if="currentUser.role == roles.admin.role && data.note && data.note !== data.note_annullamento" v-tooltip="'Questa nota è visibile solo agli admin'">{{data.note}}</p>
                            </div>
                            <div v-else-if="data.caricato == 2"><strong>{{ data.note }}</strong></div>
                            <div v-else-if="[3].includes(data.cod_state_switch)"><strong>{{ data.note_switch }}</strong></div>
                            <div v-if="data.timoe_ok == 0"><strong>TIMOE KO</strong></div>
                          </div>
                        </div>
                      </template>
                    </Column>
                    <!-- <template #groupfooter="slotProps">
                      <div class="flex justify-content-around w-full">{{ slotProps.data }}</div>
                    </template> -->
                  </DataTable>
                </div>
                <div class="col-12" v-if="slotProps.data.forniture.gas">
                  <h4>Gas</h4>
                  <DataTable :value="slotProps.data.forniture.gas" showGridlines :alwaysShowPaginator="false" paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]" sortField="cod_esito_precheck" :sortOrder="-1" :rowClass="rowClass">
                    <Column  field='status' header="Stato" style="width: 6rem;">
                      <template #body="{data}">
                        <div class="flex justify-content-around align-items-center w-full">
                          <Checkbox v-if="slotProps.data.count_pps > 1 && !slotProps.data.in_review_delete && (slotProps.data.cod_richiesta_firma == null || (currentUser.profile.name == 'admin' && data.caricato == 0))" v-model="data.selected" :binary="true" @update:modelValue="inSelectedRows(slotProps.data, data)"/>
                          <div>
                            <p class="p-0">{{ getCaricatoLabel(data.caricato) }}</p> <p class="p-0" v-if="data.data_stato">il {{ moment(data.data_stato).format("DD/MM/YYYY") }} alle ore {{ moment(data.data_stato).format("HH:mm") }}</p>
                          </div>
                        </div>
                      </template>
                    </Column>
                    <Column header="Anagrafica" style="width: 13rem;">
                      <template #body="{data}">
                        <div><strong>{{data.denominazione_cliente}}</strong></div>
                        <div>
                          cf: {{data.cf_cliente}}
                        </div>
                        <div v-if="data.piva_cliente">
                          p. iva: {{data.piva_cliente }}
                        </div>
                      </template>
                    </Column>
                    <Column field="iban_contratto" header="IBAN" style="width: 15rem;">
                      <template #body="{data}">
                        <div>{{ data.iban_contratto }}</div>
                        <div class="flex">
                          <div v-if="!data.checked_data_iban_equal_to_client">
                            <strong>{{ data.intestazione_contratto }}</strong>
                            {{ data.cf_intestazione_contratto }}
                          </div>
                          <Button v-if="slotProps.data.cod_stato_caricamento != 8" class="ml-2 p-button-text p-button-success" icon="pi pi-pencil" v-tooltip="(data.iban_contratto ? 'Modifica' : 'Aggiungi') + ' iban'" @click="setChanges('iban_contratto', slotProps.data, true, data)"/>
                        </div>
                      </template>
                    </Column>
                    <Column header="PDR e Indirizzo di fornitura" style="width: 15rem;">
                      <template #body="{data}">
                        <div>
                          <strong>{{ data.pdr }}</strong> <span>({{data.tipologia_fornitura}})</span>
                        </div>
                        <InlineMessage v-if="data.active" severity="info">in fornitura</InlineMessage>
                        <div class="flex">
                          <span v-if="data.toponimo_fornitura">{{data.toponimo_fornitura}} {{data.indirizzo_fornitura}} {{data.numero_civico_fornitura}}, {{data.cap_fornitura}} - {{data.citta_fornitura}}</span>
                          
                          <Button v-if="data.precheck != 1 && slotProps.data.cod_stato_caricamento != 8" class="ml-2 p-button-text p-button-success" icon="pi pi-pencil" v-tooltip="'Modifica indirizzo di fornitura'" @click="setChanges('indirizzo_fornitura', slotProps.data, true, data)"/>
                        </div>
                        <Button icon="pi pi-eye" v-tooltip="'Vedi prechecks'" class="p-button-white m-2" v-if="currentUser.role == roles.admin.role && data.prechecks.length > 0" @click="viewPrechecks(data.prechecks, data.pdr, 'pdr')"/>
                        <Button icon="pi pi-info-circle" v-tooltip="'Vedi informative voltura'" class="p-button-white m-2" v-if="currentUser.role == roles.admin.role && getInformativeVolturaList(data).length > 0" @click="viewInformativeVoltura(data, data.pdr, 'pdr')"/>
                        <Button icon="pi pi-book" v-tooltip="'Vedi modifiche (opzione IT)'" class="p-button-white m-2" v-if="currentUser.role == roles.admin.role && currentUser.profile.name == 'admin'" @click="viewModifiche('gas', data)"/>
                      </template>
                    </Column>
                    <Column header="Offerta" style="width: 13rem;">
                      <template #body="{data}">
                        <div class="flex flex-wrap align-items-center">
                          <Dropdown v-if="'cod_listino_contratto' in inEdit" v-model="data.cod_listino_contratto" :options="agente_offerta[slotProps.data.agente_id].gas" optionLabel="name" optionValue="id" placeholder="Seleziona offerta" :disabled="!('cod_listino_contratto' in inEdit)" filter/>
                          <div v-else><strong>{{ data.nome_offerta }}</strong></div>
                          <Button v-if="(currentUser.role == roles.admin.role || (currentUser.role == roles.agent.role && slotProps.data.is_contratto_manuale)) && data.caricato == 0 && slotProps.data.cod_stato_caricamento != 8" class="ml-3 p-button-text p-button-success" :icon="('cod_listino_contratto' in inEdit) ? 'pi pi-check' : 'pi pi-pencil'" v-tooltip="'Modifica offerta'" @click="('cod_listino_contratto' in inEdit) ? saveChanges('cod_listino_contratto', false, true, [data.id, 'gas']) : setChanges('cod_listino_contratto', slotProps.data, true, data)"/>
                        </div>
                      </template>
                    </Column>                      
                    <Column style="width: 20%;">
                      <template #body="{data}">
                        <div class="flex">
                          <label>Tipo pratica:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{ getTipoPraticaLabel(data) }}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="data.cf_attivazione || data.piva_attivazione">
                          <label>CF/PIVA precedente:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>
                              <span v-if="data.cf_attivazione">CF: {{ data.cf_attivazione }}</span>
                              <span v-if="data.cf_attivazione && data.piva_attivazione"> - </span>
                              <span v-if="data.piva_attivazione">PIVA: {{ data.piva_attivazione }}</span>
                            </strong>
                          </div>
                        </div>
                        <div class="flex" v-if="data.has_vt4">
                          <label>VT4:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>Si</strong>
                          </div>
                        </div>
                        <div class="flex">
                          <label>Esito precheck:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{getEsitoPrecheck(data)}}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="currentUser.role == roles.admin.role && [2,6].includes(data.cod_stato_caricamento)">
                          <label>Stato:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{getStatoSwitch(data)}}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="currentUser.role == roles.admin.role && [null, 3, 5].includes(data.cod_state_switch)">
                          <label>Esito TIMG:</label>
                          <div class="ml-2 flex flex-column">
                            <strong>{{getEsitoTimoeTimg(data, 'gas')}}</strong>
                          </div>
                        </div>
                        <div class="flex" v-if="[3,7].includes(data.cod_state_switch) || data.timg_ok == 0">
                          <label>Note annullamento:</label>
                          <div class="ml-2 flex flex-column">
                            <div v-if="data.id_annullamento > 0">
                              <strong>{{ data.note_annullamento }}</strong>
                              <p v-if="currentUser.role == roles.admin.role && data.note && data.note !== data.note_annullamento" v-tooltip="'Questa nota è visibile solo agli admin'">{{data.note}}</p>
                            </div>
                            <div v-else-if="data.caricato == 2"><strong>{{ data.note }}</strong></div>
                            <div v-else-if="[3].includes(data.cod_state_switch)"><strong>{{ data.note_switch }}</strong></div>
                            <div v-if="data.timg_ok == 0"><strong>TIMG KO</strong></div>
                          </div>
                        </div>
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </Fieldset>
            </div>
  
            <!-- Dettaglio Note KO-->
            <div class="col-12" v-if="slotProps.data.note_ko.length">
              <Fieldset legend="Note KO Documentale">
                <div class="col-12">
                  <li v-for="(nota) in slotProps.data.note_ko" :key="nota" class="flex justify-content-between nota">
                    <div class="col-1">
                      {{ moment(nota.created_at).format('DD-MM-YYYY') }}:
                    </div>
                    <strong class="col-11">{{ nota.nota }}</strong>
                  </li>
                </div>
              </Fieldset>
            </div>
          </div>
          <div v-else>
            <Loader/>
          </div>
        </template>
      </DataTable>
    </div>
    <div v-else class="field card">
      <Skeleton class="mb-2"></Skeleton>
      <Skeleton width="10rem" class="mb-2"></Skeleton>
      <Skeleton width="5rem" class="mb-2"></Skeleton>
      <Skeleton height="2rem" class="mb-2"></Skeleton>
      <Skeleton width="10rem" height="4rem"></Skeleton>
    </div>
  </div>
  <Dialog v-model:visible="showModalAnnullamento" :style="{width: '450px'}" :modal="true" @hide="hideOverlayAnnullaContratto()">
    <div class="flex flex-column gap-3 w-25rem">
      <h5>Annullamento contratto</h5>
      <Dropdown v-model="matrice_da_annullare.motivazione" :options="motivazioni" filter optionLabel="label" optionGroupLabel="label" optionGroupChildren="items" placeholder="Seleziona Motivazione di annullamento" class="w-full mb-2">
      </Dropdown>
      <div v-if="currentUser.role == roles.admin.role">
        <span class="font-medium text-900 block mb-2">Inserisci note annullamento</span>
        <Textarea v-model="matrice_da_annullare.note_annullamento" rows="5" class="w-full"/>
      </div>
      <div class="m-3 flex justify-content-center">
        <Button :disabled="!matrice_da_annullare.motivazione" label="Conferma annullamento" @click="deleteContratto(true, matrice_da_annullare)" size="small" class="p-button-rounded p-button-success m-2"></Button>
        <Button label="Annulla operazione" outlined @click="deleteContratto(false)" class="p-button-rounded p-button-danger m-2" size="small" text></Button>
      </div>
    </div>
  </Dialog>

  <Dialog id="modalShow" v-model:visible="showModal" :style="{width: '450px'}" :modal="true">
    <div class="formgrid grid">  
      <div class="p-field col-12 md:col-6">
        <h4>{{ rappresentante.name }}</h4>
      </div>
      <div class="p-field col-12 md:col-12">
        <label for="cod_fiscale">Codice fiscale del rappresentante o p.iva dello studio </label>

        <br>
        <InputText id="cod_fiscale" v-model="rappresentante.cod_fiscale" :class="['inputfield w-full',{'p-invalid': validationErrors.cod_fiscale && submitted}]" @change="onSelected($event, 'cod_fiscale')" />
        <div v-if="validationErrors.cod_fiscale && submitted" class="p-error">Formato errato.</div>
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="phone">Telefono</label><br>
          <InputText id="phone" @change="onSelected($event, 'phone')" v-model="rappresentante.phone" :class="['inputfield w-full',{'p-invalid': validationErrors.phone && submitted}]" />
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="mobile">Cellulare</label><br>                   
          <InputMask @change="onSelected($event, 'mobile')" id="mobile" mask="999-999999?9" v-model="rappresentante.mobile" :class="['inputfield w-full',{'p-invalid': validationErrors.mobile && submitted}]" />
          <small v-show="validationErrors.mobile && submitted" class="p-error">Campo richiesto.</small>
          <small v-show="validationErrors.mobile" class="p-error">Ricontrolla il numero di cellulare inserito.</small>
      </div> 
      <Dialog id="modalShowMobile" v-model:visible="showModalMobile" :style="{width: '450px'}" :modal="true">
        <div class="confirmation-content">          
          <p>Hai inserito il numero telefonico: {{ rappresentante.mobile }}</p> 
          <p>É corretto?</p>   
        </div>
        <template #footer>
          <Button @click="isCorrect(true)" label="Si" type="button" icon="pi pi-check" iconPos="left" class="p-button-success btn-multisito mb-2" />
          <Button @click="isCorrect()" label="No" type="button" icon="pi pi-times" iconPos="left" class="p-button-danger btn-multisito mb-2" />
        </template>
      </Dialog>
      <div class="p-field col-12 md:col-6">
          <label for="email">Email</label><br>
          <InputText @change="onSelected($event, 'email')" id="email" v-model="rappresentante.email" :class="['inputfield w-full',{'p-invalid': validationErrors.email || validationErrors.isEmail && submitted}]" />
          <div v-show="validationErrors.email && submitted" class="p-error">Campo richiesto o formato non consentito.</div>
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="pec">Pec</label><br>
          <InputText @change="onSelected($event, 'pec')" id="pec" v-model="rappresentante.pec" class="inputfield w-full"/>
      </div>
      <div class="p-field col-12  md:col-6">
          <label for="toponimo">Toponimo</label><br>
          <Dropdown @change="onSelected($event, 'toponimo')" id="toponimo" v-model="rappresentante.toponimo" :options="toponimi" optionLabel="name" :filter="true" :editable="true" optionValue="name" placeholder="Seleziona toponimo" :class="['inputfield w-full',{'p-invalid': validationErrors.toponimo && submitted}]" />
          <small v-show="validationErrors.toponimo && submitted" class="p-error">Campo richiesto.</small>
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="address">Indirizzo</label><br>
          <InputText @change="onSelected($event, 'address')" id="address" v-model="rappresentante.address" :class="['inputfield w-full',{'p-invalid': validationErrors.address && submitted}]" />
          <small v-show="validationErrors.address && submitted" class="p-error">Campo richiesto.</small>
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="civico">Civico</label><br>
          <InputText @change="onSelected($event, 'civico')" id="civico" v-model="rappresentante.civico" :class="['inputfield w-full',{'p-invalid': validationErrors.civico && submitted}]" />
          <small v-show="validationErrors.civico && submitted" class="p-error">Campo richiesto.</small>
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="cap">Cap</label><br>
          <InputText @change="onSelected($event, 'cap')" id="cap" v-model="rappresentante.cap" :class="['inputfield w-full',{'p-invalid': validationErrors.cap && submitted}]" />
          <small v-show="validationErrors.cap && submitted" class="p-error">Campo richiesto.</small>
      </div>
      <div class="p-field col-12  md:col-6">
          <label for="district">Provincia</label><br>
          <Dropdown @change="onSelected($event, 'selectedDistrict')" id="district" v-model="rappresentante.selectedDistrict" :options="districts" optionLabel="name" optionValue="code" :filter="true" placeholder="Seleziona provincia" :class="['inputfield w-full',{'p-invalid': validationErrors.selectedDistrict && submitted}]" />
          <small v-show="validationErrors.selectedDistrict && submitted" class="p-error">Campo richiesto.</small>
      </div>
      <div class="p-field col-12 md:col-6">
          <label for="city">Comune</label><br>
          <Dropdown id="city" @change="onSelected($event, 'cityId')" v-model="rappresentante.cityId" :options="cities" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona comune" :class="['inputfield w-full',{'p-invalid': validationErrors.cityId && submitted}]" />
          <small v-show="validationErrors.cityId && submitted" class="p-error">Campo richiesto.</small>
      </div>
      <div class="p-field col-12 flex align-items-center flex-column mt-3">
        <div class="text-center">
          <div class="button-wrapper mb-2">
            <span class="label">Carica File</span>
            <input id="upload" name="files" type="file" ref="file" @change="onSelected($event, 'files')" accept="application/pdf,image/gif, image/jpeg, image/jpg,image/png" multiple/>
          </div>
          <div>
            File selezionati:
            <ul>
              <li v-for="file in files" :key="file.name">{{ file.name }}</li>
            </ul>
          </div>
          <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto o formato non consentito.</div>
        </div>
        <div class="text-center">
          <small>Formati consentiti: {{allowedTypeDoc.join(", ")}}</small>
        </div>
      </div>
    </div>
    <template #footer>
      <Button @click="updateRapp(rappresentante)" label="Salva" type="button" icon="pi pi-check" iconPos="left" class="p-button-success btn-multisito mb-2" />
      <Button @click="deleteChanges" label="Annulla" type="button" icon="pi pi-times" iconPos="left" class="p-button-danger btn-multisito mb-2" />
    </template>

  </Dialog>

  <Dialog id="modalPraticheShow" v-model:visible="showModalPratiche" :style="{width: '1300px'}" :modal="true" :dismissableMask="true" @hide="deleteChangesPratiche()">
    <TabView>
      <TabPanel header="Gestisci pratiche" v-if="all_supplies > 0">
        <div class="formgrid grid">  
          <div v-for="(array_pratica, pratica) in all_pratiche" :key="pratica">
            <div v-if="array_pratica.length">
              <div v-if="pratica == 'voltura'">
                <DataTable :value="array_pratica">
                  <template #header>
                    Pratiche di voltura
                  </template>
                  <Column header="CF NUOVO CLIENTE">
                    <template #body="{data}">
                      {{ data.cf }}
                    </template>
                  </Column>
                  <Column header="PIVA NUOVO CLIENTE" v-if="![2,3].includes(type_client_pratiche)">
                    <template #body="{data}">
                      {{ data.piva }}
                    </template>
                  </Column>
                  <Column header="FORNITURA">
                    <template #body="{data}">
                      {{ data.code }}
                    </template>
                  </Column>
                  <Column header="CF PRECEDENTE INTESTATARIO">
                    <template #body="{data, index}">
                      <InputText v-model="data[`cf_attivazione_${data.tipo}`]" autofocus @input="onInputCell($event, index, pratica, data.tipo, 'cf')"/>
                      
                      <div v-show="validationErrors[`cf_attivazione_${data.tipo}_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`cf_attivazione_${data.tipo}_format_${index}`]" class="p-error mt-1" style="font-size:11px">Formato non valido</div>
                      <div v-show="validationErrors[`cf_attivazione_${data.tipo}_invalid_${index}`]" class="p-error mt-1" style="font-size:11px">Lunghezza non valida</div>
                      <div v-show="validationErrors[`cf_attivazione_${data.tipo}_equal_${index}`]" class="p-error mt-1" style="font-size:11px">CF ATTIVAZIONE non può essere uguale al codice fiscale del cliente da attivare</div>
                    </template>
                  </Column>
                  <Column header="PIVA PRECEDENTE INTESTATARIO">
                    <template #body="{data, index}">
                      <InputMask mask="99999999999" v-model="data[`piva_attivazione_${data.tipo}`]" autofocus @update:modelValue="onInputCell($event, index, pratica, data.tipo, 'piva')"/>
                      <div v-show="validationErrors[`piva_attivazione_${data.tipo}_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`piva_attivazione_${data.tipo}_format_${index}`]" class="p-error mt-1" style="font-size:11px">Formato non valido</div>
                      <div v-show="validationErrors[`piva_attivazione_${data.tipo}_equal_${index}`]" class="p-error mt-1" style="font-size:11px">PIVA ATTIVAZIONE non può essere uguale alla partita iva del cliente da attivare</div>
                    </template>
                  </Column>
                  <Column header="DATA DECORRENZA">
                    <template #body="{data}">
                      <Calendar v-model="data['data_decorrenza']" :numberOfMonths="2" :minDate="minDate" :manualInput="false" dateFormat="dd/mm/yy" showIcon/>
                    </template>
                  </Column>
                  <Column header="FILE">
                    <template #body="{data}">
                      <div class="button-wrapper">
                        <span class="label flex justify-content-center align-items-center">Carica {{data.tipo_pratica}}</span>
                        <input class="uploadModuli" :id="`${data.documento.ref}`" :name="`${data.documento.ref}`" type="file" :ref="data.documento.ref" accept="application/pdf,image/gif,image/jpeg,image/jpg,image/png" @change="handleFilePratiche($event, data.documento.ref, pratica)"/>
                      </div>
                      <div class="m-1">{{data.documento.nome}}</div>
                      <div v-show="validationErrors[data.documento.ref]" class="p-error mt-1" style="font-size:11px">Documento necessario</div>

                    </template>
                  </Column>
                </DataTable>
              </div>
              <div v-else>
                <DataTable :value="array_pratica">
                  <template #header>
                    Pratiche di {{pratica}}
                  </template>
                  <Column header="FORNITURA">
                    <template #body="{data}">
                      {{ data.code }}
                    </template>
                  </Column>
                  <Column>
                    <template #body="{data}">
                      <div v-if="data.code.startsWith('IT')">
                        Nessun dato richiesto
                      </div>
                      <div v-else>
                        <Dropdown v-model="data['remi']" 
                        :options="remiOption[data.code]" 
                        placeholder="Seleziona Remi" 
                        @change="onSelectedRemi(data.code)"
                        optionValue="remi" optionLabel="remi"
                        />
                        <div v-show="validationErrors[`remi_${data.code}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      </div>
                    </template>
                  </Column>
                  <Column header="DATA DECORRENZA">
                    <template #body="{data}">
                      <Calendar v-model="data['data_decorrenza']" :numberOfMonths="2" :minDate="minDate" :manualInput="false" dateFormat="dd/mm/yy" showIcon/>
                    </template>
                  </Column>
                  <Column header="FILE">
                    <template #body="{data}">
                      <div class="button-wrapper">
                        <span class="label">Carica {{data.tipo_pratica}}</span>
                        <input class="uploadModuli" :id="`${data.documento.ref}`" :name="`${data.documento.ref}`" type="file" :ref="data.documento.ref" accept="application/pdf,image/gif,image/jpeg,image/jpg,image/png" @change="handleFilePratiche($event, data.documento.ref, pratica)"/>
                      </div>
                      <div class="m-1">{{data.documento.nome}}</div>
                      <div v-show="validationErrors[data.documento.ref]" class="p-error mt-1" style="font-size:11px">Documento necessario</div>
                    </template>
                  </Column>
                </DataTable>
              </div>
            </div>
          </div>            
          <footer class="mt-5 col-12 flex justify-content-center">
            <div v-if="sent_pratica">
              <div v-if="is_contratto_manuale">
                <div class="m-2">
                  Dati inseriti correttamente.
                </div>
                <div class="flex justify-content-center m-2">
      
                  <Button @click="deleteChangesPratiche()" label="Chiudi" type="button" icon="pi pi-times" iconPos="left" class="p-button-danger btn-multisito m-2"/>
                </div>
      
              </div>
              <div v-else>
                <Button @click="showPratiche()" label="Scarica Moduli Pratiche" type="button" icon="pi pi-eye" iconPos="left" class="p-button-danger btn-multisito mb-2" />
                <Button @click="signPratiche(matrice_pratiche)" label="Richiedi Firma pratiche" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-primary btn-multisito mb-2"/>
              </div>
            </div>
            <div v-else>
              <Button @click="sendPratiche" label="Invia pratiche" type="button" icon="pi pi-check" iconPos="left" class="p-button-success btn-multisito m-2" :disabled="isDisabledSendPratiche"/>
              <Button @click="deleteChangesPratiche()" label="Annulla" type="button" icon="pi pi-times" iconPos="left" class="p-button-danger btn-multisito m-2"/>
            </div>
          </footer> 
        </div>      
      </TabPanel>
      <!-- <TabPanel header="Modifica Dati">
        <div class="formgrid grid">  
          <div v-if="modifiche.length">
            <div class="card flex justify-content-around m-2" v-if="type_client_pratiche != 3">
              <div class="flex flex-column">
                <label>CODICE FISCALE</label>
                <InputMask  class="text_toupper" v-model="unique_cf" :mask="![2,4].includes(type_client_pratiche) ? '99999999999' : 'aaaaaa99a99a9**a'" @update:modelValue="onInput($event, 'unique_cf')"/>
                <div v-show="validationErrors.unique_cf" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
              </div>

              <div class="flex flex-column" v-if="![2].includes(type_client_pratiche)">
                <label>Partita IVA</label>
                <InputMask v-model="unique_piva" mask="99999999999" @update:modelValue="onInput($event, 'unique_piva')"/>
                <div v-show="validationErrors.unique_piva" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
              </div>
            </div>
            <Button v-tooltip="`Clicca sulla fornitura per apportare le eventuali modifiche`" icon="pi pi-info" class="ml-3 btn-offerte"/>
            <DataTable :value="modifiche" v-model:editingRows="editingRows" editMode="cell">
              <Column field="cf" header="CODICE FISCALE" v-if="type_client_pratiche == 3">
                <template #body="{ data, index }">
                  <div>{{data.cf == '' ? 'Inserisci...' : data.cf}}</div>
                  <div v-show="validationErrors[`cf_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </template>

                <template #editor="{ data, index }">
                  <InputMask v-model="data.cf" mask="99999999999" @update:modelValue="onInput($event, 'cf', index)"/>
                </template>
              </Column>
              <Column field="code" header="FORNITURA">
                <template #body="{ data, index }">
                  <div>{{data.code == '' ? 'Inserisci...' : data.code}}</div>
                  <div v-show="validationErrors[`code_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                  <div v-show="validationErrors[`existent_${index}`]" class="p-error mt-1" style="font-size:11px">Duplicato</div>
                </template>
                <template #editor="{ data, index }">
                  <InputMask v-model="data.code" :mask="data.mask" @update:modelValue="onInput($event, 'code', index)"/>
                </template>
              </Column>
              <Column :exportable="false" v-if="modifiche.length > 1">
                <template #body="{ data, index }">
                  <ConfirmPopup group="headless">
                    <template #container="{ message, acceptCallback, rejectCallback }">
                      <div class="border-round p-3">
                        <span>{{ message.message }}</span>
                        <div class="flex align-items-center gap-2 mt-3">
                          <Button label="Si" @click="acceptCallback" size="small" class="p-button-success"></Button>
                          <Button label="No" outlined @click="rejectCallback" class="p-button-decondary" size="small" text></Button>
                        </div>
                      </div>
                    </template>
                  </ConfirmPopup>
                  <div class="flex justify-content-center">
                    <Button @click="requireConfirmation($event, data, index)" class="p-button-danger" label="Elimina Fornitura"/>
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
          <footer class="mt-5 col-12 flex justify-content-center">
            <Button @click="saveChangesMultisito()" label="Salva modifiche" type="button" icon="pi pi-times" iconPos="left" class="p-button-success btn-multisito m-2"/>
          </footer> 
        </div>      
      </TabPanel> -->
    </TabView>
  </Dialog>

  <!-- Dialog new Matrice -->
  <Dialog v-model:visible="newMatriceDialog" :style="{width: '80%'}" header="Aggiungi Matrice" :modal="true">
      <div class="grid form-file"> 
        <div class="col-12">
          <div>Tipo matrice: </div><br>
          <Dropdown v-model="typeMatrice" :options="typesMatrice" optionLabel="name" optionValue="val" placeholder="Seleziona tipo matrice" class="inputfield w-full" />
          <div v-show="validationErrors.type_matrice && submitted" class="p-error">Campo richiesto.</div>
        </div>
        <div class="col-12">
          <label>Tipo Clienti</label>
          <Dropdown v-model="selectedTypeClient" :options="typesClient" optionLabel="name" optionValue="id" placeholder="Seleziona tipo cliente"  :class="['inputfield w-full',{'p-invalid': validationErrors.selectedTipo && submitted}]" />
          <div v-show="validationErrors.type_client && submitted" class="p-error">Campo richiesto.</div>
        </div>
        <div class="col-12" style="display:none">
          <label class="mb-1">Offerte applicabili</label><br>
          <div v-for="offerta in offerte" :key="offerta.id" class="badge-offerta">
            {{offerta.name}}
          </div>
        </div>
        <div class="col-12 md:col-6 my-4">
          <Checkbox v-model="isIvaAgevolata" :binary="true"/>
          <label class="ml-2"> Iva Agevolata </label>
        </div>
        <div class="col-12">
          <label>File</label>
          <div class="button-wrapper">
            <span :class="['label', {'active': fileToUpload.length > 0}]">
              {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Seleziona File' }}
            </span>
            <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
          </div>
          <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
          <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
        </div>
      </div>
      
      <template #footer>
        <Button label="Annulla" icon="pi pi-times" class="p-button-text p-button-secondary" @click="newMatriceDialog = false"/>
        <Button label="Aggiungi" icon="pi pi-check" class="p-button-text" @click="uploadNewMatrice" />
      </template>
  </Dialog>

  <!-- Dialog insert signed contract -->
  <Dialog v-model:visible="insertSignedContractDialog" :style="{width: '80%'}" header="Aggiungi documenti firmati" :modal="true" :dismissableMask="true" @hide="deleteInsertSignedContract()">
    <div class="flex flex-wrap justify-content-center">
      <div v-for="document in requiredDocuments" :key="document.name" class="col-12 sm:col-6 md:col-4 lg:col-3 xl:col-2">
        <div class="flex align-items-center flex-column mb-3 justify-content-center">
          <div class="button-wrapper-file mb-2">
            <span class="label">Carica {{document.name}}</span>
            <input class="upload-file" :name="`${document.ref}`" type="file" :ref="document.ref" @change="handleFileNewUpload($event, document.ref)" accept="application/pdf,image/gif,image/jpeg,image/jpg,image/png" :multiple="document.multiple" :disabled="isDisableInput"/>
          </div>
          <div>
            <p class="text-center">
              File selezionati:
            </p>
            <ul>
              <li v-for="file in document.files" :key="file.name">{{ file.name }}</li>
            </ul>
          </div>
          <div v-show="validationErrors[`${ref}`] && submitted" class="p-error">Campo richiesto.</div>
          <div v-show="validationErrors[`type_${ref}`] && submitted" class="p-error">Formato non consentito</div>
        </div>
      </div>
    </div>      
    <div class="text-center">
      <small>Formati consentiti: {{allowedTypes.join(", ")}}</small>
    </div>
    <div class="mt-3 grid justify-content-center">
      <div class="flex flex-column">
        <label>Data firma:</label>
        <Calendar v-model="data_firma_cartaceo" :maxDate="maxDateSigned" :manualInput="false" dateFormat="dd/mm/yy" @update:modelValue="onChangeDataFirma"/>
        <div v-show="validationErrors.data_firma_cartaceo && submitted" class="p-error">Campo richiesto.</div>
      </div>
    </div>
    <template #footer>
      <Button :disabled="isDisabledSetFirmato" label="Invia documenti" icon="pi pi-check" class="p-button-success" @click="setFirmato($event, matrice_for_signed_contract.id)" />
    </template>
  </Dialog>

    <!-- Dialog insert missing documents -->
  <Dialog v-model:visible="insertMissingDocumentsDialog" :style="{width: '80%'}" header="Aggiungi documenti mancanti" :modal="true" :dismissableMask="true" @hide="deleteInsertMissingDocuments()">
    <div class="flex flex-wrap justify-content-center">
      <div v-for="document in missingDocuments" :key="document.name" class="col-12 sm:col-6 md:col-4 lg:col-3 xl:col-2">
        <div class="flex align-items-center flex-column mb-3 justify-content-center">
          <div class="button-wrapper-file mb-2">
            <span class="label">Carica {{document.name}}</span>
            <input class="upload-file" :name="`${document.ref}`" type="file" :ref="document.ref" @change="handleFileMissing($event, document.ref)" accept="application/pdf,image/gif,image/jpeg,image/jpg,image/png" :multiple="document.multiple" :disabled="isDisableInputMissing"/>
          </div>
          <div>
            <p class="text-center">
              File selezionati:
            </p>
            <ul>
              <li v-for="file in document.files" :key="file.name">{{ file.name }}</li>
            </ul>
          </div>
          <div v-show="validationErrors[`${ref}`] && submitted" class="p-error">Campo richiesto.</div>
          <div v-show="validationErrors[`type_${ref}`] && submitted" class="p-error">Formato non consentito</div>
        </div>
      </div>
    </div>      
    <div class="text-center">
      <small>Formati consentiti: {{allowedTypes.join(", ")}}</small>
    </div>
    <template #footer>
      <Button :disabled="isDisabledUploadNewFile" label="Invia documenti" icon="pi pi-check" class="p-button-success" @click="uploadNewFile($event, matrice_for_missing_documents.id)" />
    </template>
  </Dialog>

  <Dialog v-model:visible="dialogModificaAgenteFirmatario" :style="{width: '60%'}" :header="`Modifica agente firmatario caricamento #${dataDialogModificaAgenteFirmatario.id}`" :modal="true" :dismissableMask="true" @hide="deleteDataDialogModificaAgenteFirmatario()">
    <div class="flex justify-content-around align-items-center m-5">
      <div class="flex flex-column">
        <label>Id caricamento</label>
        <strong>{{ dataDialogModificaAgenteFirmatario.id }}</strong>
      </div>
      <div class="flex flex-column">
        <label>Agente firmatario attuale</label>
        <strong>{{ dataDialogModificaAgenteFirmatario.agente.name }}</strong>
      </div>
      <div class="flex flex-column">
        <label>Nuovo agente firmatario</label>
        <Dropdown v-model="dataDialogModificaAgenteFirmatario.new_agente" :options="dataDialogModificaAgenteFirmatario.possibleNewAgenti" optionLabel="name" placeholder="Seleziona un nuovo agente firmatario" class="w-20rem" filter/>
      </div>
    </div>
    <div class="flex justify-content-center">
      <Button :disabled="!dataDialogModificaAgenteFirmatario.new_agente" label="Salva" @click="saveNewAgenteFirmatario()"/>
    </div>

  </Dialog>

  <Button v-if="currentUser.role == roles.admin.role && selectedItems.length > 0" @click="downloadsMatrici" class="p-button-warning btn-downloads-matrici p-3 m-1"  style="min-width:200px">
    Scarica matrici selezionate <i class="pi pi-download ml-5"></i>
  </Button>

  <Dialog v-model:visible="dialogPrechecks" :style="{width: '100%'}" :header="`Precheck della fornitura #${prechecks.pp}`" modal :dismissableMask="true">
    <DataTable :value="prechecks.list" showGridlines scrollable>
      <Column>
        <template #body="{data}">
          <Button v-if="data['REQUEST ID']" class="p-button-text" icon="pi pi-eye" @click="viewRequestPratica(data['REQUEST ID'])" v-tooltip="'Visualizza Richiesta'"/>
        </template>
      </Column>
      <Column v-for="col of prechecks.columns" :key="col" :field="col" :header="col" style="min-width: 80px"></Column>
    </DataTable>
  </Dialog>

  <Dialog v-model:visible="dialogInformativeVoltura" :style="{width: '100%'}" :header="`Informative voltura della fornitura #${informativeVoltura.pp}`" modal :dismissableMask="true">
    <DataTable :value="informativeVoltura.list" showGridlines scrollable>
      <Column>
        <template #body="{data}">
          <Button v-if="getRequestIdPratica(data)" class="p-button-text" icon="pi pi-eye" @click="viewRequestPratica(getRequestIdPratica(data))" v-tooltip="'Visualizza Richiesta'"/>
        </template>
      </Column>
      <Column v-for="col of informativeVoltura.columns" :key="col" :field="col" :header="col" style="min-width: 80px"></Column>
    </DataTable>
  </Dialog>

  <Dialog v-model:visible="dialogDataStorico" :style="{width: '70%'}" :header="`Storico caricamento ${idDataStorico}`" modal :dismissableMask="true" @hide="resetDataStorico()">
    <DataTable :value="dataStorico.data" showGridlines scrollable>
      <Column v-for="col of dataStorico.columns" :key="col" :field="col" :header="col" style="min-width: 80px"></Column>
    </DataTable>
  </Dialog>

  <Dialog v-model:visible="dialogLogCaricamento" :style="{width: '80%'}" :header="`Log caricamento ${idLogCaricamento}`" modal :dismissableMask="true" @hide="resetLogCaricamento()">
    <DataTable :value="logCaricamento.data" showGridlines scrollable>
      <Column v-for="col of logCaricamento.columns" :key="col" :field="col" :header="col" :style="{minWidth: col === 'json' ? '360px' : '120px'}">
        <template #body="slotProps">
          <pre v-if="col === 'json'" class="json-viewer">{{ parseJson(slotProps.data[col]) }}</pre>
          <span v-else>{{ slotProps.data[col] }}</span>
        </template>
      </Column>
    </DataTable>
  </Dialog>

  <Dialog v-model:visible="dialogModifiche" :style="{width: '80%'}" modal :dismissableMask="true" @hide="resetInEdit()">
    <template #header>
      <div v-if="'contatto' in inEdit">{{`Modifica contatto del caricamento #${caricamento_da_modificare.id}`}}</div>
      <div v-if="'indirizzo_fornitura' in inEdit">{{`Modifica indirizzo di fornitura del punto di prelievo ${pp_da_modificare.code} del caricamento #${caricamento_da_modificare.id}`}}</div>
      <div v-if="'iban_contratto' in inEdit">{{`Modifica iban del punto di prelievo ${pp_da_modificare.code} del caricamento #${caricamento_da_modificare.id}`}}</div>
    </template>
    <div v-if="'contatto' in inEdit">
      <div class="flex flex-wrap w-full">
        <div class="p-field col-6">
          <label for="toponimo">Toponimo</label><br>
          <Dropdown @change="onSelected($event, 'toponimo')" id="toponimo" v-model="caricamento_da_modificare.contatto.toponimo" :options="toponimi" optionLabel="name" :filter="true" :editable="true" optionValue="name" placeholder="Seleziona toponimo" :class="['inputfield w-full',{'p-invalid': validationErrors.toponimo}]" />
        </div>
        <div class="p-field col-6">
          <label for="indirizzo">Indirizzo</label><br>
          <InputText @change="onSelected($event, 'indirizzo')" id="indirizzo" v-model="caricamento_da_modificare.contatto.indirizzo" :class="['inputfield w-full',{'p-invalid': validationErrors.indirizzo}]" />
        </div>
        <div class="p-field col-6">
          <label for="civico">Civico</label><br>
          <InputText @change="onSelected($event, 'civico')" id="civico" v-model="caricamento_da_modificare.contatto.civico" :class="['inputfield w-full',{'p-invalid': validationErrors.civico}]" />
        </div>
        <div class="p-field col-6">
          <label for="cap">Cap</label><br>
          <InputText @change="onSelected($event, 'cap')" id="cap" v-model="caricamento_da_modificare.contatto.cap" :class="['inputfield w-full',{'p-invalid': validationErrors.cap}]" />
        </div>
        <div class="p-field col-6">
          <label for="district">Provincia</label><br>
          <Dropdown @change="onSelected($event, 'provincia')" id="district" v-model="caricamento_da_modificare.contatto.provincia" :options="districts" optionLabel="name" optionValue="code" :filter="true" placeholder="Seleziona provincia" :class="['inputfield w-full',{'p-invalid': validationErrors.provincia}]" />
        </div>
        <div class="p-field col-6">
          <label for="city">Comune</label><br>
          <Dropdown id="city" @change="onSelected($event, 'cod_comune')" v-model="caricamento_da_modificare.contatto.cod_comune" :options="cities" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona comune" :class="['inputfield w-full',{'p-invalid': validationErrors.cod_comune}]" />
        </div>
        <div class="p-field col-6">
          <label for="email">Email</label><br>
          <InputText @change="onSelected($event, 'email')" id="email" v-model="caricamento_da_modificare.contatto.email" :class="['inputfield w-full',{'p-invalid': validationErrors.email}]" />
        </div>
        <div class="p-field col-6">
          <label for="pec">PEC <span v-if="isContactPecRequired" class="p-error">(obbligatoria)</span></label><br>
          <InputText @change="onSelected($event, 'pec')" id="pec" v-model="caricamento_da_modificare.contatto.pec" :class="['inputfield w-full',{'p-invalid': validationErrors.pec || isContactPecMissing || isContactPecInvalid}]" />
        </div>
        <div class="p-field col-6">
          <label for="cell">Cellulare</label><br>
          <InputMask @change="onSelected($event, 'cell')" id="cell" mask="999999999?9" v-model="caricamento_da_modificare.contatto.cell" :class="['inputfield w-full',{'p-invalid': validationErrors.cell}]" />
        </div>
      </div>
      <div class="flex flex-wrap col-12 justify-content-center">
        <InlineMessage v-if="isDisabledSaveNewContact.disabled" severity="error" class="m-2 col-5">
          {{ isDisabledSaveNewContact.message }}
        </InlineMessage>
      </div>
      <div class="flex justify-content-center">
        <Button icon="pi pi-send" label="Salva nuovo contatto" :disabled="isDisabledSaveNewContact.disabled" class="p-button-rounded p-button-success" @click="saveChanges('contatto')"/>
      </div>

    </div>
    <div v-if="'indirizzo_fornitura' in inEdit">
      <div class="flex flex-wrap w-full">
        <div class="p-field col-6">
          <label for="toponimo">Toponimo</label><br>
          <Dropdown @change="onSelected($event, 'toponimo_fornitura')" id="toponimo" v-model="pp_da_modificare.toponimo_fornitura" :options="toponimi" optionLabel="name" :filter="true" :editable="true" optionValue="name" placeholder="Seleziona toponimo" :class="['inputfield w-full',{'p-invalid': validationErrors.toponimo_fornitura}]" />
        </div>
        <div class="p-field col-6">
          <label for="indirizzo">Indirizzo</label><br>
          <InputText @change="onSelected($event, 'indirizzo_fornitura')" id="indirizzo" v-model="pp_da_modificare.indirizzo_fornitura" :class="['inputfield w-full',{'p-invalid': validationErrors.indirizzo_fornitura}]" />
        </div>
        <div class="p-field col-6">
          <label for="civico">Civico</label><br>
          <InputText @change="onSelected($event, 'numero_civico_fornitura')" id="civico" v-model="pp_da_modificare.numero_civico_fornitura" :class="['inputfield w-full',{'p-invalid': validationErrors.numero_civico_fornitura}]" />
        </div>
        <div class="p-field col-6">
          <label for="cap">Cap</label><br>
          <InputText @change="onSelected($event, 'cap_fornitura')" id="cap" v-model="pp_da_modificare.cap_fornitura" :class="['inputfield w-full',{'p-invalid': validationErrors.cap_fornitura}]" />
        </div>
        <div class="p-field col-6">
          <label for="district">Provincia</label><br>
          <Dropdown @change="onSelected($event, 'provincia_fornitura')" id="district" v-model="pp_da_modificare.provincia_fornitura" :options="districts" optionLabel="name" optionValue="code" :filter="true" placeholder="Seleziona provincia" :class="['inputfield w-full',{'p-invalid': validationErrors.provincia_fornitura}]" />
        </div>
        <div class="p-field col-6">
          <label for="city">Comune</label><br>
          <Dropdown id="city" @change="onSelected($event, 'cod_comune')" v-model="pp_da_modificare.cod_comune" :options="cities" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona comune" :class="['inputfield w-full',{'p-invalid': validationErrors.cod_comune}]" />
        </div>
      </div>
      <div class="flex flex-wrap col-12 justify-content-center">
        <InlineMessage v-if="isDisabledSaveNewIndirizzoFornitura.disabled" severity="error" class="m-2 col-5">
          {{ isDisabledSaveNewIndirizzoFornitura.message }}
        </InlineMessage>
      </div>
      <div class="flex justify-content-center">
        <Button icon="pi pi-send" label="Salva l'indirizzo di fornitura" :disabled="isDisabledSaveNewIndirizzoFornitura.disabled" class="p-button-rounded p-button-success" @click="saveChanges('indirizzo_fornitura', false, true, [pp_da_modificare.id, pp_da_modificare.pod ? 'ee' : 'gas'])"/>
      </div>
    </div>
    <div v-if="'iban_contratto' in inEdit">
      <div class="flex justify-content-center">
        <div class="col-5">
          <label>Iban</label><br>
          <InputMask class="w-full text_toupper" mask="IT99a9999999999****99999*99" placeholder="Inserisci IBAN" v-model="pp_da_modificare.iban_contratto" @change="onSelected($event, 'iban_contratto')"/>
        </div>
      </div>
      <div class="flex flex-wrap justify-content-center" v-if="pp_da_modificare.iban_contratto">
        <div v-if="canChangeDatiIban" class="col-12 flex m-2 align-items-center justify-content-center">
          <Checkbox v-model="pp_da_modificare.checked_data_iban_equal_to_client" :binary="true" @change="setDatiIban()"/>
          <label class="ml-2">L'intestatario delle coordinate bancarie coincide con il cliente</label>
        </div>
      
        <div class="flex flex-wrap col-12 justify-content-around">
          <div class="col-5">
            <label><strong>Intestatario</strong></label>
            <InputText class="text_toupper w-full" v-model="pp_da_modificare.intestazione_contratto" :disabled="pp_da_modificare.checked_data_iban_equal_to_client"
            @input="onSelected($event, 'intestazione_contratto')"/>
          </div>
          <div class="col-5">
            <label><strong>Codice fiscale</strong></label>
            <InputMask v-model="pp_da_modificare.cf_intestazione_contratto" :mask="getMaskIban" class="text_toupper w-full" :disabled="pp_da_modificare.checked_data_iban_equal_to_client"
            @input="onSelected($event, 'cf_intestazione_contratto')"/>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap col-12 justify-content-center">
        <InlineMessage v-if="isDisabledSaveNewPaymentMode.disabled" severity="error" class="m-2 col-5">
          {{ isDisabledSaveNewPaymentMode.message }}
        </InlineMessage>
      </div>
      <div class="flex justify-content-center">
        <Button icon="pi pi-send" label="Salva metodo di pagamento" :disabled="isDisabledSaveNewPaymentMode.disabled" class="p-button-rounded p-button-success" @click="saveChanges('iban_contratto', !pp_da_modificare.iban_contratto, true, [pp_da_modificare.id, pp_da_modificare.pod ? 'ee' : 'gas'])"/>
      </div>
    </div>
  </Dialog>
  <Dialog v-model:visible="dataDialogDeletePP.dialog" :style="{width: '70%'}" :header="`Seleziona motivazioni di annullamento per i punti del caricamento ${dataDialogDeletePP.matrice.id}`" modal :dismissableMask="true" @hide="resetDataDialogDeletePP()">
    <DataTable :value="dataDialogDeletePP.pps" showGridlines scrollable>
      <Column header='Fornitura'>
        <template #body="{data}">
          {{ data.code }}
        </template>
      </Column>
      <Column header='Motivazione'>
        <template #body="{data}">
          <div class="flex flex-column w-full">
            <Dropdown v-model="data.motivazione_annullamento" :options="motivazioni" filter optionLabel="label" optionGroupLabel="label" optionGroupChildren="items" placeholder="Seleziona Motivazione di annullamento" class="w-full mb-2"/>
          </div>
        </template>
      </Column>
      <template #footer v-if="canViewDeletePP()">
        <div class="flex flex-column align-items-center">
          <Button label="Elimina" icon="pi pi-trash" @click="deletePP()" class="p-button-danger mb-3"/>

          <Textarea v-model="dataDialogDeletePP.note" rows="3" cols="30" placeholder="Note" class="w-full"/>
        </div>
      </template>
    </DataTable>
  </Dialog>

  <Dialog 
    v-model:visible="log_modifiche.dialog" 
    :modal="true" 
    :header="'Cronologia Modifiche Fornitura - Codice: ' + (log_modifiche.code || '')"
    :style="{ width: '70vw' }"
    :breakpoints="{ '960px': '85vw', '640px': '100vw' }"
    @hide="log_modifiche.reset()"
  >
    <div v-if="log_modifiche.logs && log_modifiche.logs.data && log_modifiche.logs.data.length > 0">
      <Carousel 
        :value="log_modifiche.logs.data" 
        :numVisible="1" 
        :numScroll="1" 
        orientation="horizontal"
        containerClass="custom-audit-carousel"
      >
        <template #item="slotProps">
          <div class="log-card">
            
            <div class="card-header">
              <span class="function-badge">{{ slotProps.data.function }}</span>
              <span class="date-text">{{ formatDate(slotProps.data.data_inserimento) }}</span>
            </div>

            <div class="card-info">
              <p><strong>ID Log:</strong> #{{ slotProps.data.id }}</p>
              <p><strong>Tabella di riferimento:</strong> {{ slotProps.data.name_table }} (ID Record: {{ slotProps.data.id_record }})</p>
              <p><strong>Operatore (ID Utente):</strong> {{ slotProps.data.id_user }}</p>
            </div>

            <Divider />

            <div class="data-comparison">
              
              <div class="data-block prev-block">
                <span class="block-title font-bold text-red-500">
                  <i class="pi pi-arrow-left mr-1"></i> Stato Precedente
                </span>
                <pre class="json-viewer">{{ parseJson(slotProps.data.data_prev) }}</pre>
              </div>

              <div class="data-block next-block">
                <span class="block-title font-bold text-green-500">
                  Stato Successivo <i class="pi pi-arrow-right ml-1"></i>
                </span>
                <pre class="json-viewer">{{ parseJson(slotProps.data.data_next) }}</pre>
              </div>

            </div>
          </div>
        </template>
      </Carousel>
    </div>
  </Dialog>

  <Dialog v-model:visible="detailRequestPratica.dialog" header="Dettaglio richiesta pratica" :style="{width: '100%'}" modal :dismissableMask="true" @hide="detailRequestPratica.reset()">
    <DataTable :value="detailRequestPratica.data.objects" showGridlines scrollable>
      <Column v-for="col of detailRequestPratica.data.columns" :key="col" :field="col" :header="col"></Column>
    </DataTable>
  </Dialog>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars
import { FilterMatchMode } from 'primevue/api';
import moment from 'moment'
import {ref, onMounted, getCurrentInstance, computed, nextTick } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import ContractPreviewDialog from '@/components/pratiche/multisito/ContractPreviewDialog.vue'
import Loader from "@/components/Loader.vue"
import { useToast } from 'primevue/usetoast';
import roles from '@/config/roles'
import { useRoute, useRouter } from 'vue-router'
import { useConfirm } from "primevue/useconfirm";

export default {
  components: {
    ContractPreviewDialog,
    Loader
  },  
  setup (props, {emit}) {
    const dates_firma = ref();
    const authors = ref([]);
    const masters = ref([]);
    const incaricati = ref([]);
    const rapps = ref([]);
    const clients = ref([]);
    const ids = ref([]);
    const cf_piva = ref([]);
    const forniture = ref([]);
    const route = useRoute()
    const router = useRouter()
    var XLSX = require("xlsx");
    const caricamento_da_modificare = ref({})
    const pp_da_modificare = ref({})
    const inEdit = ref({})
    const prechecks = ref({
      pp: null,
      list: [],
      columns: []
    })
    const informativeVoltura = ref({
      pp: null,
      list: [],
      columns: []
    })
    const columns_precheck = {
      pod: ["VERIFICA AMM","COD CAUSALE","MOTIVAZIONE","ESITO","COD ESITO","DETTAGLIO ESITO","CF","PIVA","RISOLUZIONE CONTRATTUALE TIMOE","PIVA CONTROPARTE COMMERCIALE","RAG SOC CONTR COMM","EMAIL CONTR COMM","PMA POD","DATA CREAZIONE"],
      pdr: ["VERIFICA AMM","COD CAUSALE","MOTIVAZIONE","ESITO","COD ESITO","DETTAGLIO ESITO","COD REMI","TIPO PDR","PIVA DISTRIBUTORE","CF","PIVA","NOME","COGNOME","RAGIONE SOCIALE DENOMINAZIONE","RAGIONE SOCIALE CONTROPARTECOMMERCIALE","PIVA CONTROPARTECOMMERCIALE","POSTA CERTIFICATA","DATA CREAZIONE"]
    }
    const columns_informative_voltura = {
      pod: ["VERIFICA AMM","COD CAUSALE","MOTIVAZIONE","COD POD","STATO POD","PMA POD","TENSIONE","TOPONIMO","VIA","CIV","CAP","ISTAT","LOCALITA","PROV","NAZIONE","ALTRO","MERCATO PROVENIENZA","POTCONTRIMP","POTDISP","DATA CREAZIONE"],
      pdr: ["VERIFICA AMM","COD CAUSALE","MOTIVAZIONE","COD PDR","COD REMI","STATO PDR","PIVA DISTRIBUTORE","TOPONIMO","VIA","CIV","CAP","ISTAT","LOCALITA","PROV","NAZIONE","ALTRO","PREL ANNUO PREV","COD PROF PREL STD","CAP TRASP PDR","MATR MIS","CLASSE GRUPPO MIS","DATA CREAZIONE"]
    }
    const dialogPrechecks = ref(false)
    const dialogInformativeVoltura = ref(false)

    const filters = ref({
      global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      id: { value: null, matchMode: FilterMatchMode.CONTAINS},
      agente: { value: null, matchMode: FilterMatchMode.CONTAINS },
      agenteMaster: { value: null, matchMode: FilterMatchMode.CONTAINS },
      agenteIncaricato: { value: null, matchMode: FilterMatchMode.CONTAINS },
      rappresentante: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cliente: { value: null, matchMode: FilterMatchMode.CONTAINS },
      is_complete: { value: null, matchMode: FilterMatchMode.EQUALS },
      need_pratiche: { value: null, matchMode: FilterMatchMode.EQUALS },
      cf_piva_clienti: { value: null, matchMode: FilterMatchMode.CONTAINS},
      pps: { value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const toast = useToast();
    const store = useStore()
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const loading = ref(false)
    const currentUser = ref(store.state.auth.user)
    const items = ref([]);
    const selectedItems = ref([]);
    const contatori = ref([]);
    const newMatriceDialog = ref(null)
    const insertSignedContractDialog = ref(null)
    const insertMissingDocumentsDialog = ref(null)
    const typesMatrice = ref([
      {name: 'Energia', val: 'ee'},
      {name: 'Gas', val: 'gas'}
    ])
    const typeMatrice = ref()
    const matriceUploadKey = ref(0);
    const typesClient = ref([])
    const selectedTypeClient = ref(null)
    const offerte = ref([])
    const selectedOfferte = ref([])
    const isIvaAgevolata = ref(false)
    const loaded = ref(false)
    const fileToUpload = ref([])
    const allowedType = {
      'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
    const allowedTypes = ['pdf','jpeg','jpg','png']
    const vs = ref([])
    const ctr = ref([])
    const matrice_for_signed_contract = ref()
    const matrice_for_missing_documents = ref()
    const isDisableInput = ref(false)
    const isDisableInputMissing = ref(false)
    const maxDateSigned = new Date()
    const data_firma_cartaceo = ref()

    const validationErrors = ref({})
    const submitted = ref(false)
    const showModalMobile = ref(false)
    const showModal = ref(false)
    const showModalPratiche = ref(false)
    const districts = ref([])
    const cities = ref([])
    const toponimi = ref([])
    const allowedTypeDoc = ['pdf','jpeg','jpg','png']
    const files = ref([])
    const moduli = ref([])
    const matrice_id = ref('')
    // const pratiche_s1_ee = ref([])
    // const pratiche_s1_gas = ref([])
    // const pratiche_v1_ee = ref([])
    // const pratiche_v1_gas = ref([])
    const matrice_pratiche = ref()
    const id_matrice_pratiche = ref('')
    const is_contratto_manuale = ref()
    const windowSize = ref(window.innerWidth)
    const all_supplies = ref(0)
    const file_caricati = ref(0)
    const all_file_pratiche = ref({})
    const all_pratiche = ref({
      voltura:[],
      subentro:[],
      'attivazione su preposato': []
    })

    // const has_piva = ref()
    // const is_number = ref()
    const editingRows = ref([]);
    const modifiche = ref([])
    const confirm = useConfirm();

    const type_client_pratiche = ref()
    const unique_cf = ref()
    const unique_piva = ref()

    const sent_pratica = ref(false)
    const isDisableShowPratiche = ref(false);
    const now = new Date()
    const minDate = ref(new Date(new Date(now).setDate(now.getDate() + 2)))
    const selectedStatus = ref([])
    const selectedStatusFilterChanged = ref(false)
    const selectedDate = ref([
      // moment().startOf("week").toDate(),
      // new Date(),
    ]);
    const dialogModifiche = ref(false)
    const selectedIdMatrice = ref([])
    const searchedIdMatrice = ref()
    const selectedPuntiPrelievo = ref(null)
    const searchedPuntiPrelievo = ref()
    const selectedClienteRappresentante = ref(null)
    const searchedClienteRappresentante = ref()
    const selectedSignDate = ref();
    const isCaricamentoEreditato = (data) => {
      return Object.prototype.hasOwnProperty.call(data ?? {}, 'origin_id') && data.origin_id !== null && String(data.id) !== String(data.origin_id)
    }

    const getDefaultSelectedDate = () => [
      moment().startOf("week").toDate(),
      new Date(),
    ]
    const hasFilterValue = (value) => {
      if (Array.isArray(value)) return value.length > 0
      if (value === null || value === undefined) return false
      return String(value).trim() !== ''
    }
    const hasTextSearchFilter = () => {
      return hasFilterValue(selectedIdMatrice.value)
        || hasFilterValue(selectedPuntiPrelievo.value)
        || hasFilterValue(selectedClienteRappresentante.value)
    }
    const maxDate = ref(new Date())
    const rappresentante = ref({
      cod_fiscale:'',
      name: '',
      phone: '',
      mobile: null,
      email: '',
      pec: '',
      toponimo: null,
      address:'',
      civico: '',
      cap: '',
      selectedDistrict:null,
      selectedCity: null,
      cityId: 0,
      id_existent: '',
      contatto_id:''
    })
    const stati_precheck = ref()
    const stati = ref([
      { id:0, name:'pre-validazione' },
      { id:1, name:'in validazione' },
      { id:2, name:'in attivazione' },
      { id:14, name:'in attesa validazione'},
      { id:3, name:'ko documenti' },
      { id:6, name:'contratto ok' },
      { id:7, name:'caricato con ko' },
      { id:8, name:'annullato' },
      { id:9, name:'bloccato' },
      { id:11, name:'standby' },
      { id:13, name:'Annullato TIMOE/TIMG' }
    ]);
    const totali = ref({})
    const loadingFilename = ref(false)
    const newFilesView = ref([]);
    const expandedRows = ref([]);
    const links = ref([])
    const op = ref();
    const confirmDeleteRow = ref(false)
    const row_in_delete = ref()
    const op_annulla_contratto = ref()
    const matrice_da_annullare = ref()
    const motivazioni = ref([])
    const resetMotivazioni = () => {
      motivazioni.value = []
    }
    
    const op_modifiche = ref();

    const periodi = ref([])
    const op_richiesta_modifiche = ref();

    const loaded_sign_data = ref(false)
    const sign_data = ref([])
    const sign_data_copy = ref([])
    const changed_sign_data = ref([])

    const requiredDocuments = ref([])
    const missingDocuments = ref([])
    const remiOption = ref([])
    const dialogModificaAgenteFirmatario = ref(false)
    const dataDialogModificaAgenteFirmatario = ref({
      id: null,
      agente: null,
      new_agente: null,
      possibleNewAgenti: []
    })
    const names_pratiche = ref([
      {name: 'VOLTURA', prop: 'v'},
      {name: 'SUBENTRO', prop: 's'},
      {name: 'ATTIVAZIONE SU PREPOSATO', prop: 'ap'}
    ])
    const dataDialogDeletePP = ref({
      matrice: {id: null},
      pps: [],
      dialog: false,
      note: ''
    })

    const resetDataDialogDeletePP = () => {
      dataDialogDeletePP.value = {
        matrice: {id: null},
        pps: [],
        dialog: false
      }
      motivazioni.value = []
    }

    const openDialogDeletePP = async (data) => {
      resetDataDialogDeletePP()
      await getMotivazioniAnnullamento(data.cod_stato_caricamento)
      .finally(()=>{
        dataDialogDeletePP.value.matrice = data
        dataDialogDeletePP.value.pps = data.selectedPP.map(pp => {
          return {
            ...pp,
            motivazione_annullamento: null,
            note_annullamento: null
          }
        })
        dataDialogDeletePP.value.dialog = true
      })
    }

    const canViewDeletePP = () => {
      return currentUser.value.role == roles.admin.role && dataDialogDeletePP.value.pps.length > 0 && !dataDialogDeletePP.value.pps.some(pp => pp.motivazione_annullamento === null)
    }
    
    const deletePP = async () => {
      if (dataDialogDeletePP.value.matrice.count_pps == dataDialogDeletePP.value.pps.length) {
        toast.add({severity: 'danger', detail: 'Non è possibile eliminare tutte le forniture di un caricamento'})
        return 
      }

      loading.value = true

      const forniture = {
        ee: dataDialogDeletePP.value.pps.filter(pp => pp.pod).map(pp => {
          return {
            id: pp.id,
            id_type_annullamento: pp.motivazione_annullamento.id
          }
        }),
        gas: dataDialogDeletePP.value.pps.filter(pp => pp.pdr).map(pp => {
          return {
            id: pp.id,
            id_type_annullamento: pp.motivazione_annullamento.id
          }
        })
      }

      let fd = {
        id_matrice: dataDialogDeletePP.value.matrice.id,
        is_complete: dataDialogDeletePP.value.matrice.is_complete,
        note_aggiuntive: dataDialogDeletePP.value.note ?? '',
        forniture: forniture
      }
      
      await service.sendDeleteContratto(fd)
      .then((res)=>{
        let severity = !res.items.success ? 'warn' : 'success' 
        let detail = res.items.message
        toast.add({severity:severity, summary:'', detail: detail, life: 5000})
      })
      .finally(()=> {
        Promise.all([
          getData(false)
        ])
        .finally(()=>{
          loading.value = false
          resetDataDialogDeletePP()
        })
      })
    }

    const agente_offerta = ref({})

    const caricamenti_pk_ko = ref([])
    const loaded_caricamenti_pk_ko = ref(false)

    const openDialogModificaAgenteFirmatario = async (caricamento) => {      
      loading.value = true
      dataDialogModificaAgenteFirmatario.value.id = caricamento.id
      await service.getAgenti()
      .then((res)=>{
        dataDialogModificaAgenteFirmatario.value.agente = res.items.filter(item => item.id == caricamento.agente_id)[0]
        dataDialogModificaAgenteFirmatario.value.possibleNewAgenti = res.items.filter(item => item.id != caricamento.agente_id)
      }).finally(()=>{
        loading.value = false
        dialogModificaAgenteFirmatario.value = true
      })
    }
    const deleteDataDialogModificaAgenteFirmatario = () => {
      dialogModificaAgenteFirmatario.value = false
      dataDialogModificaAgenteFirmatario.value = {
        id: null,
        agente: null,
        new_agente: null,
        possibleNewAgenti: []
      }
    }

    const saveNewAgenteFirmatario = async () => {      
      const data = {
        id: dataDialogModificaAgenteFirmatario.value.id,
        old_agente: dataDialogModificaAgenteFirmatario.value.agente.name,
        old_agente_id: dataDialogModificaAgenteFirmatario.value.agente.id,
        new_agente: dataDialogModificaAgenteFirmatario.value.new_agente.name,
        new_agente_id: dataDialogModificaAgenteFirmatario.value.new_agente.id,
      }
      await service.saveNewAgenteFirmatario(data)
      .then((res)=>{
        let severity = res.item.success ? 'success' : 'warn'
        let detail = res.item.msg
        toast.add({severity: severity, detail: detail, life: 5000})
        if (res.item.success) {
          let index_matrice = items.value.findIndex(item => item.id == dataDialogModificaAgenteFirmatario.value.id)
          if (index_matrice > -1) {
            items.value[index_matrice].agente = dataDialogModificaAgenteFirmatario.value.new_agente.name
            items.value[index_matrice].agenteMaster = dataDialogModificaAgenteFirmatario.value.new_agente.agente_master  
            items.value[index_matrice].agente_id = dataDialogModificaAgenteFirmatario.value.new_agente.id
          }
        }
      }).finally(()=>{
        deleteDataDialogModificaAgenteFirmatario()
        loading.value = false
      })
    }
    const showModalAnnullamento = ref(false)
    const setDataAnnullamento = async (data) => {
      matrice_da_annullare.value = data

      await onRowExpand({data: matrice_da_annullare.value})

      await getMotivazioniAnnullamento(data.cod_stato_caricamento)
      .finally(()=>{
        showModalAnnullamento.value = true
      })
    }

    const getMotivazioniAnnullamento = async (cod_stato_caricamento) => {
      loading.value = true
      await service.getMotivazioniAnnullamento(cod_stato_caricamento, currentUser.value.role == roles.agent.role)
      .then((res) => {
        motivazioni.value = res.items
      })
      .finally(()=>{
        loading.value = false
      })
    }

    const toggle = async (event, type_op, data = null) => {
      switch (type_op) {
        case 'link':
          op.value.toggle(event);
          
          break;
        case 'richiesta_modifiche':
          op_richiesta_modifiche.value.toggle(event);

          break;
        case 'annulla_contratto':
          matrice_da_annullare.value = data
          loading.value = true
          await service.getMotivazioniAnnullamento(data.cod_stato_caricamento)
          .then((res) => {
            motivazioni.value = res.items
          })
          .finally(()=>{
            loading.value = false
            op_annulla_contratto.value.toggle(event);
          })  
          break;
        default:
          op_modifiche.value.toggle(event);

          break;
      }
    }
    const getPeriodiFtContratto = () => {
      service.getPeriodi()
      .then((res) => {
        periodi.value = res.items
      })
    }

    const hideOverlay = () => {
      loaded_sign_data.value = false
    }

    const cancelDeletion = () => {
      confirmDeleteRow.value = false
      row_in_delete.value = null
    }
    const hideOverlayAnnullaContratto = () => {
      matrice_da_annullare.value = null
      resetMotivazioni()
      showModalAnnullamento.value = false
    }

    const createSignedContract = (dati) => {
      matrice_for_signed_contract.value = dati
      data_firma_cartaceo.value = new Date()

      requiredDocuments.value.push({
        name:'Contratto Cartaceo',
        ref:'ctr',
        files:[],
        multiple:false
      })
      if (dati.pratica != null) {
          Object.keys(dati.forniture).forEach(type => {
            let type_device = type == 'ee' ? 'pod' : 'pdr'
            dati.forniture[type].forEach(row => {
              requiredDocuments.value.push({
                name:`${dati.pratica} ${row[type_device]}`,
                ref:row[type_device],
                files:[],
                multiple:false
              })            
            })
          })
        }
      insertSignedContractDialog.value = true
    }

    const insertSignedContract = async (dati) => {
      if (!dati.loaded_details) {
        loading.value = true
        let event = {data:dati}
        let res = await onRowExpand(event)
        setTimeout(()=>{
          createSignedContract(res)
          loading.value = false
        }, 3000)

      }else{
        createSignedContract(dati)
      }
    }
    const createMissingDocuments = (dati) => {
      matrice_for_missing_documents.value = dati
      let docs_valid = [
        {prop:'has_documento_identita',name:'DOCUMENTO D\'IDENTITA', code:'di'}
      ]

      if (dati.is_contratto_manuale) {
        docs_valid.push({prop:'has_contratto',name:'CONTRATTO', code:'ctr'})
      }

      if (dati.pratica != null && dati.pratica != 'SWITCH') {
        docs_valid.push({prop:'has_titolo_giust',name:'TITOLO GIUSTIFICATIVO', code:'tg'})
      }

      docs_valid.forEach(doc => {
        if (!dati[doc.prop]) {
          missingDocuments.value.push({
            name:doc.name,
            ref:doc.code,
            files:[],
            multiple:false
          }) 
        }
      })

      let docs_valid_supply = [
        {prop:'has_ft',name:'FATTURA', code:'ft', check: false},
        {prop:'insoluto',name:'CONTABILE DI PAGAMENTO', code:'cp', check: true}      
      ]

      if (dati.pratica != null && dati.pratica != 'SWITCH') {
        let index_name_pratica = names_pratiche.value.findIndex(el => el.name == dati.pratica)
        if (index_name_pratica != -1) {
          let name_prop = names_pratiche.value[index_name_pratica].prop
          docs_valid_supply.push({prop:`has_${name_prop}1`, name:dati.pratica, code:`${name_prop}`, check: false})
        }        
      }

      Object.keys(dati.forniture).forEach(type => {
        let type_device = type == 'ee' ? 'pod' : 'pdr'
        dati.forniture[type].forEach(row => {          
          docs_valid_supply.forEach(doc => {
            if (row[doc.prop] == doc.check) {
              missingDocuments.value.push({
                name:`${doc.name} ${row[type_device]}`,
                ref:doc.code+type+row.id,
                files:[],
                multiple:false
              }) 
            }
          })
        })
      })
      insertMissingDocumentsDialog.value = true
    }

    const insertMissingDocuments = async (dati) => {
      if (!dati.loaded_details) {
        loading.value = true
        let event = {data:dati}
        let res = await onRowExpand(event)
        setTimeout(()=>{
          createMissingDocuments(res)
          loading.value = false
        }, 3000)
      }else{
        createMissingDocuments(dati)
      }
    }

    const onChangeDataFirma = () => {
      delete validationErrors.value.data_firma_cartaceo
    }
    const deleteInsertSignedContract = () => {
      isDisableInput.value = false
      insertSignedContractDialog.value = false
      matrice_for_signed_contract.value = null
      requiredDocuments.value = []
      data_firma_cartaceo.value = null
      vs.value = []
      ctr.value = []
    }

    const deleteInsertMissingDocuments = () => {
      matrice_for_missing_documents.value = null
      isDisableInputMissing.value = false
      insertMissingDocumentsDialog.value = false
      missingDocuments.value = []
    }

    const getRemi = (city, code) => {
      delete remiOption.value[code]
      service.getRemi(city).then((res) => {
        remiOption.value[code] = res.items
      })
    }

    onMounted(() => {
      service.getContractAnimationsEnabled()
      getToponimi()
      getDistricts()
      getPeriodiFtContratto()
      mount(false)
    })
    const mount = async (bypass = true) => {
      selectedSignDate.value = null
      selectedStatus.value = []
      selectedPuntiPrelievo.value = null
      searchedPuntiPrelievo.value = null
      selectedClienteRappresentante.value = null
      searchedClienteRappresentante.value = null
      moment.locale('it')
      selectedDate.value = getDefaultSelectedDate()
      if (bypass) {
        selectedIdMatrice.value = null
      } else {
        selectedIdMatrice.value = route.params.id == '' ? null : parseInt(route.params.id)
      }
      if (selectedIdMatrice.value > 0 && selectedIdMatrice.value != null) {
        changeIdMatrice(selectedIdMatrice.value, false)
      }
  
      
      setResponsive()
      loading.value = true
      getStatiPrecheck()
      const promises = [
        getData(bypass, false),
        getAllTipoClient(),
        getOfferte(),
      ]
      Promise.all(promises)
      .finally(() => {
        loading.value = false
      })
      files.value = []
      getCaricamentiPKko()
    }

    const getCaricamentiPKko = async () => {
      loaded_caricamenti_pk_ko.value = false
      await service.getCaricamentiPKko()
      .then((res) => {
        if (res.items.length > 0) {
          caricamenti_pk_ko.value = res.items
          loaded_caricamenti_pk_ko.value = true
        } else {
          loaded_caricamenti_pk_ko.value = false
        }
      })
    }

    const filterCaricamenti = () => {
      selectedIdMatrice.value = caricamenti_pk_ko.value.join(',')
      changeIdMatrice(selectedIdMatrice.value)
    }

    // const esportaEsiti = (evt) => {
    //   let list = []
    //   let filtered = [...items.value]

    //   Object.keys(filters.value).forEach((filtro) => {
    //     if (filtro != 'global') {
    //       if (filters.value[filtro].value != null) {
    //         filtered = filtered.filter(item => item[filtro] == filters.value[filtro].value)
    //       }
    //     }
    //   })
    //   let types = [
    //     {type:'ee', name:'Energia'},
    //     {type:'gas', name:'Gas'},
    //     {type:'ee/gas', name:'Energia & Gas'}
    //   ]
    //   if (filtered.length) {

    //     let i = 0
    //     filtered.forEach((item) => {
    //       Object.keys(item.forniture).forEach((type_supplies) => {
    //         let type_device = type_supplies == 'ee' ? 'pod' : 'pdr'
    //         item.forniture[type_supplies].forEach((supply, index) => {
    //           list[i] = {
    //             'Id caricamento':item.id,
    //             'Stato caricamento': stati.value.find(stato => stato.id == item.cod_stato_caricamento).name,
    //             'Data caricamento':moment(item.data_caricamento).format("DD-MM-YYYY HH:mm:ss"),
    //             'Data firma':item.data_firma ? moment(item.data_firma).format("DD-MM-YYYY HH:mm:ss") : null,
    //             'Firmato':item.is_complete ? 'Si' : 'No',
    //             'Pratica': item.pratica,
    //             'Cliente':supply.denominazione_cliente,
    //             'Fornitura':supply[type_device],
    //             'Codice esito PK':supply.cod_esito_precheck,
    //             'Dettaglio esito PK':supply.dettaglio_esito_precheck,
    //             'Data risposta PK':supply.data_risposta_pk ? moment(supply.data_risposta_pk).format("DD-MM-YYYY HH:mm:ss") : null
    //           }
    //           i++
    //         })
    //       })
    //     })
    //     const worksheet = XLSX.utils.json_to_sheet(list);
  
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Matrice");
  
    //     let array_width = []
    //     for (let index = 0; index < 12; index++) {
    //       array_width[index] = {wch:15}
    //     }
    //     worksheet["!cols"] = array_width
  
    //     let data = new Date()
    //     let giorno = data.getDate()
    //     let mese = data.getMonth() + 1
    //     let anno = data.getFullYear()
  
    //     XLSX.writeFile(workbook, `ExportMatrici_${giorno}_${mese}_${anno}.xlsx`, { compression: true });
    //   }else{
    //     toast.add({severity:'warn', summary:'Attenzione', detail: 'Non ci sono matrici da scaricare', life:5000});
    //   }
    // }

    const matchesDataTableFilter = (item, field, filter) => {
      if (filter.value == null) {
        return true
      }

      if (filter.matchMode == FilterMatchMode.CONTAINS) {
        return String(item[field] ?? '').toLowerCase().includes(String(filter.value).toLowerCase())
      }

      return item[field] == filter.value
    }

    const getFilteredCaricamenti = () => {
      return items.value.filter(item => {
        return Object.keys(filters.value).every((filtro) => {
          if (filtro == 'global') {
            return true
          }

          return matchesDataTableFilter(item, filtro, filters.value[filtro])
        })
      })
    }

    const esportaEsiti = async (evt) => {
      let filtered = getFilteredCaricamenti()
    
      if (filtered.length) {
        let ids = []
        filtered.forEach(item => {
          ids.push(item.id)
        })
  
        loading.value = true
  
        await service.downloadExportEsiti(JSON.stringify(ids))
        .finally(()=> {
          loading.value = false
        })
      }else{
        toast.add({severity: 'warn', detail: 'Non ci sono caricamenti da esportare con i filtri selezionati', life: 5000})
      }
    }

    // const esportaCaricamenti = (evt) => {
    //   console.log(evt, items.value);
    //   let list = []
    //   let filtered = [...items.value]

    //   Object.keys(filters.value).forEach((filtro) => {

    //     if (filtro != 'global') {
    //       if (filters.value[filtro].value != null) {
    //         filtered = filtered.filter(item => item[filtro] == filters.value[filtro].value)
    //       }
    //     }
    //   })
    //   let types = [
    //     {type:'ee',name:'Energia'},
    //     {type:'gas',name:'Gas'},
    //     {type:'ee/gas',name:'Energia & Gas'}
    //   ]
    //   if (filtered.length) {
    //     filtered.forEach((item, index) => {
    //       list[index] = {
    //         'Id caricamento':item.id,
    //         'Stato caricamento': stati.value.find(stato => stato.id == item.cod_stato_caricamento).name,
    //         'Agente':item.agente,
    //         'Rappresentante':item.rappresentante,
    //         'Cliente':item.cliente,
    //         'Tipo cliente':typesClient.value.find(type => type.id == item.cod_type_client).name,
    //         'Data caricamento':moment(item.data_caricamento).format("DD-MM-YYYY HH:mm:ss"),
    //         'Data firma':item.data_firma ? moment(item.data_firma).format("DD-MM-YYYY HH:mm:ss") : null,
    //         'Firmato':item.is_complete ? 'Si' : 'No',
    //         'Tipo Firma':item.is_contratto_manuale ? 'Cartaceo' : 'Digitale',
    //         'Tipo forniture':types.find(type => type.type == item.type).name,
    //         'Totale forniture':Number(item.total_rows),
    //         'Pratica': item.pratica
    //       }
    //     })
    //     const worksheet = XLSX.utils.json_to_sheet(list);
  
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Matrice");
  
    //     let array_width = []
    //     for (let index = 0; index < 12; index++) {
    //       array_width[index] = {wch:15}
    //     }
    //     worksheet["!cols"] = array_width
  
    //     let data = new Date()
    //     let giorno = data.getDate()
    //     let mese = data.getMonth() + 1
    //     let anno = data.getFullYear()
  
    //     XLSX.writeFile(workbook, `ExportMatrici_${giorno}_${mese}_${anno}.xlsx`, { compression: true });
    //   }else{
    //     toast.add({severity:'warn', summary:'Attenzione', detail: 'Non ci sono matrici da scaricare', life:5000});
    //   }  
    // }

    const esportaCaricamenti = async (evt, typeDetails = 'all') => {
      let filtered = getFilteredCaricamenti()
    
      if (filtered.length) {
        let ids = []
        filtered.forEach(item => {
          ids.push(item.id)
        })
  
        loading.value = true
  
        await service.downloadExport(JSON.stringify(ids), typeDetails)
        .finally(()=> {
          loading.value = false
        })
      }else{
        toast.add({severity: 'warn', detail: 'Non ci sono caricamenti da esportare con i filtri selezionati', life: 5000})
      }
    }

    const setResponsive = () => {
      window.addEventListener('resize', () => {
        windowSize.value = window.innerWidth
      })
    }

    const getStatiPrecheck = () => {
      service.getStatiPrecheck()
      .then((res) => {
        stati_precheck.value = res.items
      })
    }
    const getSignLink = async (id) => {
      await service.getSignLink(id)
      .then((res) => {
        links.value[id] = res.items
      })
    }
    const getSignData = async (id) => {
      await service.getSignData(id)
      .then((res) => {
        sign_data.value[id] = JSON.parse(JSON.stringify(res.items))
        sign_data_copy.value[id] = JSON.parse(JSON.stringify(res.items))
        changed_sign_data.value[id] = true
        loaded_sign_data.value = true
      })
    }

    const getStatoFirmaContratto = (data) => {
      const formatDate = (date) => date && moment(date).isValid()
        ? ` il ${moment(date).format('DD/MM/YYYY HH:mm')}`
        : ''
      const signData = sign_data_copy.value[data.id] || {}
      const firmatario = [signData.email, signData.contatto].filter(Boolean).join(' - ')
      const destinatario = firmatario ? ` a ${firmatario}` : ''
      const autoreFirma = firmatario ? ` da ${firmatario}` : ''

      switch (Number(data.cod_status_pratica)) {
        case 1:
          return `CREATA${formatDate(data.data_creazione_richiesta_firma)}`
        case 2:
          return `INVIATA${destinatario}${formatDate(data.data_invio_richiesta_firma)}`
        case 3:
          return `FIRMATA${autoreFirma}${formatDate(data.data_firma_richiesta_firma)}`
        case 4:
          return `ANNULLATA${formatDate(data.data_annullamento_richiesta_firma)}`
        default:
          return 'NON INVIATA'
      }
    }

    const isDisabledSendSignData = (id) => {
      if (sign_data_copy.value[id].contatto == '' || sign_data_copy.value[id].email == '') {
        return true
      }
      sign_data_copy.value[id].contatto = sign_data_copy.value[id].contatto.replace('-','')
      const json1 = JSON.stringify(sign_data.value[id]);
      const json2 = JSON.stringify(sign_data_copy.value[id]);

      return json1 === json2
    }

    const setChangedSignData = (id) => {
      changed_sign_data.value[id] = isDisabledSendSignData(id)
    }

    const copyLink = (link) => {
      navigator.clipboard.writeText(link).then(() => {
        toast.add({severity:'success', summary:'', detail: `Link copiato negli appunti`, life: 5000});
      }, () => {
        console.log('Errore durante la copia del valore negli appunti');
      });
    }

    const sendSignData = (id) => {
      loading.value = true

      let fd = new FormData();
      fd.append('matrice_id', JSON.stringify(id));

      fd.append('sign_data', JSON.stringify(sign_data_copy.value[id]));

      service.sendSignData(fd)
      .then((res)=>{
        if (res.items) {
          toast.add({severity:'success', summary:'Modifica eseguita', detail: `Il cliente può firmare con i nuovi dati`, life: 10000});
        } else {
          toast.add({severity:'warn', summary:'Modifica fallita', detail: `Errore nella modifica dei dati del firmatario`, life: 10000});
        }
        getData()
      })
      .finally(()=> {
        loading.value = false
      })
    }
    const sendRequestSignData = (id) => {
      loading.value = true

      let fd = new FormData();
      fd.append('matrice_id', JSON.stringify(id));

      fd.append('sign_data', JSON.stringify(sign_data_copy.value[id]));

      service.sendRequestSignData(fd)
      .then((res)=>{
        let severity = res.items.error ? 'warn' : 'success' 
        let detail = res.items.response
        toast.add({severity:severity, summary:'', detail: detail, life:10000})

        getData()
      })
      .finally(()=> {
        loading.value = false
      })
    }
    
    const onRowExpand = async (event) => {
      let index_item = items.value.findIndex(item => item.id == event.data.id)

      if (!items.value[index_item].loaded_details) {
        loadingFilename.value = true
        const promises = [
          getFileCaricamentoDetail(event.data.id),
          getDetailsCaricamento(event.data.id)
        ]
        if (!(event.data.agente_id in agente_offerta.value)) {
          promises.push(getOfferteAgent(event.data.agente_id))
        }

        return Promise.all(promises)
        .then(async ()=>{
          if (!event.data.is_contratto_manuale) {
            const signPromises = [getSignData(event.data.id)]
            if(currentUser.value.role == roles.admin.role || currentUser.value.can_view_otp_sign_link){
              signPromises.push(getSignLink(event.data.id))
            }
            await Promise.all(signPromises)
          }
          items.value[index_item].loaded_details = true
          return items.value[index_item]
        })
        .finally(()=>{
          loadingFilename.value = false
        })
      }
    }
    const getOfferteAgent = async (agente_id) => {
      await service.getOfferteAgent(agente_id)
      .then((res) => {
        if (res.items.length > 0) {
          agente_offerta.value[agente_id] = {
            ee: [],
            gas: []
          }
          agente_offerta.value[agente_id].ee = res.items.filter((offerta) => offerta.tipologia === 1)
          agente_offerta.value[agente_id].gas = res.items.filter((offerta) => offerta.tipologia === 2)
        }
      })
    }
    // const hasParametro = () => {
    //   if (parametroGet) {
    //     let data = items.value.filter(el => el.id == parametroGet)
    //     filters.value.id.value = [parseInt(parametroGet)]
    //     if (!data[0].is_complete_rapp) {
    //       insertDataRapp(data[0])
    //     }else{
    //       getData()
    //     }
    //   }
    // }
    // const uploadNewFile = async (event, id) => {
    //   loading.value = true
    //   service.uploadNewFile(event.files, id)
    //   .then((res)=>{
    //     if (res.success) {
    //       toast.add({severity:'success', summary:'Importazione eseguita', detail: `File caricati correttamente`, life: 10000});
    //     } else {
    //       toast.add({severity:'warn', summary:'Importazione fallita', detail: `Errore nel caricamento dei file`, life: 10000});
    //     }
    //   })
    //   .finally(()=> {
    //     getData()
    //     loading.value = false
    //   })
    // }
    const uploadNewFile = async (event, id) => {
      isDisableInputMissing.value = true
      loading.value = true
      let fd = new FormData();
      fd.append('matrice_id', JSON.stringify(id));
      
      missingDocuments.value.forEach((doc)=>{
        for (let i = 0 ; i < doc.files.length ; i++) {
          fd.append(`${doc.ref}[]`, doc.files[i]); 
        }
      })

      service.uploadNewFile(fd)
      .then((res)=>{
        if (res.success) {
          toast.add({severity:'success', summary:'Importazione eseguita', detail: `File caricati correttamente`, life: 10000});
        } else {
          toast.add({severity:'warn', summary:'Importazione fallita', detail: `Errore nel caricamento dei file`, life: 10000});
        }
      })
      .finally(()=> {
        deleteInsertMissingDocuments()
        getData()
        loading.value = false
      })
    }
    const setFirmato = async (event, id) => {
      isDisableInput.value = true
      loading.value = true
      let data_firma = setData(data_firma_cartaceo.value)

      let fd = new FormData();
      fd.append('matrice_id', JSON.stringify(id));
      fd.append('data_firma', JSON.stringify(data_firma));
      
      requiredDocuments.value.forEach((doc)=>{
        for (let i = 0 ; i < doc.files.length ; i++) {
          fd.append(`${doc.ref}[]`, doc.files[i]); 
        }
      })

      service.signedContract(fd)
      .then((res)=>{
        if (res.items) {
          toast.add({severity:'success', summary:'Importazione eseguita', detail: `Contratto caricato correttamente`, life: 10000});
        } else {
          toast.add({severity:'warn', summary:'Importazione fallita', detail: `Errore nel caricamento dei file`, life: 10000});
        }
        deleteInsertSignedContract()
        getData()
      })
      .finally(()=> {
        loading.value = false
      })
    }

    const getFileCaricamentoDetail = async (id) => {
      await service.getFileCaricamento(id)
      .then((res) => {
        newFilesView.value[id] = res.items
      })
    }
    const getDetailsCaricamento = async (id) => {
      let index_item = items.value.findIndex(item => item.id == id)
      let fd = new FormData()
      fd.append('matrice_id', JSON.stringify(id));

      await service.getDetailsCaricamento(fd)
      .then((res) => {
        Object.keys(res.items).forEach(item => {
          if (item == 'note_ko') {
            items.value[index_item][item] = []
            Object.keys(res.items[item]).forEach(nota => {
              items.value[index_item][item].push(res.items[item][nota])
            })
          }else{
            items.value[index_item][item] = res.items[item]
          }
        })
      })

    }  
    const resetTextSearchFilters = () => {
      selectedIdMatrice.value = null
      searchedIdMatrice.value = null
      selectedPuntiPrelievo.value = null
      searchedPuntiPrelievo.value = null
      selectedClienteRappresentante.value = null
      searchedClienteRappresentante.value = null
    }
    const resetDefaultFiltersExcept = (activeFilter) => {
      if (activeFilter !== 'stato_caricamento') {
        selectedStatus.value = []
      }
      if (activeFilter !== 'data_caricamento') {
        selectedDate.value = getDefaultSelectedDate()
      }
      if (activeFilter !== 'data_firma') {
        selectedSignDate.value = null
      }
    }
    const resetTextSearchAndDefaultFilters = (activeFilter) => {
      const shouldResetDefaults = hasTextSearchFilter()
      resetTextSearchFilters()
      if (shouldResetDefaults) {
        resetDefaultFiltersExcept(activeFilter)
      }
    }

    const onSelectedStatus = () => {
      selectedStatusFilterChanged.value = true
      resetTextSearchAndDefaultFilters('stato_caricamento')
    }
    const onSelectedStatusHide = async () => {
      if (!selectedStatusFilterChanged.value) return
      selectedStatusFilterChanged.value = false
      await getData()
    }
    const onSelectedRemi = (code) => {
      delete validationErrors.value[`remi_${code}`];
    }
    const initData = () => {
      getData(false)
    }
    const onChangeDate = (evt, dependence = false) => {
      if (dependence) {
        selectedSignDate.value = []
        selectedDate.value = []
        return
      }
      resetTextSearchAndDefaultFilters(evt)
      if (evt == 'data_firma') {
        if (selectedSignDate.value == null) {
          getData()
        }else if (selectedSignDate.value[1]) {
          self.refs.calendarRefSign.overlayVisible = false;
          getData()
        }
      } else {
        if (selectedDate.value == null) {
          getData()
        }else if (selectedDate.value[1]) {
          self.refs.calendarRef.overlayVisible = false;
          getData()
        }
      }
    }
    const getSeverity = (cod_stato_caricamento) => {
      switch (cod_stato_caricamento) {
        case 0:
        case 1:
        case 2:
        case 14:

          return 'text-yellow-300';

        case 3:
        case 5:
        case 7:
          return 'p-error';
      
        case 4:
        case 6:
          return 'text-green-400'
      }
    }
    const getSeverityTag = (cod_stato_caricamento) => {
      switch (cod_stato_caricamento) {
        case 0:
        case 1:
        case 2:
        case 14:
          return 'warning';

        case 3:
        case 5:
        case 7:
        case 8:
        case 9:
        case 13:
          return 'danger';
      
        case 4:
        case 6:
          return 'success'
      }
    }
    const getTooltip = (cod_stato_caricamento) => {
      return stati.value.find(stato => stato.id == cod_stato_caricamento).name
    }
    const stato_timoe_timg = ref({
      ee: {
        null: {label: 'PreSwitch non eseguito', has_note: false},
        0: {label: 'TIMOE KO', has_note: true},
        1: {label: 'TIMOE OK', has_note: false}
      },
      gas: {
        null: {label: 'PreSwitch non eseguito', has_note: false},
        0: {label: 'TIMG KO', has_note: true},
        1: {label: 'TIMG OK', has_note: false}
      }
    })
    const isNuovaPosa = (data) => {
      return data?.in_nuova_posa === true
        || data?.in_nuova_posa === 1
        || data?.in_nuova_posa === '1'
    }
    const isNuovaPosaCaricamento = (data) => {
      if (isNuovaPosa(data)) return true

      return Object.values(data?.forniture || {}).some((forniture) => {
        return Array.isArray(forniture) && forniture.some((fornitura) => isNuovaPosa(fornitura))
      })
    }
    const getTipoPraticaLabel = (data) => {
      if (isNuovaPosa(data)) return 'Nuova posa'
      return data?.tipo_pratica || 'Switch'
    }
    const getStatoSwitch = (data) => {
      const nuovaPosa = isNuovaPosa(data)
      const dataInvio = data.data_invio_switch ? ` il ${moment(data.data_invio_switch).format(nuovaPosa ? 'DD/MM/YYYY' : 'DD/MM/YYYY HH:mm')}` : ''
      const dataInvioDa = data.data_invio_switch ? ` dal ${moment(data.data_invio_switch).format('DD/MM/YYYY HH:mm')}` : ''
      const dataDecorrenza = moment(data.data_decorrenza_switch).isValid()
        ? ` per ${moment(data.data_decorrenza_switch).format('MMMM YYYY')}`
        : ''
      const dataDecorrenzaNuovaPosa = moment(data.data_decorrenza_switch || data.data_decorrenza).isValid()
        ? ` per ${moment(data.data_decorrenza_switch || data.data_decorrenza).format('MMMM YYYY')}`
        : ''
      const dataAggiornamento = data.data_aggiornamento ? moment(data.data_aggiornamento).format('DD/MM/YYYY HH:mm') : ''
      const hasProtocollo = String(data.protocollo || '').trim() !== '' || data.note_switch === "CAMBIO CC"
      const statoEseguito = nuovaPosa || hasProtocollo
        ? `Switchato${dataInvio}${nuovaPosa ? dataDecorrenzaNuovaPosa : dataDecorrenza}`
        : `Cambio CTE. Pdp in fornitura da ${moment(data.data_decorrenza_switch).format('MMMM YYYY')}`

      const stato_switch = {
        null: nuovaPosa ? 'Nuova posa non avviata' : `Non è presente nessuno switch`,
        1: nuovaPosa ? `Nuova posa pronta dal ${moment(data.data_ready_to_switch).format('DD/MM/YYYY HH:mm')}` : `Switchabile dal ${moment(data.data_ready_to_switch).format('DD/MM/YYYY HH:mm')}`,
        2: statoEseguito,
        3: `${nuovaPosa ? 'Nuova posa annullata' : 'Switch annullato'} il ${dataAggiornamento}`,
        4: nuovaPosa ? `Nuova posa da gestire dal ${dataAggiornamento}` : `Pratica dal ${dataAggiornamento}`,
        5: `Annullato Timoe/Timg il ${dataAggiornamento}`,
        6: `In attesa di accettazione ${nuovaPosa ? 'nuova posa' : 'switch'}${dataInvioDa}`
      }
      return stato_switch[data.cod_state_switch]
    }
    const getEsitoTimoeTimg = (data, type) => {
      let esito = stato_timoe_timg.value[type]
      let prop = type == 'ee' ? 'timoe' : 'timg'
      let prop_motivazione = type == 'ee' ? 'motivazione_timoe_ko' : 'motivazione_timg_ko'      
      let result = esito[data[`${prop}_ok`]].label
      if (data.cod_state_switch == 2 && data[`${prop}_ok`] == null) {
        result = 'In attesa ' + prop
      }
      return result + (esito[data[`${prop}_ok`]].has_note ? ` - ${data[prop_motivazione]}` : '')
    }
    const getEsitoPrecheck = (data) => {
      return data.precheck != 2 ? stati_precheck.value.find(stato => stato.code == data.precheck).description : data.dettaglio_esito_precheck
    }
    const goToPratiche = () => {
      router.push({path: '/precheck-iv'})
    }
    const goToUpdateContract = (id) => {
      return router.push({path: `/multisito/step-info/${id}`})
    }
    const detachAndUpdateContract = async (data) => {
      if (loading.value) return
      loading.value = true
      try {
        if (data.cod_richiesta_firma != null) {
          await service.detachContractSignature(data.id)
          data.cod_richiesta_firma = null
          data.cod_status_pratica = null
          data.has_contract_document = 0
        }
        await goToUpdateContract(data.id)
      } catch (error) {
        toast.add({ severity: 'error', detail: error.response?.data?.message || 'Impossibile sganciare la richiesta di firma', life: 7000 })
      } finally {
        loading.value = false
      }
    }
    const getAllTipoClient = async () => {
      await service.getAllTipoClient().then((res) => {
        typesClient.value = res.items
      })
    }
    const getOfferte = async () => {
      await service.getOfferte()
      .then((res) => {
        offerte.value = res.items
        selectedOfferte.value = offerte.value
      })
    }

    const onTodayClick = (evt) => {
      if (evt == 'data_firma') {
        selectedSignDate.value[1] = selectedSignDate.value[0]
      } else {
        selectedDate.value[1] = selectedDate.value[0]
      }
      onChangeDate(evt)
    }

    const removeFilters = () => {
      mount()
    }
    const resetOptionFilter = () => {
      items.value = []
      authors.value = [];
      masters.value = [];
      incaricati.value = []
      rapps.value = [];
      clients.value = [];
      ids.value = [];
      cf_piva.value = []
      forniture.value = []
    }

    const waitForTableRender = async () => {
      await nextTick()
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)))
    }

    const getData = async (bypass = true, manageLoading = true) => {     
      if (bypass && selectedIdMatrice.value != '' && selectedIdMatrice.value != null && selectedIdMatrice.value == searchedIdMatrice.value) return
      if (bypass && selectedPuntiPrelievo.value != '' && selectedPuntiPrelievo.value != null && selectedPuntiPrelievo.value == searchedPuntiPrelievo.value) return
      if (bypass && selectedClienteRappresentante.value != '' && selectedClienteRappresentante.value != null && selectedClienteRappresentante.value == searchedClienteRappresentante.value) return
      loaded.value = false
      resetOptionFilter()
      if (manageLoading) {
        loading.value = true
      }
      let fd = new FormData();
      let range = []
      let rangeSign = []

      if (selectedDate.value) {
        selectedDate.value.forEach((data) => {
          let giorno = data.getDate() 
          giorno = giorno.toString().padStart(2,'0')
          let mese = data.getMonth()+1
          mese = mese.toString().padStart(2,'0')
          let anno = data.getFullYear() 
          data = `${anno}-${mese}-${giorno}`
          range.push(data)
        })        
      }
      fd.append('range', range);
      
      if (selectedIdMatrice.value != '' && selectedIdMatrice.value != null) {
        fd.append('matrice_id', JSON.stringify(getIdMatriceList(selectedIdMatrice.value)))
        searchedIdMatrice.value = selectedIdMatrice.value
      }

      if (selectedPuntiPrelievo.value != '' && selectedPuntiPrelievo.value != null) {
        fd.append('pps', JSON.stringify(getPuntiPrelievoList(selectedPuntiPrelievo.value)))
        searchedPuntiPrelievo.value = selectedPuntiPrelievo.value
      }

      if (selectedClienteRappresentante.value != '' && selectedClienteRappresentante.value != null) {
        fd.append('cliente_rappresentante', JSON.stringify(selectedClienteRappresentante.value))
        searchedClienteRappresentante.value = selectedClienteRappresentante.value
      }

      if (selectedSignDate.value) {
        selectedSignDate.value.forEach((data) => {
          let giorno = data.getDate() 
          giorno = giorno.toString().padStart(2,'0')
          let mese = data.getMonth()+1
          mese = mese.toString().padStart(2,'0')
          let anno = data.getFullYear() 
          data = `${anno}-${mese}-${giorno}`
          rangeSign.push(data)
        })        
      }
      fd.append('rangeSign', rangeSign);
      const filtro = selectedStatus.value.map(stato => stato.id)
      fd.append('filtro', JSON.stringify(filtro))

      await service.getAllCaricamentiMultisito(fd)
      .then((res) => {
        let status = res.res.status
        let data = res.res.data

        if (status == 500) {
          toast.add({severity: 'error', detail:data.message, life: 10000})
        } else {          
          if(!data.success) toast.add({severity: 'warn', detail:data.message, life: 5000})

          items.value = data.caricamenti
          items.value.forEach(item => {
            item.is_complete = Boolean(item.is_complete)
            item.need_pratiche = Boolean(item.need_pratiche)
            item.loaded_details = false
            item.selectedPP = []
          });

          populateAuthorsArray(data.caricamenti)
          populateMastersArray(data.caricamenti)
          populateIncaricatiArray(data.caricamenti)
          populateRappsArray(data.caricamenti)
          populateClientsArray(data.caricamenti)
          populateIdsArray(data.caricamenti)
          populateCfPivaArray(data.caricamenti)
          populateFornitureArray(data.caricamenti)

          filters.value.id.value = null
          
          contatori.value = data.contatori
          if (contatori.value) {
            contatori.value[3] = {
              title: 'Forniture totali',
              totale: contatori.value[1].totale + contatori.value[2].totale,
              firmati: contatori.value[1].firmati + contatori.value[2].firmati,
              non_firmati: contatori.value[1].non_firmati + contatori.value[2].non_firmati
            }
          }
        }
      })
      .finally(async ()=> {
        loaded.value = true
        await waitForTableRender()
        if (manageLoading) {
          loading.value = false
        }
      })
    }
    const updateRapp = (data) => {
      submitted.value = true;
      if (Object.keys(validationErrors.value).length > 0) {
        toast.add({severity:'warn', summary:'Campi Errati', detail: 'Alcuni campi sembrano vuoti o errati', life:3000});
      }else if (validateForm()) {
        loading.value = true
        let fd = new FormData();
        fd.append('rappresentante', JSON.stringify(rappresentante.value));
        fd.append('matrice_id', JSON.stringify(matrice_id.value));
        for (let i = 0 ; i < files.value.length ; i++) {
          fd.append('files[]', files.value[i]); 
        }
        service.updateRapp(fd)
        .then((res) => {
          if (res.item.success) {
            toast.add({severity:'success', summary: 'Successo', detail:`Rappresentante aggiornato correttamente.`});
          } else {
            toast.add({severity:'warn', summary:'Attenzione', detail: `Errore nell'aggiornamento del rappresentante`});
          }
        }).finally(() => {
          deleteChanges()
          showModal.value = false
          loading.value = false
          setTimeout(()=>{
            router.push({path: '/caricamenti-multisito'})
            getData()
          }, 5000)
        })
      }
    }
    const deleteUpdate = async (data) => {
      loading.value = true
      service.deleteUpdate(data)
      .then(()=>{
        getData()
      })
      .finally(() => {
        loading.value = false
        toast.add({severity:'success', summary:'Successo', detail: 'Caricamento eliminato'});
      })
    }
    const deleteChanges = () => {
      rappresentante.value = {
        cod_fiscale:'',
        name: rappresentante.value.name,
        phone: '',
        mobile: null,
        email: '',
        pec: '',
        toponimo: null,
        address:'',
        civico: '',
        cap: '',
        selectedDistrict:null,
        selectedCity: null,
        cityId: 0,
        selectedCityName: '',
      }
      files.value = []
      validationErrors.value = {}
      matrice_id.value = ''
      showModal.value = false
    }
    const insertDataRapp = (data) => {
      getDistricts()
      getToponimi()
      rappresentante.value.cod_fiscale = data.codfis,
      rappresentante.value.name = data.rappresentante,
      rappresentante.value.id_existent = data.rappresentante_id,
      rappresentante.value.contatto_id = data.contatto_id,
      rappresentante.value.mobile = data.cell,
      rappresentante.value.phone = data.tel,
      rappresentante.value.toponimo = data.toponimo,
      rappresentante.value.address = data.indirizzo,
      rappresentante.value.civico = data.civico,
      rappresentante.value.email = data.email,
      rappresentante.value.pec = data.pec,
      rappresentante.value.cap = data.cap,

      showModal.value = true
      matrice_id.value = data.id
    }

    const isCorrect = (is_correct = false) => {
      if (!is_correct) {
        validationErrors.value['mobile'] = true;
      }else{
        delete validationErrors.value['mobile'];
      }
      showModalMobile.value = false;
    }
    const onSelected = (evt, input) => {      
      let value
      if(evt.value){
        value = evt.value
      }else{
        value = evt.target.value
      }
      switch (input) {
        case 'provincia':
          service.getCities(evt.value).then((res) => {
            cities.value = res.items
          })
          break;

        case 'iban_contratto':
          setDatiIban()     
          break;
        default:
          break;
      }
      delete validationErrors.value[input];
    }

    const getDistricts = () => {
      service.getDistricts().then((res) => {
        districts.value = res.items
      })     
    }
    const getToponimi = () =>{
      service.getToponimi().then((res) => {
        toponimi.value = res.items
      })
    }
    const validateForm = () => {
      validationErrors.value = []
      let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let regexPiva = /^[0-9]{11}$/
      let regex_cf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i

      if (rappresentante.value.cod_fiscale == null || rappresentante.value.cod_fiscale.trim() == '') 
        validationErrors.value['cod_fiscale'] = true;
      else
        delete validationErrors.value['cod_fiscale'];

      if (rappresentante.value.cod_fiscale.length == 16) {
        if (!regex_cf.test(rappresentante.value.cod_fiscale)) 
          validationErrors.value['cod_fiscale'] = true;
        else
          delete validationErrors.value['cod_fiscale'];
      } else {
          if (!regexPiva.test(rappresentante.value.cod_fiscale))
            validationErrors.value['cod_fiscale'] = true;
          else
            delete validationErrors.value['cod_fiscale'];            
      }

      if (rappresentante.value.name == null || rappresentante.value.name.trim() == '')
        validationErrors.value['name'] = true;
      else
        delete validationErrors.value['name'];
      
      if (regex_email.test(rappresentante.value.email)) {
        delete validationErrors.value['email'];
      } else {
        validationErrors.value['email'] = true;
      }

      if (rappresentante.value.mobile == null || rappresentante.value.mobile.trim() == '')
        validationErrors.value['mobile'] = true;
      else
        delete validationErrors.value['mobile'];

      if (rappresentante.value.toponimo == null || rappresentante.value.toponimo == '')
        validationErrors.value['toponimo'] = true;
      else
        delete validationErrors.value['toponimo'];
          
      if (rappresentante.value.address == null || rappresentante.value.address.trim() == '')
        validationErrors.value['address'] = true;
      else
        delete validationErrors.value['address'];
      
      if (rappresentante.value.civico == null || rappresentante.value.civico.trim() == '')
        validationErrors.value['civico'] = true;
      else
        delete validationErrors.value['civico'];

      if (!Number.isInteger(parseInt(rappresentante.value.cap)))          
          validationErrors.value['cap'] = true;
      else 
        delete validationErrors.value['cap'];

      if (rappresentante.value.selectedDistrict == '' || rappresentante.value.selectedDistrict == null)
        validationErrors.value['selectedDistrict'] = true;
      else
        delete validationErrors.value['selectedDistrict'];

      if (rappresentante.value.cityId == '' || rappresentante.value.cityId == null)
        validationErrors.value['cityId'] = true;
      else
        delete validationErrors.value['cityId'];

      if (files.value.length == 0) {
        validationErrors.value['files'] = true;
      } else {
        delete validationErrors.value['files'];
      }

      if (files.value.length > 0) {
        let valid = [...files.value].every(file => allowedTypeDoc.includes(file.type.replace(/(.*)\//g, '')), false);
        if (valid) 
          delete validationErrors.value['files'];
        else
          validationErrors.value['files'] = true;
      }

      return !Object.keys(validationErrors.value).length;

    }

    const populateDatesFirmaArray = (items) => {
      let dates = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.data_firma) {
            //moment(data.data_firma).format('DD-MM-YYYY HH:mm')
            dates.push(moment(el.data_firma).format('YYYY-MM-DD'))
          }
        });
        dates_firma.value = [...new Set(dates)];
      }
    }

    const populateAuthorsArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.agente) {
            list.push(el.agente)
          }
        });
        // authors.value = [...new Set(list)];

        let list_agent = [...new Set(list)];
        list_agent.forEach(agent => {
          authors.value.push({name:agent})
        })
      }
    }
    const populateMastersArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.agenteMaster) {
            list.push(el.agenteMaster)
          }
        });
        // authors.value = [...new Set(list)];

        let list_agent = [...new Set(list)];
        list_agent.forEach(agent => {
          masters.value.push({name:agent})
        })
      }
    }
    const populateIncaricatiArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.agenteIncaricato) {
            list.push(el.agenteIncaricato)
          }
        });
        // authors.value = [...new Set(list)];

        let list_agent = [...new Set(list)];
        list_agent.forEach(agent => {
          incaricati.value.push({name:agent})
        })
      }
    }
    const populateRappsArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.rappresentante) {
            list.push(el.rappresentante)
          }
        });

        let list_rapp = [...new Set(list)];
        list_rapp.forEach(rapp => {
          rapps.value.push({name:rapp})
        })
      }

    }
    const populateClientsArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.cliente) {
            let els = el.cliente.split(', ')
            els.forEach(element => {
              list.push(element)
            });
          }
        });

        let list_client = [...new Set(list)];
        list_client.forEach(client => {
          clients.value.push({name:client})
        })
      }
      clients.value.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
      });
    }
    const populateIdsArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.id) {
            list.push(el.id)
          }
        });
        let list_ids = [...new Set(list)];
        list_ids.forEach(id => {
          ids.value.push({key:id})
        })
      }
    }
    const populateCfPivaArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.cf_piva_clienti) {
            let els = el.cf_piva_clienti.split(', ')
            els.forEach(element => {
              list.push(element)
            });
          }
        });
        let list_ids = [...new Set(list)];
        list_ids.forEach(id => {
          cf_piva.value.push({key:id})
        })
      }
    }
    const populateFornitureArray = (items) => {
      let list = []
      if (items.length > 0) {
        items.forEach(el => {
          if (el.pps) {
            let els = el.pps.split(', ')
            els.forEach(element => {
              list.push(element)
            });
          }
        });
        let list_ids = [...new Set(list)];
        list_ids.forEach(id => {
          forniture.value.push({key:id})
        })
                
        forniture.value.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
      });
      }
    }
    const rowClass = (data) => {      
      if (data.caricato === 0) return 'bg-warning'
      if (data.caricato === 1) return 'bg-success text-danger-contrast'
      if (data.caricato === 2) return 'bg-danger text-danger-contrast'
    }


    const handleFileUpload = (evt) => {
      files.value = self.refs.file.files;
      delete validationErrors.value['files'];
      delete validationErrors.value['moduli'];
      delete validationErrors.value['type'];
      delete validationErrors.value['typeModuli'];
    };

    const uploadNewMatrice = async () => {
      submitted.value = true
      if (validateFormNewMatrice()) {
        loading.value = true
        service.uploadNewMatrice(
          typeMatrice.value, 
          fileToUpload.value, 
          selectedTypeClient.value, 
          isIvaAgevolata.value, 
          selectedOfferte.value
        )
        .then((res) => {
          if (res.items.success) {
            toast.add({severity:'success', summary:'Successo', detail: 'Matrice caricata'});
          } else {
            toast.add({severity:'error', summary:'Attenzione', detail: res.items.msg});
          }
        })
        .finally(()=> {
          matriceUploadKey.value = Date.now();
          loading.value = false
        })
      }
    };

    const uploadMatrice = async (event, data) => {
      loading.value = true
      service.uploadMatriceCaricata(data.id, event.files)
      .then((res) => {
        if (res.items.success) {
          toast.add({severity:'success', summary:'Successo', detail: 'Matrice aggiornata'});
        } else {
          toast.add({severity:'error', summary:'Attenzione', detail: res.items.msg});
        }
      })
      .finally(()=> {
        matriceUploadKey.value = Date.now();
        loading.value = false
      })
        
    };

    const downloadMatrice = (data) => {
      loading.value = true
      service.downloadMatriceCaricata(data.id)
      .finally(()=> {
        loading.value = false
      })
    }

    const downloadsMatrici = () => {
      let isSelectedNotSigned = selectedItems.value.some(el => el.is_complete == 0)
      selectedItems.value = selectedItems.value.filter(el => el.is_complete == 1)
      if (isSelectedNotSigned) {
        toast.add({severity:'warn', summary:'Attenzione', detail: 'Alcune Matrici rimosse perchè non firmate', life:3000});
        if (selectedItems.value == 0) {
          return;
        }
      }
      loading.value = true
      service.downloadsMatriciCaricate(selectedItems.value)
      .finally(()=> {
        loading.value = false
      })
    }

    // const onMatriceSelected = (evt) => {
    //   if (evt.data.is_complete != 1) {
    //     selectedItems.value = selectedItems.value.filter(item => item.id !== evt.data.id);
    //     toast.add({severity:'warn', summary:'Attenzione', detail: 'Matrice non selezionabile perchè non firmata'});
    //   }
    // }

    const contractPreviewDialog = ref(null)
    const previewMatriceId = ref(null)
    const refreshPreviewSignature = () => getData(false)
    const downloadPreviewContract = () => service.showPdfMatrice(previewMatriceId.value)
    const contractPreviewVisible = ref(false)
    const contractPreviewDocuments = ref([])
    const showPdf = async (data) => {
      if (loading.value) return
      loading.value = true
      contractPreviewDocuments.value = []
      previewMatriceId.value = data.id
      try {
        if (window.innerWidth < 1200) {
          const downloaded = await service.showPdfMatrice(data.id)
          if (downloaded) {
            data.cod_status_pratica = 1
            data.has_contract_document = 1
            contractPreviewVisible.value = true
            await getFileCaricamentoDetail(data.id)
          }
        } else {
          const documents = await service.showPdfMatrice(data.id, true)
          if (documents && documents.length) {
            data.cod_status_pratica = 1
            data.has_contract_document = 1
            contractPreviewDocuments.value = documents
            contractPreviewVisible.value = true
            await getFileCaricamentoDetail(data.id)
          } else {
            toast.add({ severity: 'warn', detail: 'Anteprima del contratto non disponibile. Riprova.' })
          }
        }
      } finally {
        loading.value = false
      }
    }

    const downloadPdf = async (id, name) => {
      loading.value = true
      await service.downloadPdf(id, name)
      .finally(()=> {
        loading.value = false
      })
    }

    const downloadZip = async (id) => {
      loading.value = true
      await service.downloadZip(id)
      .finally(()=> {
        loading.value = false
      })
    }

    const signPdf = (data, event) => {
      if (loading.value) return
      const source = event?.currentTarget?.getBoundingClientRect()
      loading.value = true
      service.signPdfMatrice(data.id)
      .then(async (res)=> {
        if (res.items.success) data.cod_status_pratica = 2
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo': 'Attenzione'
        let detail = res.items.errore
        
        toast.add({severity:severity, summary: summary, detail:detail});
        if (res.items.success) await contractPreviewDialog.value?.finish('signed', source)
      })
      .finally(()=> {
        loading.value = false
        getData()
      })
    }

    const aggiornamentoOnCondition = (id) => {
      loading.value = true
      service.aggiornamentoOnCondition(id)
      .then((res)=> {
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo': 'Attenzione'
        let detail = res.items.errore
        
        toast.add({severity:severity, summary: summary, detail:detail});                            
      })
      .finally(()=> {
        loading.value = false
        initData()
      })
    }
    const forzaCaricamento  = (id) => {
      loading.value = true
      service.forzaCaricamento(id)
      .then((res)=> {
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo': 'Attenzione'
        let detail = res.items.errore
        
        toast.add({severity:severity, summary: summary, detail:detail});                            
      })
      .finally(()=> {
        loading.value = false
        initData()
      })
    }
    const forzaScissionePk  = (id) => {
      loading.value = true
      service.forzaScissionePk(id)
      .then((res)=> {
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo': 'Attenzione'
        let detail = res.items.errore
        
        toast.add({severity:severity, summary: summary, detail:detail});                            
      })
      .finally(()=> {
        loading.value = false
        initData()
      })
    }

    // const onCheckRowMultisito = (i) => {
    //   const targetId = items.value[i].id;


    //   if (selectedItems.value || selectedItems.value.length == 0) {
    //     selectedItems.value.push(items.value[i])
    //   } else {
    //     const isPresent = selectedItems.value.some(item => item.id === targetId);
    //     if (!isPresent) {
    //       selectedItems.value.push(items.value[i])
    //     } 
    //   }
    // }


    const validateFormNewMatrice = () => {
      if (selectedTypeClient.value) {
        delete validationErrors.value['type_client'];
      } else {
        validationErrors.value['type_client'] = true;
      }

      if (typeMatrice.value) {
        delete validationErrors.value['type_matrice'];
      } else {
        validationErrors.value['type_matrice'] = true;
      }

      if (fileToUpload.value.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }

      if (fileToUpload.value.length > 0) {
        let valid = [...fileToUpload.value].every(file => [Object.values(allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }
    const createDataPratiche = (dati) => {
      if (dati.in_review) {
        toast.add({severity:'warn', summary:'Attenzione', detail: 'Modifiche in attesa di revisione', life: 5000});
      } else {
        matrice_pratiche.value = dati
        id_matrice_pratiche.value = dati.id
        is_contratto_manuale.value = dati.is_contratto_manuale
        type_client_pratiche.value = dati.cod_type_client

        let tipi = ['ee', 'gas']
        tipi.forEach(tipo => {
          let tipo_fornitura = tipo == 'ee' ? 'pod' : 'pdr'          
          if (dati.forniture[tipo]) {
            const tipi_pratica = {
              'in_voltura': {name: 'voltura', code: 'v'},
              'in_subentro': {name: 'subentro', code: 's'},
              'in_attivazione_p': {name: 'attivazione su preposato', code: 'ap'}
            }
            for (let index = 0; index < dati.forniture[tipo].length; index++) {
              let row = {};
              unique_cf.value = dati.cod_type_client != 3 ? dati.forniture[tipo][index].cf_cliente : null
              unique_piva.value = dati.cod_type_client != 2 && dati.cod_type_client != 3 ? dati.forniture[tipo][index].piva_cliente : null
              row.id = dati.forniture[tipo][index].id 
              row.code = dati.forniture[tipo][index][tipo_fornitura]
              row.data_decorrenza = minDate.value
              row.cf = dati.forniture[tipo][index].cf_cliente
              row.piva = dati.forniture[tipo][index].piva_cliente
              row.tipo = tipo

              if (isNuovaPosa(dati.forniture[tipo][index])) {
                continue;
              }
              
              let key_tipo_pratica = null
              if (dati.forniture[tipo][index].in_voltura) {
                key_tipo_pratica = 'in_voltura'
              } else if(dati.forniture[tipo][index].in_subentro){
                key_tipo_pratica = 'in_subentro'
              } else if(dati.forniture[tipo][index].in_attivazione_p){
                key_tipo_pratica = 'in_attivazione_p'
              }else{
                continue;
              }
              let tipo_pratica = tipi_pratica[key_tipo_pratica]

              if (tipo_pratica) {
                if (['s', 'ap'].includes(tipo_pratica.code) && !row.code.startsWith('IT')) {
                  row.remi = null
                  row.citta = dati.forniture[tipo][index].citta_fornitura
                  getRemi(dati.forniture[tipo][index].citta_fornitura, row.code)
                }
                row.nome = `pratiche_${tipo_pratica.code}1_${tipo}`
                row.tipo_pratica = tipo_pratica.name
                row.documento = {
                  ref:tipo_pratica.code+tipo+row.id,
                  file:[],
                  nome:''
                }                
                if (dati.forniture[tipo][index].precheck == 2) {
                  all_pratiche.value[row.tipo_pratica].push(row)
                  all_supplies.value++
                }
              }

              row.mask = tipo == 'ee' ? 'IT999E9999999*' : '99999999999999'
              modifiche.value.push({...row}) 
            }
          }
        })
        if (modifiche.value.length > 0) {
          showModalPratiche.value = true
        }
      }        
    }

    const insertDataForPratiche = async (dati) => {
      if (currentUser.value.role == roles.admin.role || currentUser.value.can_process_practices) {
        if (!dati.loaded_details) {
          loading.value = true
          let event = {data:dati}
          let res = await onRowExpand(event)
          setTimeout(()=>{
            createDataPratiche(res)
            loading.value = false
          }, 3000)
        }else{
          createDataPratiche(dati)
        }
      }else{
        toast.add({severity: 'warn', detail: 'Utente non abilitato alla gestione delle pratiche', life: 10000})
      }
    }
    const onInput = (evt, type, index = null) => {
      let value = evt.toUpperCase()
      let validator
      if (index == null) {
        validator = type        
        type = type.replace('unique_', '')
        modifiche.value.forEach(modifica => {
          modifica[type] = value
        }) 
      } else {
        modifiche.value[index][type] = value
        validator = `${type}_${index}`
        if (type == 'code') {
          delete validationErrors.value[`existent_${index}`]
        }           
      }
      delete validationErrors.value[validator]
      getDuplicate()                
    }
    const deleteChangesPratiche = (bool = false, reset_all_supplies = true) => {
      // pratiche_s1_ee.value = []
      // pratiche_v1_ee.value = []
      // pratiche_s1_gas.value = []
      // pratiche_v1_gas.value = []
      all_pratiche.value = {
        voltura:[],
        subentro:[],
        "attivazione su preposato":[]
      }
      matrice_pratiche.value = bool ? matrice_pratiche.value : null
      id_matrice_pratiche.value = bool ? id_matrice_pratiche.value : ''
      validationErrors.value = []
      modifiche.value = []
      if (reset_all_supplies) {
        all_supplies.value = 0
      }
      file_caricati.value = 0
      showModalPratiche.value = bool
      if (showModalPratiche.value) {
        getData()
      }
      type_client_pratiche.value = null
      unique_cf.value = null
      unique_piva.value = null
    }
    const setData = (el) => {
      let giorno = el.getDate() 
      let mese = el.getMonth()+1
      mese = mese.toString().padStart(2,'0')
      let anno = el.getFullYear() 
      el = `${anno}-${mese}-${giorno}`
      return el
    } 

    const setDate = () => {
      Object.keys(all_pratiche.value).forEach(pratica=>{
        all_pratiche.value[pratica].forEach((array) => {
          array['data_decorrenza'] = setData(array['data_decorrenza'])
        })
      })
    }

    const sendPratiche = async () => {
      let volture = true
      let subentri = true
      let attivazioni = true
      let docs = true
      if(Object.keys(validationErrors.value).length > 0) {
          toast.add({severity:'warn', summary:'Campi Errati', detail: 'Alcuni campi sembrano vuoti o errati', life:3500});
      }else{
        if (!is_contratto_manuale.value) {
          Object.keys(all_pratiche.value).forEach(pratica=>{
            all_pratiche.value[pratica].forEach((array) => {
              if (array.documento.file.length) {
                file_caricati.value++
              }
            })
          })
          docs = file_caricati.value == 0 || file_caricati.value == all_supplies.value      
        }
        if (!docs) {
          toast.add({severity: 'warn', detail: 'Carica tutti i documenti', life: 5000})
        }

        if (all_pratiche.value.voltura.length) {
          volture = await validatePratiche(all_pratiche.value.voltura, 'v')
        }
        if (all_pratiche.value.subentro.length) {
          subentri = await validatePratiche(all_pratiche.value.subentro, 's')
        }
        if (all_pratiche.value['attivazione su preposato'].length) {
          attivazioni = await validatePratiche(all_pratiche.value['attivazione su preposato'], 'ap')
        }

        if(volture && subentri && attivazioni && (file_caricati.value == 0 || file_caricati.value == all_supplies.value)){
          setDate()
          loading.value = true
          let fd = new FormData();
          fd.append('matrice_id', JSON.stringify(id_matrice_pratiche.value));
          
          Object.keys(all_pratiche.value).forEach(pratica=>{
            all_pratiche.value[pratica].forEach((array) => {             
              fd.append(array.code+'[]', array.documento.file[0] ?? null);
              if (array.documento.file.length) {
                is_contratto_manuale.value = true
              }
              delete array.documento.file
            })
          })
          fd.append('pratiche', JSON.stringify(all_pratiche.value));
          service.saveMultisitoPratiche(fd)
          .then((res) => {
            if (res.item.success) {
              let string = res.item.totals_pratiche > 1 ? 'pratiche gestite' : 'pratica gestita'
              toast.add({severity:'success', summary: 'Successo', detail:`${res.item.totals_pratiche} ${string}`});
              deleteChangesPratiche(true, false)
              sent_pratica.value = true
            } else {
              toast.add({severity:'warn', summary:'Attenzione', detail: `${res.item.error}`});
            }
          }).finally(() => {
            loading.value = false
          })
        }
        file_caricati.value = 0
      }
    }

    const validatePratiche = (array, type_pratica) => {
      // return 0
      if (type_pratica == 'v') {
        let regexPiva = /^[0-9]{11}$/
        let regex_cf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
  
        array.forEach((el, i)=>{
          if (`cf_attivazione_${el.tipo}` in el) {
            if (el[`cf_attivazione_${el.tipo}`].length < 11 || el[`cf_attivazione_${el.tipo}`].length > 16) {
              validationErrors.value[`cf_attivazione_${el.tipo}_invalid_${i}`] = true
            }else{
              delete validationErrors.value[`cf_attivazione_${el.tipo}_invalid_${i}`]
              if (el[`cf_attivazione_${el.tipo}`].length == 16) {
                if (regex_cf.test(el[`cf_attivazione_${el.tipo}`])) {
                  delete validationErrors.value[`cf_attivazione_${el.tipo}_format_${i}`]
                } else {
                  validationErrors.value[`cf_attivazione_${el.tipo}_format_${i}`] = true
                }
              }else{
                if (regexPiva.test(el[`cf_attivazione_${el.tipo}`])) {
                  delete validationErrors.value[`cf_attivazione_${el.tipo}_format_${i}`]
                } else {
                  validationErrors.value[`cf_attivazione_${el.tipo}_format_${i}`] = true
                }
              }
              if (el.cf && el.cf == el[`cf_attivazione_${el.tipo}`]) {
                validationErrors.value[`cf_attivazione_${el.tipo}_equal_${i}`] = true
              } else {
                delete validationErrors.value[`cf_attivazione_${el.tipo}_equal_${i}`]
              }
            }
          }else{
            validationErrors.value[`cf_attivazione_${el.tipo}_${i}`] = true
          }
          if (`piva_attivazione_${el.tipo}` in el) {
            if (el[`piva_attivazione_${el.tipo}`].length != 11) {
              validationErrors.value[`piva_attivazione_${el.tipo}_invalid_${i}`] = true
            }else{
              delete validationErrors.value[`piva_attivazione_${el.tipo}_invalid_${i}`]
              if (regexPiva.test(el[`piva_attivazione_${el.tipo}`])) {
                delete validationErrors.value[`piva_attivazione_${el.tipo}_format_${i}`]
              } else {
                validationErrors.value[`piva_attivazione_${el.tipo}_format_${i}`] = true
              }
              if (el.piva && el.piva == el[`piva_attivazione_${el.tipo}`]) {
                validationErrors.value[`piva_attivazione_${el.tipo}_equal_${i}`] = true
              } else {
                delete validationErrors.value[`piva_attivazione_${el.tipo}_equal_${i}`]
              }
            }
          }
          if (is_contratto_manuale.value) {
            if (el.documento.file.length) {
              delete validationErrors.value[el.documento.ref]
            }else{
              validationErrors.value[el.documento.ref] = true
            }
          }
        })        
      }
      if (type_pratica == 's' || type_pratica == 'ap') {
        array.forEach((el, i)=>{
          if ('remi' in el) {
            if (el.remi == '' || el.remi == null) {
              validationErrors.value[`remi_${el.code}`] = true
            }else{
              delete validationErrors.value[`remi_${el.code}`]
            }
          }
          if (is_contratto_manuale.value) {
            if (el.documento.file.length) {
              delete validationErrors.value[el.documento.ref]
            }else{
              validationErrors.value[el.documento.ref] = true
            }
          }
        })
      }
      return !Object.keys(validationErrors.value).length;
    }

    const newValidatePratiche = (array_v1, type) => {
      let regexPiva = /^[0-9]{11}$/
      let regex_cf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i

      array_v1.forEach((el, i)=>{
          if (`cf_attivazione_${type}` in el) {
            if (el[`cf_attivazione_${type}`].length < 11 || el[`cf_attivazione_${type}`].length > 16) {
              validationErrors.value[`cf_attivazione_${type}_invalid_${i}`] = true
            }else{
              delete validationErrors.value[`cf_attivazione_${type}_invalid_${i}`]
              if (el[`cf_attivazione_${type}`].length == 16) {
                if (regex_cf.test(el[`cf_attivazione_${type}`])) {
                  delete validationErrors.value[`cf_attivazione_${type}_format_${i}`]
                } else {
                  validationErrors.value[`cf_attivazione_${type}_format_${i}`] = true
                }
              }else{
                if (regexPiva.test(el[`cf_attivazione_${type}`])) {
                  delete validationErrors.value[`cf_attivazione_${type}_format_${i}`]
                } else {
                  validationErrors.value[`cf_attivazione_${type}_format_${i}`] = true
                }
              }
              // if (el.cf && el.cf == el[`cf_attivazione_${type}`]) {
              //   validationErrors.value[`cf_attivazione_${type}_equal_${i}`] = true
              // } else {
              //   delete validationErrors.value[`cf_attivazione_${type}_equal_${i}`]
              // }
            }
          }else{
            validationErrors.value[`cf_attivazione_${type}_${i}`] = true
          }
          if (`piva_attivazione_${type}` in el) {
            if (el[`piva_attivazione_${type}`].length != 11) {
              validationErrors.value[`piva_attivazione_${type}_invalid_${i}`] = true
            }else{
              delete validationErrors.value[`piva_attivazione_${type}_invalid_${i}`]
              if (regexPiva.test(el[`piva_attivazione_${type}`])) {
                delete validationErrors.value[`piva_attivazione_${type}_format_${i}`]
              } else {
                validationErrors.value[`piva_attivazione_${type}_format_${i}`] = true
              }
              // if (el.piva && el.piva == el[`piva_attivazione_${type}`]) {
              //   validationErrors.value[`piva_attivazione_${type}_equal_${i}`] = true
              // } else {
              //   delete validationErrors.value[`piva_attivazione_${type}_equal_${i}`]
              // }
            }
          }
      })
      return !Object.keys(validationErrors.value).length;
    }

    const onInputCell = (evt, index, type_pratica, type, type_code) => {
      if (type_code == 'cf') {
        if (type == 'ee') {
          if (evt.target.value) {
            all_pratiche.value[type_pratica][index].cf_attivazione_ee = evt.target.value.toUpperCase()
          } else {
            delete all_pratiche.value[type_pratica][index].cf_attivazione_ee
          }
        } else {
          if (evt.target.value) {
            all_pratiche.value[type_pratica][index].cf_attivazione_gas = evt.target.value.toUpperCase()
          } else {
            delete all_pratiche.value[type_pratica][index].cf_attivazione_gas
          }
        }
      } else {
        if (type == 'ee') {
          if (evt) {
            all_pratiche.value[type_pratica][index].piva_attivazione_ee = evt.toUpperCase()
          } else {
            delete all_pratiche.value[type_pratica][index].piva_attivazione_ee
          }
        } else {
          if (evt) {
            all_pratiche.value[type_pratica][index].piva_attivazione_gas = evt.toUpperCase()
          } else {
            delete all_pratiche.value[type_pratica][index].piva_attivazione_gas
          }
        }
      }
      
      delete validationErrors.value[`${type_code}_attivazione_${type}_format_${index}`]
      delete validationErrors.value[`${type_code}_attivazione_${type}_invalid_${index}`]
      delete validationErrors.value[`${type_code}_attivazione_${type}_equal_${index}`]
      delete validationErrors.value[`${type_code}_attivazione_${type}_${index}`]
    }

    const isDisabledSendPratiche = computed(()=>{
      if (all_supplies.value == 0) {
        return true
      }
      if (currentUser.value.role == roles.admin.role || !is_contratto_manuale.value) {
        return false
      }
      let n_pratiche = 0
      let n_file = 0
      Object.keys(all_pratiche.value).forEach(pratica => {
        all_pratiche.value[pratica].forEach(item => {
          n_pratiche++
          if (item.documento.file.length) {
            n_file++
          }
        })
      })
      return n_pratiche != n_file
    })

    const showPratiche = (id = null) => {
      loading.value = true
      service.showPdfPratiche(id ?? id_matrice_pratiche.value)
      .then(()=>{
        getData()
      })
      .finally(()=> {
        // isDisableShowPratiche.value = true
        loading.value = false
      })
    }

    const signPratiche = (data) => {
      loading.value = true
      service.signPdfPratiche(data.id)
      .then((res)=> {
        if (res.items.success) data.cod_status_pratica_moduli = 2
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo': 'Attenzione'
        let detail = res.items.errore != '' ? res.items.errore : 'Richiesta di firma inviata correttamente'
        
        toast.add({severity:severity, summary: summary, detail:detail});
        deleteChangesPratiche()
      })
      .finally(()=> {
        loading.value = false
        getData()
      })
    }

    const requireConfirmation = (event, data, index) => {
      confirm.require({
        target: event.currentTarget,
        group: 'headless',
        message: 'Vuoi eliminare la fornitura?',
        rejectClass: 'p-button-danger p-button-sm',
        acceptClass: 'p-button-success p-button-sm',
        rejectLabel: 'No',
        acceptLabel: 'Si',
        accept: () => {
          deleteSupply(data, index)
          toast.add({severity:'info', summary:'', detail:'Fornitura eliminata', life: 3000});
        },
        reject: () => {
          // toast.add({severity:'error', summary:'Rejected', detail:'You have rejected', life: 3000});
        }
      });
    }

    const canViewAnnullaContratto = (data) => {
      if([8,13].includes(data.cod_stato_caricamento)) return false
      
      if(currentUser.value.role == roles.agent.role){
        if(!data.data_firma) return true
        return false
      }

      if(currentUser.value.role == roles.admin.role) return true

      
      if(data.data_firma){
        const dataFirma = new Date(data.data_firma);

        const dataScadenza = new Date(dataFirma);
        dataScadenza.setDate(dataFirma.getDate() + 15);

        const oggi = new Date();
        if (oggi > dataScadenza) return false
      }

      return true
    }

    const deleteContratto = async (in_delete, row = null) => {
      if (in_delete) {
        toast.add({severity:'info', summary:'', detail:'Eliminazione in corso', life: 3000});

        loading.value = true
        let forniture = {
          ee: [],
          gas: []
        }

        Object.keys(row.forniture).forEach(type => {
          row.forniture[type].forEach(el => {
            forniture[type].push({id: el.id, id_type_annullamento: row.motivazione.id})
          })
        })

        let fd = {
          id_matrice: row.id,
          is_complete: row.is_complete,
          note_aggiuntive: row.note_annullamento ?? '',
          forniture: forniture
        }

        await service.sendDeleteContratto(fd)
        .then((res)=>{
          let severity = !res.items.success ? 'warn' : 'success' 
          let detail = res.items.message
          toast.add({severity:severity, summary:'', detail: detail, life: 5000})
        })
        .finally(()=> {
          Promise.all([
            getData(false)
          ])
          .finally(()=>{
            loading.value = false
          })
        })
      }else{
        toast.add({severity:'success', summary:'', detail:'Eliminazione annullata', life: 3000});
      }
      hideOverlayAnnullaContratto()
    }
    
    const saveChangesMultisito = async () => {
      if(Object.keys(validationErrors.value).length > 0 || !validateModifiche()) {
          toast.add({severity:'warn', summary:'Campi Errati', detail: 'Alcuni campi sembrano vuoti o errati', life:3500});
      }
      else{
        loading.value = true
        let fd = new FormData()
        fd.append('matrice_id', JSON.stringify(id_matrice_pratiche.value));
        fd.append('modifiche', JSON.stringify(modifiche.value));
  
        await service.saveChangesMultisito(fd)
        .then((res) => {
          let severity = res.items.error ? 'warn' : 'success' 
          let detail = res.items.response
          toast.add({severity:severity, summary:'', detail: detail, life:3500})

          deleteChangesPratiche()
          Promise.all([getData(false)])
        })
        .finally(()=> {
          loading.value = false
        })
      }
    }
    const validateModifiche = () => {
      let validation_prop = [
        'code'
      ]
      if (type_client_pratiche.value != 3) {
        validation_prop.push('unique_cf')
        if (type_client_pratiche.value != 2) {
          validation_prop.push('unique_piva')
        }
      }else{
        validation_prop.push('cf')
      }

      modifiche.value.forEach((modifica, index) => {
        validation_prop.forEach(prop => {
          let validator = `${prop}_${index}`
          let validation
          if (prop.includes('unique_')) {
            validator = prop 
            validation = eval(`${prop}.value`)
          }else{
            validation = modifica[prop] 
          }
          if (!validation) {
            validationErrors.value[validator] = true
          } else {
            delete validationErrors.value[validator]
          }
        })
      })

      getDuplicate()

      return !Object.keys(validationErrors.value).length;
    }
    const getDuplicate = () => {
      let supplies = []
      
      modifiche.value.forEach((modifica, index) => {
        supplies.push(modifica.code);
      })
      
      let duplicate = []
      supplies.forEach((supply, i) => {
        let new_list = [...supplies]
        new_list.splice(i, 1);
        
        if (new_list.includes(supply)) {
          let objs = modifiche.value.filter(modifica => modifica.code == supply)
          Object.keys(objs).forEach((obj,id) => {
            duplicate.push(id)
          })
        }else{
          let id = modifiche.value.findIndex(modifica => modifica.code == supply)
          delete validationErrors.value[`existent_${id}`]
        }
      })
      duplicate = [...new Set(duplicate)]
      
      if (duplicate.length) {
        duplicate.forEach(id => {
          validationErrors.value[`existent_${id}`] = true
        })
      }
      
    }

    const deleteSupply = (row, index) => {
      modifiche.value.splice(index, 1);
      if (modifiche.value.length == 0){
        saveChangesMultisito()
        deleteChangesPratiche()
      }
    }

    const handleFileNewUpload = (evt, ref) => {
      let index = requiredDocuments.value.findIndex(el => el.ref == ref)
      requiredDocuments.value[index].files = []
      requiredDocuments.value[index].files = self.refs[`${ref}`].files
    }
    const handleFileMissing = (evt, ref) => {
      let index = missingDocuments.value.findIndex(el => el.ref == ref)
      missingDocuments.value[index].files = []
      missingDocuments.value[index].files = self.refs[`${ref}`].files
    }
    const handleFilePratiche = (evt, ref, type) => {
      let index = all_pratiche.value[type].findIndex(el => el.documento.ref == ref)
      all_pratiche.value[type][index].documento.file = []
      all_pratiche.value[type][index].documento.nome = ''
      if (self.refs[`${ref}`].files[0]) {
        all_pratiche.value[type][index].documento.file = self.refs[`${ref}`].files
        all_pratiche.value[type][index].documento.nome = self.refs[`${ref}`].files[0].name        
      }
      delete validationErrors.value[ref]
    }

    const isDisabledSetFirmato = computed( () => {
      let disabled = true
      let has_files = []
      requiredDocuments.value.forEach((doc)=>{
        if (doc.files.length) {
          has_files.push(true)
        }
      })
      disabled = has_files.length == requiredDocuments.value.length ? false : true
      return disabled
    })
    const isDisabledUploadNewFile = computed( () => {
      let has_files = []
      missingDocuments.value.forEach((doc)=>{
        if (doc.files.length) {
          has_files.push(true)
        }
      })

      return has_files.length != missingDocuments.value.length
    })
    const getCaricatoLabel = (caricato) => {
      return [
        {id: 0, label: 'Non caricato'},
        {id: 1, label: 'Caricato'},
        {id: 2, label: 'Annullato'}
      ].find(stato => stato.id == caricato).label
    }
    const getIdMatriceList = (input) => {
      if (typeof input == 'number') {
        return [input]
      }

      return input.split(',').map(id => id.trim()).filter(id => id != '')
    }

    const getPuntiPrelievoList = (input) => {
      return input.split(',').map(pp => pp.trim().toUpperCase()).filter(pp => pp != '')
    }

    const getClienteRappresentanteSearch = (input) => {
      return input.trim()
    }

    const isPuntoPrelievoValid = (pp) => {
      return /^\d{14}$/.test(pp) || /^IT[A-Z0-9]{3}E[A-Z0-9]{8}$/.test(pp)
    }

    const isPuntiPrelievoListValid = (input) => {
      if (!input.trim()) {
        return false
      }

      if (!/^\s*[A-Z0-9]+(?:\s*,\s*[A-Z0-9]+)*\s*,?\s*$/i.test(input)) {
        return false
      }

      return getPuntiPrelievoList(input).every(isPuntoPrelievoValid)
    }

    const isIdListValid = (input) => {
      // RegEx: Solo numeri (\d+) separati da virgole, con spazi opzionali.
      const regexSoloNumeri = /^\s*\d+(?:\s*,\s*\d+)*\s*,?\s*$/;
      
      // Controllo per campo vuoto: se non ci sono caratteri significativi, non è valido.
      if (typeof input != 'number' && !input.trim()) {
        return false; 
      }
      
      return regexSoloNumeri.test(input);
    }

    const changeIdMatrice = async (evt, can_search = true) => {
      if (evt != '' && evt != null) {
        if (!isIdListValid(evt)) {
          toast.add({severity: 'error', detail: 'La ricerca è abilitata solo per id separati da virgola.', life: 10000})
          can_search = false
        } else {
          selectedIdMatrice.value = getIdMatriceList(evt).join(',')
        }
          
        searchedIdMatrice.value = selectedIdMatrice.value == searchedIdMatrice.value ? searchedIdMatrice.value : null
        selectedPuntiPrelievo.value = null
        searchedPuntiPrelievo.value = null
        selectedClienteRappresentante.value = null
        searchedClienteRappresentante.value = null
        selectedStatus.value = []
        onChangeDate('data_caricamento', true)
        onChangeDate('data_firma', true)
      }else{
        can_search = false
        selectedDate.value = getDefaultSelectedDate()
        selectedIdMatrice.value = null
      }
      if (can_search) {
        await getData()
      }
    }
    const changePuntiPrelievo = async (evt, can_search = true) => {
      if (evt != '' && evt != null) {
        if (!isPuntiPrelievoListValid(evt)) {
          toast.add({severity: 'error', detail: "La ricerca e' abilitata solo per punti di prelievo validi, lunghi 14 caratteri e separati da virgola.", life: 10000})
          can_search = false
        } else {
          selectedPuntiPrelievo.value = getPuntiPrelievoList(evt).join(',')
        }

        searchedPuntiPrelievo.value = selectedPuntiPrelievo.value == searchedPuntiPrelievo.value ? searchedPuntiPrelievo.value : null
        selectedIdMatrice.value = null
        searchedIdMatrice.value = null
        selectedClienteRappresentante.value = null
        searchedClienteRappresentante.value = null
        selectedStatus.value = []
        onChangeDate('data_caricamento', true)
        onChangeDate('data_firma', true)
      }else{
        can_search = false
        selectedDate.value = getDefaultSelectedDate()
        selectedPuntiPrelievo.value = null
        searchedPuntiPrelievo.value = null
      }
      if (can_search) {
        await getData()
      }
    }

    const changeClienteRappresentante = async (evt, can_search = true) => {
      if (evt != '' && evt != null && getClienteRappresentanteSearch(evt) != '') {
        selectedClienteRappresentante.value = getClienteRappresentanteSearch(evt)
        searchedClienteRappresentante.value = selectedClienteRappresentante.value == searchedClienteRappresentante.value ? searchedClienteRappresentante.value : null
        selectedIdMatrice.value = null
        searchedIdMatrice.value = null
        selectedPuntiPrelievo.value = null
        searchedPuntiPrelievo.value = null
        selectedStatus.value = []
        onChangeDate('data_caricamento', true)
        onChangeDate('data_firma', true)
      }else{
        can_search = false
        selectedDate.value = getDefaultSelectedDate()
        selectedClienteRappresentante.value = null
        searchedClienteRappresentante.value = null
      }
      if (can_search) {
        await getData()
      }
    }

    const saveChanges = (type_modifica, request_delete = false, view_toast = true, other_props = []) => {
      if (type_modifica === 'contatto' && (isContactPecMissing.value || isContactPecInvalid.value)) {
        validationErrors.value.pec = true
        const detail = isContactPecMissing.value
          ? 'La PEC è obbligatoria per questa tipologia di cliente.'
          : 'Formato PEC del contatto non valido.'
        toast.add({severity: 'warn', summary: 'PEC non valida', detail, life: 5000})
        return
      }

      if (type_modifica in inEdit.value) {
        const caricamentoModificato = caricamento_da_modificare.value
        const puntoPrelievoModificato = pp_da_modificare.value

        if(['cod_listino_contratto','indirizzo_fornitura', 'iban_contratto'].includes(type_modifica)){
          inEdit.value[type_modifica].new = pp_da_modificare.value[type_modifica]
          if (type_modifica == 'indirizzo_fornitura') {
            inEdit.value[type_modifica].new = {
              toponimo_fornitura: pp_da_modificare.value.toponimo_fornitura,
              indirizzo_fornitura: pp_da_modificare.value.indirizzo_fornitura,
              numero_civico_fornitura: pp_da_modificare.value.numero_civico_fornitura,
              cap_fornitura: pp_da_modificare.value.cap_fornitura,
              cod_comune: pp_da_modificare.value.cod_comune,
              name: pp_da_modificare.value.citta_fornitura,
            }
          }
          if (type_modifica == 'iban_contratto') {
            inEdit.value[type_modifica].new = {
              iban_contratto: pp_da_modificare.value.iban_contratto,
              intestazione_contratto: pp_da_modificare.value.intestazione_contratto,
              cf_intestazione_contratto: pp_da_modificare.value.cf_intestazione_contratto,
              checked_data_iban_equal_to_client: pp_da_modificare.value.checked_data_iban_equal_to_client,
            }
          }
        }else{
          inEdit.value[type_modifica].new = caricamento_da_modificare.value[type_modifica]
        }

        if (JSON.stringify(inEdit.value[type_modifica].new) != JSON.stringify(inEdit.value[type_modifica].old) || request_delete) {
          loading.value = true
          let changes = {
            matrice_id: caricamento_da_modificare.value.id,
            modifica: type_modifica,
            old: inEdit.value[type_modifica].old,
            new: inEdit.value[type_modifica].new,
            request_delete: request_delete
          }
          if (other_props.length > 0) {
            changes.supply_id = other_props[0]
            changes.type = other_props[1]
          }
          service.saveChangesMultisito(changes)
          .then((res)=>{
            let severity = res.items.error ? 'error' : 'success'
            let detail = res.items.response
            if (!res.items.error) {
              if(['cod_listino_contratto','indirizzo_fornitura', 'iban_contratto'].includes(type_modifica)){
                puntoPrelievoModificato[`in_review_${type_modifica}`] = true
                puntoPrelievoModificato[type_modifica] = changes.old
                if (type_modifica == 'indirizzo_fornitura') {
                  puntoPrelievoModificato.toponimo_fornitura = changes.old.toponimo_fornitura
                  puntoPrelievoModificato.indirizzo_fornitura = changes.old.indirizzo_fornitura
                  puntoPrelievoModificato.numero_civico_fornitura = changes.old.numero_civico_fornitura
                  puntoPrelievoModificato.cap_fornitura = changes.old.cap_fornitura
                  puntoPrelievoModificato.cod_comune = changes.old.cod_comune
                }
                if (type_modifica == 'iban_contratto') {
                  puntoPrelievoModificato.iban_contratto = changes.old.iban_contratto
                  puntoPrelievoModificato.checked_data_iban_equal_to_client = changes.old.checked_data_iban_equal_to_client
                  puntoPrelievoModificato.intestazione_contratto = changes.old.intestazione_contratto
                  puntoPrelievoModificato.cf_intestazione_contratto = changes.old.cf_intestazione_contratto
                }
              }else{
                caricamentoModificato[`in_review_${type_modifica}`] = true
                caricamentoModificato[type_modifica] = changes.old
              }
              delete inEdit.value[type_modifica]
            }
            if(view_toast || res.items.error) toast.add({severity: severity, detail: detail, life: 10000})
          })
          .finally(()=>{
            loading.value = false
          })
        }else{
          toast.add({severity: 'warn', detail: 'Non hai effettuato modifiche al caricamento', life: 5000})
          delete inEdit.value[type_modifica]
        }
        resetInEdit()
      }
    }
    const setChanges = (type_modifica, data, view_toast = true, pp = null) => {
      let check = pp ? pp[`in_review_${type_modifica}`] : data[`in_review_${type_modifica}`]
      if (!check) {
        inEdit.value = {}
        inEdit.value[type_modifica] = {
          old: pp ? pp[type_modifica] : data[type_modifica],
          new: null
        }
        caricamento_da_modificare.value = data
        pp_da_modificare.value = pp

        if (['contatto','indirizzo_fornitura', 'iban_contratto'].includes(type_modifica)) {
          let provincia
          if (type_modifica == 'indirizzo_fornitura') {
            inEdit.value.indirizzo_fornitura.old = {
              toponimo_fornitura: pp.toponimo_fornitura,
              indirizzo_fornitura: pp.indirizzo_fornitura,
              numero_civico_fornitura: pp.numero_civico_fornitura,
              cap_fornitura: pp.cap_fornitura,
              cod_comune: pp.cod_comune,
              name: pp.citta_fornitura
            }
            provincia = pp.provincia_fornitura
          }
  
          if (type_modifica == 'contatto') {            
            inEdit.value.contatto.old = {...data.contatto}
            provincia = data.contatto.provincia
          }
          if (type_modifica == 'iban_contratto') {
            inEdit.value.iban_contratto.old = {
              iban_contratto: pp.iban_contratto,
              intestazione_contratto: pp.intestazione_contratto,
              cf_intestazione_contratto: pp.cf_intestazione_contratto,
              checked_data_iban_equal_to_client: pp.checked_data_iban_equal_to_client
            }
          }
          if (provincia) {
            service.getCities(provincia)
            .then((res) => {
              cities.value = res.items
              dialogModifiche.value = true
            })
          }else{
            dialogModifiche.value = true
          }
        }
      }else{
        if(view_toast) toast.add({severity: 'warn', detail: 'Modifica in revisione', life: 5000})
      }
    }
    const getMaskIban = computed(()=>{
      let mask = ''
      const typeClient = caricamento_da_modificare.value?.cod_type_client;

      switch (typeClient) {
        case 1:
        case 2:
        case 4:
          mask = 'aaaaaa99a99a9*9a'
          break;
        case 3:
        case 5:
          mask = '99999999999'
          break;
        case 6:
          mask = pp_da_modificare.value.cf_cliente.startsWith('0') ? 'aaaaaa99a99a9*9a' : '99999999999'
          break;
      }
      return mask
    })

    const setDatiIban = () => {                       
        if (pp_da_modificare.value.checked_data_iban_equal_to_client) {
          pp_da_modificare.value.intestazione_contratto = pp_da_modificare.value.denominazione_cliente
          
          const cfPiva = pp_da_modificare.value.cf_cliente
          const rappCodFis = caricamento_da_modificare.value.codfis

          const typeClient = caricamento_da_modificare.value?.cod_type_client;

          switch (typeClient) {
            case 2:
            case 3:
            case 5:

              pp_da_modificare.value.cf_intestazione_contratto = cfPiva
              break;

            case 6:
              pp_da_modificare.value.cf_intestazione_contratto = cfPiva.startsWith('0') 
              ? cfPiva 
              : rappCodFis;
              break;

            default:
              pp_da_modificare.value.cf_intestazione_contratto = rappCodFis;
              break;
          }
        }
      }
    const canChangeDatiIban = computed(() => {
      let allowed = [2]
      return allowed.includes(caricamento_da_modificare.value.cod_type_client)
    })
    const resetInEdit = () => {
      dialogModifiche.value = false
      if ('contatto' in inEdit.value) {
        caricamento_da_modificare.value.contatto = inEdit.value.contatto.old
      }
      if ('indirizzo_fornitura' in inEdit.value) {
        pp_da_modificare.value.toponimo_fornitura = inEdit.value.indirizzo_fornitura.old.toponimo_fornitura
        pp_da_modificare.value.indirizzo_fornitura = inEdit.value.indirizzo_fornitura.old.indirizzo_fornitura
        pp_da_modificare.value.numero_civico_fornitura = inEdit.value.indirizzo_fornitura.old.numero_civico_fornitura
        pp_da_modificare.value.cap_fornitura = inEdit.value.indirizzo_fornitura.old.cap_fornitura
        pp_da_modificare.value.cod_comune = inEdit.value.indirizzo_fornitura.old.cod_comune
      }
      if ('iban_contratto' in inEdit.value) {
        pp_da_modificare.value.iban_contratto = inEdit.value.indirizzo_fornitura.old.iban_contratto
        pp_da_modificare.value.intestazione_contratto = inEdit.value.intestazione_contratto.old.indirizzo_fornitura
        pp_da_modificare.value.cf_intestazione_contratto = inEdit.value.indirizzo_fornitura.old.cf_intestazione_contratto
        pp_da_modificare.value.checked_data_iban_equal_to_client = inEdit.value.indirizzo_fornitura.old.checked_data_iban_equal_to_client        
      }
      caricamento_da_modificare.value = {}
      pp_da_modificare.value = {}
      inEdit.value = {}
    }

    const viewPrechecks = (list, pp, type) => {
      prechecks.value.pp = pp
      prechecks.value.list = list.map( obj => {
        const new_obj = {}
        for (const chiaveOriginale in obj) {
          const nuovaChiave = chiaveOriginale.replace(/_/g, ' ');

          new_obj[nuovaChiave] = obj[chiaveOriginale];
        }
        return new_obj;
      })
      
      prechecks.value.columns = columns_precheck[type] 
      dialogPrechecks.value = true
    }

    const formatPraticaColumn = (column) => {
      return column.replace(/_/g, ' ').toUpperCase()
    }

    const normalizePraticaRows = (list) => {
      return list.map( obj => {
        const new_obj = {}
        for (const chiaveOriginale in obj) {
          new_obj[formatPraticaColumn(chiaveOriginale)] = obj[chiaveOriginale];
        }
        return new_obj;
      })
    }

    const getInformativeVolturaList = (data) => {
      const fields = [
        'informative_voltura',
        'informativa_voltura',
        'informative_volture',
        'informativa_volture',
        'informativeVoltura',
        'informativaVoltura',
        'informativeVolture',
        'informativaVolture',
        'iv',
        'ivs'
      ]

      for (const field of fields) {
        if (Array.isArray(data?.[field])) {
          return data[field]
        }
        if (Array.isArray(data?.[field]?.list)) {
          return data[field].list
        }
      }

      return []
    }

    const getRequestIdPratica = (data) => {
      return data['REQUEST ID'] || data['ID RICHIESTA'] || data['ID REQUEST'] || data['ID RICHIESTA PRATICA'] || data['COD RICHIESTA'] || null
    }

    const viewInformativeVoltura = (data, pp, type) => {
      const list = getInformativeVolturaList(data)
      const normalizedList = normalizePraticaRows(list)

      informativeVoltura.value.pp = pp
      informativeVoltura.value.list = normalizedList
      informativeVoltura.value.columns = columns_informative_voltura[type]
      dialogInformativeVoltura.value = true
    }

    const inSelectedRows = (caricamento, riga) => {
      if (riga.selected) {
        caricamento.selectedPP.push(riga);
      } else {
        let index = caricamento.selectedPP.findIndex((row) => row.id == riga.id);
        if (index != -1) {
          caricamento.selectedPP.splice(index, 1);
        }
      }
    }

    const resetSelection = (caricamento) => {
      const forniture = caricamento.forniture;
      
      for (const tipo in forniture) {
        if (Array.isArray(forniture[tipo])) {
          forniture[tipo] = forniture[tipo].map(item => ({
            ...item,
            selected: false
          }));
        }
      }
    };

    const contactEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const isContactPecRequired = computed(() => Number(caricamento_da_modificare.value?.cod_type_client) !== 2)
    const isContactPecMissing = computed(() => {
      if (!isContactPecRequired.value) return false

      const pec = caricamento_da_modificare.value?.contatto?.pec
      return pec === null || pec === undefined || String(pec).trim() === ''
    })
    const isContactPecInvalid = computed(() => {
      const pec = caricamento_da_modificare.value?.contatto?.pec
      if (pec === null || pec === undefined || String(pec).trim() === '') return false

      return !contactEmailRegex.test(String(pec).trim())
    })

    const isDisabledSaveNewContact = computed(() => {
      const data = caricamento_da_modificare.value;
      
      const res = {
        disabled: false,
        message: ""
      };

      if (!data || !data.contatto) {
        return { disabled: true, message: "Dati contatto non disponibili." };
      }

      // La PEC non è obbligatoria per i clienti con cod_type_client 2.
      const props_not_null = ['toponimo', 'indirizzo', 'civico', 'cap', 'email', 'cell'];
      if (isContactPecRequired.value) props_not_null.push('pec')

      // Verifica se manca almeno uno dei campi
      const hasMissingField = props_not_null.some(prop => {
        const value = data.contatto[prop];
        return (
          value === null || 
          value === undefined || 
          value === "" || 
          (typeof value === 'string' && value.trim() === "") ||
          (Array.isArray(value) && value.length === 0)
        );
      });

      if (hasMissingField) {
        return {
          disabled: true,
          message: isContactPecMissing.value
            ? "La PEC è obbligatoria per questa tipologia di cliente."
            : "Tutti i campi (Indirizzo completo, Email e Cellulare) sono obbligatori."
        };
      }

      if (isContactPecInvalid.value) {
        return {
          disabled: true,
          message: "Formato PEC del contatto non valido."
        };
      }

      return res;
    });
    const isDisabledSaveNewIndirizzoFornitura = computed(() => {
      const data = pp_da_modificare.value;
      
      // Risultato di default: tutto ok
      const res = {
        disabled: false,
        message: ""
      };

      if (!data) {
        return { disabled: true, message: "Dati contatto non disponibili." };
      }

      // Definiamo i campi obbligatori per l'indirizzo
      const props_not_null = ['toponimo_fornitura', 'indirizzo_fornitura', 'numero_civico_fornitura', 'cap_fornitura'];

      // Cerchiamo se c'è almeno un campo mancante
      const hasMissingField = props_not_null.some(prop => {
        const value = data[prop];
        return (
          value === null || 
          value === undefined || 
          value === "" || 
          (typeof value === 'string' && value.trim() === "") ||
          (Array.isArray(value) && value.length === 0)
        );
      });

      if (hasMissingField) {
        return {
          disabled: true,
          message: "Tutti i campi dell'indirizzo (Toponimo, Indirizzo, Civico e CAP) sono obbligatori."
        };
      }

      return res;
    });

    const isDisabledSaveNewPaymentMode = computed(() => {
      const data = pp_da_modificare.value;
      if (!data) return { disabled: true, message: "" };

      const res = { disabled: false, message: "" };

      if (!data.checked_data_iban_equal_to_client) {
        // Pulizia profonda: rimuoviamo gli underscore della maschera e spazi
        const cleanCF = (data.cf_intestazione_contratto || "").replace(/_/g, "").trim().toUpperCase();
        const cleanIntestatario = (data.intestazione_contratto || "").trim().toUpperCase();
        
        const clienteOriginale = (data.denominazione_cliente || "").trim().toUpperCase();
        const cfOriginale = (data.cf_cliente || "").trim().toUpperCase();

        // Verifica se i campi sono effettivamente vuoti o incompleti
        if (!cleanIntestatario || !cleanCF) {
          return { 
            disabled: true, 
            message: "Compilare i campi Intestatario e Codice Fiscale." 
          };
        }

        // Verifica se coincidono con il cliente principale
        if (cleanIntestatario === clienteOriginale && cleanCF === cfOriginale) {
          return { 
            disabled: true, 
            message: "I dati devono essere diversi da quelli del cliente se l'intestatario non coincide." 
          };
        }
      }

      return res;
    });

    const dataStorico = ref()
    const dialogDataStorico = ref(false)
    const idDataStorico = ref()
    const resetDataStorico = () => {
      dataStorico.value = null
      idDataStorico.value = null
      dialogDataStorico.value = false
    }

    const getStoricoCaricamentoById = async (id) => {
      loading.value = true
      await service.getStoricoCaricamentoById(id)
      .then((res) => {        
        if(res.items.data.length > 0){
          idDataStorico.value = id
          dataStorico.value = res.items
          dialogDataStorico.value = true
        }
      })
      .finally(()=>{
        loading.value = false
      })
    }
    const logCaricamento = ref({
      data: [],
      columns: []
    })
    const dialogLogCaricamento = ref(false)
    const idLogCaricamento = ref()
    const resetLogCaricamento = () => {
      logCaricamento.value = {
        data: [],
        columns: []
      }
      idLogCaricamento.value = null
      dialogLogCaricamento.value = false
    }

    const getLogCaricamentiMultisitoById = async (id) => {
      loading.value = true
      await service.getLogCaricamentiMultisitoById(id)
      .then((res) => {
        const logs = res.items?.data ?? []

        if (logs.length > 0) {
          idLogCaricamento.value = id
          logCaricamento.value = {
            data: logs,
            columns: Object.keys(logs[0] ?? {})
          }
          dialogLogCaricamento.value = true
        } else {
          toast.add({severity:'info', summary:'', detail:'Non sono presenti log per questo caricamento', life: 3000});
        }
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(()=>{
        loading.value = false
      })
    }
    const log_modifiche = ref({
      dialog: false,
      code: null,
      matrice: null,
      logs: [],
      reset() {
        log_modifiche.value.dialog = false
        log_modifiche.value.code = null
        log_modifiche.value.matrice = null
        log_modifiche.value.logs = []
      }
    })

    const viewModifiche = async (type, pp) => {
      log_modifiche.value.reset()
      loading.value = true
      await service.getModifichePPbyId(type, pp.id)
      .then((res) => {  
        if(res.items.exist){
          log_modifiche.value.code = pp.code
          log_modifiche.value.matrice = pp.matrice_id
          log_modifiche.value.logs = res.items
          log_modifiche.value.dialog = true
        }else{
          toast.add({severity:'info', summary:'', detail:'Non sono presenti modifiche per questa fornitura', life: 3000});
        }
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(()=>{
        loading.value = false
      })
    }

    const parseNestedJson = (value) => {
      if (typeof value === 'string') {
        const trimmed = value.trim()
        const isJsonScalar = /^".*"$/.test(trimmed)
          || ['null', 'true', 'false'].includes(trimmed)
          || /^-?\d+(\.\d+)?$/.test(trimmed)

        if (!trimmed || (!trimmed.startsWith('{') && !trimmed.startsWith('[') && !isJsonScalar)) {
          return value
        }

        try {
          return parseNestedJson(JSON.parse(trimmed))
        } catch (e) {
          return value
        }
      }

      if (Array.isArray(value)) {
        return value.map(item => parseNestedJson(item))
      }

      if (value && typeof value === 'object') {
        return Object.fromEntries(
          Object.entries(value).map(([key, item]) => [key, parseNestedJson(item)])
        )
      }

      return value
    }

    const normalizeEscapedLogText = (value) => {
      return String(value)
        .replace(/\\r\\n/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '\n')
        .replace(/\\t/g, '\t')
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, '\\')
    }

    const findJsonBlockEnd = (text, start) => {
      const expectedClosers = []
      let inString = false
      let escaped = false

      for (let i = start; i < text.length; i++) {
        const char = text[i]

        if (escaped) {
          escaped = false
          continue
        }

        if (char === '\\') {
          escaped = true
          continue
        }

        if (char === '"') {
          inString = !inString
          continue
        }

        if (inString) continue

        if (char === '{') expectedClosers.push('}')
        if (char === '[') expectedClosers.push(']')

        if (char === '}' || char === ']') {
          if (expectedClosers[expectedClosers.length - 1] !== char) return -1

          expectedClosers.pop()
          if (expectedClosers.length === 0) return i
        }
      }

      return -1
    }

    const formatEmbeddedJsonBlocks = (value) => {
      const text = normalizeEscapedLogText(value)
      let formatted = ''
      let index = 0

      while (index < text.length) {
        const char = text[index]

        if (char === '{' || char === '[') {
          const end = findJsonBlockEnd(text, index)

          if (end > index) {
            const block = text.slice(index, end + 1)

            try {
              formatted += JSON.stringify(parseNestedJson(block), null, 2)
              index = end + 1
              continue
            } catch (e) {
              // Continua con il testo originale se il blocco non e JSON valido.
            }
          }
        }

        formatted += char
        index++
      }

      return formatted
    }

    const formatParsedJsonValue = (value) => {
      if (typeof value === 'string') {
        const parsed = parseNestedJson(value)

        if (parsed !== value) {
          return formatParsedJsonValue(parsed)
        }

        return formatEmbeddedJsonBlocks(value)
      }

      if (value && typeof value === 'object') {
        return JSON.stringify(value, null, 2)
      }

      return String(value)
    }

    const parseJson = (jsonString) => {
      if (!jsonString) return 'Nessun dato';
      try {
        const parsed = parseNestedJson(jsonString);
        return formatParsedJsonValue(parsed); 
      } catch (e) {
        if (jsonString !== undefined) return normalizeEscapedLogText(jsonString);
        return jsonString; // Se non è un JSON valido (o già parsato), restituisce la stringa così com'è
      }
    }


    const formatDate = (dateString) => {
      if (!dateString) return '';
      return moment(dateString).format('DD/MM/YYYY HH:mm')
    }
    const formatSwitchDateOnly = (dateString) => {
      if (!dateString) return 'Non impostata';
      const formattedDate = moment(dateString)
      return formattedDate.isValid() ? formattedDate.format('DD/MM/YYYY') : dateString
    }
    const formatSwitchLogValue = (change, value) => {
      if (change?.value_type === 'boolean') {
        return value === true || value === 1 || value === '1' ? 'Calcolata dal sistema' : 'Selezionata'
      }

      return formatSwitchDateOnly(value)
    }
    const hasSwitchDates = (data) => {
      return !!data?.data_switch_pod && !!data?.data_switch_pdr
    }
    const canShowSwitchLogOrigin = (change) => {
      return change?.origin_label && change.origin_label !== 'Origine non determinata'
    }
    const isPrimaDataUtileSwitch = (data) => {
      return data?.prima_data_utile_switch === true
        || data?.prima_data_utile_switch === 1
        || data?.prima_data_utile_switch === '1'
    }
    const getSwitchDateAuthor = (data) => {
      if (Number(data?.admin_id || 0) !== 0 && data?.admin) {
        return data.admin
      }

      if (data?.agenteIncaricato) {
        return data.agenteIncaricato
      }

      return data?.agente || ''
    }
    const getSwitchDateSource = (data) => {
      const isAdmin = Number(data?.admin_id || 0) !== 0 && !!data?.admin
      return {
        is_selected: !isPrimaDataUtileSwitch(data),
        author: getSwitchDateAuthor(data),
        is_admin: isAdmin
      }
    }
    const getSwitchDateTitle = (data) => {
      return isNuovaPosaCaricamento(data) ? 'Data nuova posa' : 'Data switch'
    }
    const getSwitchDateRows = (data) => {
      const podDate = data?.data_switch_pod || null
      const pdrDate = data?.data_switch_pdr || null
      const sameDate = (podDate || null) === (pdrDate || null)
      const dateTitle = getSwitchDateTitle(data)

      if (sameDate) {
        return [{ label: dateTitle, value: formatSwitchDateOnly(podDate) }]
      }

      const rows = []
      if (podDate) {
        rows.push({ label: `${dateTitle} POD`, value: formatSwitchDateOnly(podDate) })
      }
      if (pdrDate) {
        rows.push({ label: `${dateTitle} PDR`, value: formatSwitchDateOnly(pdrDate) })
      }

      return rows
    }
    const detailRequestPratica = ref({
      data: {
        exist: false,
        objects: [],
        columns: []
      },
      dialog: false,
      reset (){
        detailRequestPratica.value.data = {
          exist: false,
          objects: [],
          columns: []
        }
        detailRequestPratica.value.dialog = false
      }
    })

    const viewRequestPratica = async (requestId) => {
      loading.value = true
      await service.getRequestPraticaById(requestId)
      .then((res) => {
        if (res.items.exist) {
          detailRequestPratica.value.data = res.items
          detailRequestPratica.value.dialog = true
        }
      })
      .finally(() => {
        loading.value = false
      })
    }

    return {
      moment,
      filters,
      dates_firma,
      authors,
      masters,
      incaricati,
      rapps,
      clients,
      ids,
      cf_piva,
      forniture,
      items,
      selectedItems,
      loading,
      loaded,
      uploadNewMatrice,
      downloadMatrice,
      downloadsMatrici,
      // onMatriceSelected,
      uploadMatrice,
      newMatriceDialog,
      insertSignedContractDialog,
      insertSignedContract,
      handleFileNewUpload,
      handleFilePratiche,
      handleFileMissing,
      all_file_pratiche,
      all_pratiche,
      isCaricamentoEreditato,
      isDisabledSendPratiche,
      typeMatrice,
      typesMatrice,
      matriceUploadKey,
      typesClient,
      selectedTypeClient,
      offerte,
      selectedOfferte,
      isIvaAgevolata,
      showPdf,
      signPdf,
      fileToUpload,
      handleFileUpload,
      allowedType,
      // onCheckRowMultisito,
      validationErrors,
      submitted,
      roles,
      currentUser,
      contatori,
      updateRapp,
      deleteChanges,
      showModal,
      showModalMobile,
      showModalPratiche,
      isCorrect,
      insertDataRapp,
      rappresentante,
      districts,
      cities,
      toponimi,
      onSelected,
      allowedTypeDoc,
      files,
      deleteUpdate,
      goToPratiche,
      goToUpdateContract,
      detachAndUpdateContract,
      insertDataForPratiche,
      // pratiche_s1_ee,
      // pratiche_s1_gas,
      // pratiche_v1_ee,
      // pratiche_v1_gas,
      deleteChangesPratiche,
      sendPratiche,
      onInputCell,
      sent_pratica,
      isDisableShowPratiche,
      showPratiche,
      signPratiche,
      minDate,
      is_contratto_manuale,
      // has_piva,
      // is_number,
      getSeverity,
      getTooltip,
      stati,
      uploadNewFile,
      onSelectedStatus,
      onSelectedStatusHide,
      selectedStatus,
      getSeverityTag,
      onChangeDate,
      selectedDate,
      maxDate,
      onTodayClick,
      selectedSignDate,
      removeFilters,
      toggle,
      op,
      op_modifiche,
      periodi,
      saveChanges,
      setChanges,
      caricamento_da_modificare,
      pp_da_modificare,
      inEdit,
      op_richiesta_modifiche,
      newFilesView,
      hideOverlay,
      loadingFilename,
      downloadPdf,
      downloadZip,
      newValidatePratiche,
      expandedRows,
      onRowExpand,
      stati_precheck,
      getSignLink,
      getSignData,
      getStatoFirmaContratto,
      links,
      sign_data,
      sign_data_copy,
      changed_sign_data,
      copyLink,
      windowSize,
      contractPreviewVisible,
      contractPreviewDialog,
      previewMatriceId,
      refreshPreviewSignature,
      downloadPreviewContract,
      contractPreviewDocuments,
      esportaCaricamenti,
      editingRows,
      modifiche,
      saveChangesMultisito,
      deleteSupply,
      requireConfirmation,
      confirm,
      type_client_pratiche,
      onInput,
      unique_cf,
      unique_piva,
      esportaEsiti,
      all_supplies,
      file_caricati,
      setFirmato,
      requiredDocuments,
      allowedTypes,      
      vs,
      ctr,
      matrice_for_signed_contract,
      deleteInsertSignedContract,
      isDisabledSetFirmato,
      isDisableInput,
      isDisableInputMissing,
      maxDateSigned,
      data_firma_cartaceo,
      onChangeDataFirma,
      matrice_pratiche,
      id_matrice_pratiche,
      sendSignData,
      isDisabledSendSignData,
      loaded_sign_data,
      setChangedSignData,
      sendRequestSignData,
      initData,
      totali,
      insertMissingDocumentsDialog,
      insertMissingDocuments,
      deleteInsertMissingDocuments,
      missingDocuments,
      matrice_for_missing_documents,
      isDisabledUploadNewFile,
      remiOption,
      onSelectedRemi,
      op_annulla_contratto,
      hideOverlayAnnullaContratto,
      matrice_da_annullare,
      deleteContratto,
      cancelDeletion,
      dialogModificaAgenteFirmatario,
      dataDialogModificaAgenteFirmatario,
      openDialogModificaAgenteFirmatario,
      deleteDataDialogModificaAgenteFirmatario,
      saveNewAgenteFirmatario,
      getEsitoTimoeTimg,
      getEsitoPrecheck,
      getCaricatoLabel,
      getStatoSwitch,
      getTipoPraticaLabel,
      rowClass,
      selectedIdMatrice,
      changeIdMatrice,
      selectedPuntiPrelievo,
      changePuntiPrelievo,
      selectedClienteRappresentante,
      changeClienteRappresentante,
      getCaricamentiPKko,
      loaded_caricamenti_pk_ko,
      caricamenti_pk_ko,
      filterCaricamenti,
      prechecks,
      viewPrechecks,
      dialogPrechecks,
      informativeVoltura,
      dialogInformativeVoltura,
      getInformativeVolturaList,
      getRequestIdPratica,
      viewInformativeVoltura,
      inSelectedRows,
      deletePP,
      dialogModifiche,
      isContactPecRequired,
      isContactPecMissing,
      isContactPecInvalid,
      isDisabledSaveNewContact,
      isDisabledSaveNewIndirizzoFornitura,
      isDisabledSaveNewPaymentMode,
      aggiornamentoOnCondition,
      forzaCaricamento,
      forzaScissionePk,
      agente_offerta,
      resetInEdit,
      canChangeDatiIban,
      getMaskIban,
      setDatiIban,
      motivazioni,
      setDataAnnullamento,
      showModalAnnullamento,
      canViewAnnullaContratto,
      dataStorico,
      dialogDataStorico,
      idDataStorico,
      resetDataStorico,
      getStoricoCaricamentoById,
      logCaricamento,
      dialogLogCaricamento,
      idLogCaricamento,
      resetLogCaricamento,
      getLogCaricamentiMultisitoById,
      dataDialogDeletePP,
      resetDataDialogDeletePP,
      openDialogDeletePP,
      canViewDeletePP,
      log_modifiche,
      viewModifiche,
      parseJson,
      formatDate,
      formatSwitchDateOnly,
      formatSwitchLogValue,
      canShowSwitchLogOrigin,
      hasSwitchDates,
      getSwitchDateSource,
      getSwitchDateTitle,
      getSwitchDateRows,
      viewRequestPratica,
      detailRequestPratica
    }
  },
}
</script>

<style>
.bg-danger{
  background-color: red !important;
}
.text-danger-contrast{
  color: white !important;
}
.bg-success{
  background-color: green !important;
}
.bg-warning{
  background-color: rgb(255, 196, 0) !important;
}

.caricamenti-multisito .btn-multisito, .caricamenti-multisito .p-fileupload-choose {
  width: 138px;
  height: 60px;
  font-size: 0.9rem;
  margin: 0 5px 5px 0;
}
.p-column-header-content .p-column-title{
  white-space: normal;
}
/* @media (min-width: 960px) and (max-width: 1250px) {
  .caricamenti-multisito {
    width: 1210px;
  }
} */

@media (max-width: 960px) {
  .caricamenti-multisito .btn-multisito, .caricamenti-multisito .p-fileupload-choose {
    margin: 5px;
  }
}

@media (max-width: 400px){
  .layout-main > .card{
    padding-left: unset;
  }
}

.overlayDocs{
  width: 400px !important;
}

.overlayDocs .p-component{
  max-width: 350px !important;
}

.p-button-white{
  color: black !important;
  background-color: white;
}

.switch-date-details{
  padding-top: 0.5rem;
  border-top: 1px solid #e5e7eb;
}

.switch-date-log{
  color: #31516d;
}
</style>
<style scoped>
.btn-offerte{
    border-radius: 50% !important;
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .btn-offerte:hover {
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    border-color: #2196F3;
  }
.removeFilter{
  position: relative;
  top: 5px;
}
.layout-main > .card{
  min-width: 370px !important;
  padding: 1rem;
}
@media (max-width: 400px){
  .p-column-header-content .p-column-title{
    font-size: 1vw;
  }

  /* .layout-main > .card{
    padding-left: unset;
  } */
  .div-buttons{
    padding: 1rem;
  }
}
.div-buttons{
  padding: 1rem 1rem 1rem 0;
}

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  box-shadow: none;
}

.button-wrapper-file {
  position: relative;
  width: 150px;
  text-align: center;
}

.button-wrapper-file span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0); 
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0);
}


.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

#upload, #uploadModuli, .uploadModuli {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.btn-downloads-matrici {
  position:fixed;
  bottom:60px; 
  right:40px;
  z-index:2;
}
.nota{
  border-bottom: 1px solid #6c757d3d;
  margin-bottom: 10px;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0); 
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0);
}

#upload, #uploadCartaceo , #di, #vs, #ft, #ctr{
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 50px;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.log-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  background: #ffffff;
  margin: 0.5rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.function-badge {
  background-color: #eff6ff;
  color: #1e40af;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-weight: 600;
  font-family: monospace;
  font-size: 0.9rem;
}

.date-text {
  color: #64748b;
  font-size: 0.875rem;
}

.card-info p {
  margin: 0.25rem 0;
  color: #334155;
  font-size: 0.95rem;
}

.data-comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

/* Quando lo schermo è piccolo, i blocchi vanno uno sotto l'altro */
@media (max-width: 960px) {
  .data-comparison {
    grid-template-columns: 1fr;
  }
}

.data-block {
  background: #f8fafc;
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid #cbd5e1;
}

.prev-block {
  border-left-color: #ef4444; /* Rosso */
}

.next-block {
  border-left-color: #22c55e; /* Verde */
}

.block-title {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.json-viewer {
  margin: 0;
  font-family: monospace;
  font-size: 0.85rem;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #0f172a;
  background: transparent;
  border: none;
}
</style>
